(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4bd3"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4bd3"] = parcelRequire;
}
parcelRequire.register("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRequire.register("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRequire.register("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRequire.register("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRequire.register("1z6jU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.websocketWrapper = void 0;
var $123df65c9b8cbac1$var$websocketWrapper = function(webSocket, start) {
    return new Proxy(webSocket, {
        get: function(obj, key) {
            var val = obj[key];
            if (key === "reconnect") return start;
            if (typeof val === "function") {
                console.error("Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket.");
                //Prevent error thrown by invoking a non-function
                return function() {};
            } else return val;
        },
        set: function(obj, key, val) {
            if (/^on/.test(key)) {
                console.warn("The websocket's event handlers should be defined through the options object passed into useWebSocket.");
                return false;
            } else {
                obj[key] = val;
                return true;
            }
        }
    });
};
module.exports.websocketWrapper = $123df65c9b8cbac1$var$websocketWrapper;
module.exports.default = module.exports.websocketWrapper;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));



var $exYeM = parcelRequire("exYeM");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";
var $97dc602bd7e23afa$exports = {};
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

$97dc602bd7e23afa$exports = (parcelRequire("h8vP0"));


var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $97dc602bd7e23afa$exports.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $97dc602bd7e23afa$exports.hydrateRoot;




var $exYeM = parcelRequire("exYeM");
var $508a5edf05a9a175$exports = {};
"use strict";
Object.defineProperty($508a5edf05a9a175$exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $508a5edf05a9a175$var$__awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
var $508a5edf05a9a175$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $508a5edf05a9a175$var$eventemitter3 = {
    exports: {}
};
(function(module) {
    var has = Object.prototype.hasOwnProperty, prefix = "~";
    /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
    //
    // We try to not inherit from `Object.prototype`. In some engines creating an
    // instance in this way is faster than calling `Object.create(null)` directly.
    // If `Object.create(null)` is not supported we prefix the event names with a
    // character to make sure that the built-in object properties are not
    // overridden or used as an attack vector.
    //
    if (Object.create) {
        Events.prototype = Object.create(null);
        //
        // This hack is needed because the `__proto__` property is still inherited in
        // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
        //
        if (!new Events().__proto__) prefix = false;
    }
    /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
    }
    /**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
        if (typeof fn !== "function") throw new TypeError("The listener must be a function");
        var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
        if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
        else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
        else emitter._events[evt] = [
            emitter._events[evt],
            listener
        ];
        return emitter;
    }
    /**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
        if (--emitter._eventsCount === 0) emitter._events = new Events();
        else delete emitter._events[evt];
    }
    /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
    }
    /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
        var names = [], events, name;
        if (this._eventsCount === 0) return names;
        for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
        if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
        return names;
    };
    /**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
        var evt = prefix ? prefix + event : event, handlers = this._events[evt];
        if (!handlers) return [];
        if (handlers.fn) return [
            handlers.fn
        ];
        for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
        return ee;
    };
    /**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
        var evt = prefix ? prefix + event : event, listeners = this._events[evt];
        if (!listeners) return 0;
        if (listeners.fn) return 1;
        return listeners.length;
    };
    /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return false;
        var listeners = this._events[evt], len = arguments.length, args, i;
        if (listeners.fn) {
            if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
            switch(len){
                case 1:
                    return listeners.fn.call(listeners.context), true;
                case 2:
                    return listeners.fn.call(listeners.context, a1), true;
                case 3:
                    return listeners.fn.call(listeners.context, a1, a2), true;
                case 4:
                    return listeners.fn.call(listeners.context, a1, a2, a3), true;
                case 5:
                    return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                case 6:
                    return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
            }
            for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
            listeners.fn.apply(listeners.context, args);
        } else {
            var length = listeners.length, j;
            for(i = 0; i < length; i++){
                if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                switch(len){
                    case 1:
                        listeners[i].fn.call(listeners[i].context);
                        break;
                    case 2:
                        listeners[i].fn.call(listeners[i].context, a1);
                        break;
                    case 3:
                        listeners[i].fn.call(listeners[i].context, a1, a2);
                        break;
                    case 4:
                        listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                        break;
                    default:
                        if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                        listeners[i].fn.apply(listeners[i].context, args);
                }
            }
        }
        return true;
    };
    /**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
        return addListener(this, event, fn, context, false);
    };
    /**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
        return addListener(this, event, fn, context, true);
    };
    /**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return this;
        if (!fn) {
            clearEvent(this, evt);
            return this;
        }
        var listeners = this._events[evt];
        if (listeners.fn) {
            if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
        } else {
            for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
            //
            // Reset the array, or remove it completely if we have no more listeners.
            //
            if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
            else clearEvent(this, evt);
        }
        return this;
    };
    /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;
        if (event) {
            evt = prefix ? prefix + event : event;
            if (this._events[evt]) clearEvent(this, evt);
        } else {
            this._events = new Events();
            this._eventsCount = 0;
        }
        return this;
    };
    //
    // Alias methods names because people roll like that.
    //
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    //
    // Expose the prefix.
    //
    EventEmitter.prefixed = prefix;
    //
    // Allow `EventEmitter` to be imported as module namespace.
    //
    EventEmitter.EventEmitter = EventEmitter;
    module.exports = EventEmitter;
})($508a5edf05a9a175$var$eventemitter3);
var $508a5edf05a9a175$var$EventEmitter = $508a5edf05a9a175$var$eventemitter3.exports;
var $508a5edf05a9a175$var$lodash_transform = {
    exports: {}
};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function(module, exports1) {
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $508a5edf05a9a175$var$commonjsGlobal == "object" && $508a5edf05a9a175$var$commonjsGlobal && $508a5edf05a9a175$var$commonjsGlobal.Object === Object && $508a5edf05a9a175$var$commonjsGlobal;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports1 && !exports1.nodeType && exports1;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            return freeProcess && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
        var index = -1, length = array ? array.length : 0;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
        var index = -1, length = array ? array.length : 0;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
        // Many host objects are `Object` objects that can coerce to strings
        // despite having improperly defined `toString` methods.
        var result = false;
        if (value != null && typeof value.toString != "function") try {
            result = !!(value + "");
        } catch (e) {}
        return result;
    }
    /**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
    /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
    }();
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
    /** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    /** Built-in value references. */ var Symbol1 = root.Symbol, Uint8Array1 = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
    /* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map1 = getNative(root, "Map"), Promise1 = getNative(root, "Promise"), Set1 = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
    /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map1), promiseCtorString = toSource(Promise1), setCtorString = toSource(Set1), weakMapCtorString = toSource(WeakMap);
    /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
    /**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    /**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
        return this.has(key) && delete this.__data__[key];
    }
    /**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    /**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    /**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
        var data = this.__data__;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
    }
    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
        this.__data__ = [];
    }
    /**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) return false;
        var lastIndex = data.length - 1;
        if (index == lastIndex) data.pop();
        else splice.call(data, index, 1);
        return true;
    }
    /**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    /**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
    }
    /**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) data.push([
            key,
            value
        ]);
        else data[index][1] = value;
        return this;
    }
    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
        this.__data__ = {
            "hash": new Hash,
            "map": new (Map1 || ListCache),
            "string": new Hash
        };
    }
    /**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
        return getMapData(this, key)["delete"](key);
    }
    /**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
        return getMapData(this, key).get(key);
    }
    /**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
        return getMapData(this, key).has(key);
    }
    /**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
        getMapData(this, key).set(key, value);
        return this;
    }
    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
        var index = -1, length = values ? values.length : 0;
        this.__data__ = new MapCache;
        while(++index < length)this.add(values[index]);
    }
    /**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
    }
    /**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
        return this.__data__.has(value);
    }
    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    /**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
        this.__data__ = new ListCache(entries);
    }
    /**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
        this.__data__ = new ListCache;
    }
    /**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
        return this.__data__["delete"](key);
    }
    /**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
        return this.__data__.get(key);
    }
    /**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
        return this.__data__.has(key);
    }
    /**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
        var cache = this.__data__;
        if (cache instanceof ListCache) {
            var pairs = cache.__data__;
            if (!Map1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
                pairs.push([
                    key,
                    value
                ]);
                return this;
            }
            cache = this.__data__ = new MapCache(pairs);
        }
        cache.set(key, value);
        return this;
    }
    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    /**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
        // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
        // Safari 9 makes `arguments.length` enumerable in strict mode.
        var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
        var length = result.length, skipIndexes = !!length;
        for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
        return result;
    }
    /**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
        var length = array.length;
        while(length--){
            if (eq(array[length][0], key)) return length;
        }
        return -1;
    }
    /**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
        return isObject(proto) ? objectCreate(proto) : {};
    }
    /**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
    /**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
    }
    /**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
        path = isKey(path, object) ? [
            path
        ] : castPath(path);
        var index = 0, length = path.length;
        while(object != null && index < length)object = object[toKey(path[index++])];
        return index && index == length ? object : undefined;
    }
    /**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
        return objectToString.call(value);
    }
    /**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
        return object != null && key in Object(object);
    }
    /**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
        if (value === other) return true;
        if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
        return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
    }
    /**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
        var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
        if (!objIsArr) {
            objTag = getTag(object);
            objTag = objTag == argsTag ? objectTag : objTag;
        }
        if (!othIsArr) {
            othTag = getTag(other);
            othTag = othTag == argsTag ? objectTag : othTag;
        }
        var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
        if (isSameTag && !objIsObj) {
            stack || (stack = new Stack);
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
        }
        if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
                var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                stack || (stack = new Stack);
                return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
            }
        }
        if (!isSameTag) return false;
        stack || (stack = new Stack);
        return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
    }
    /**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length, length = index, noCustomizer = !customizer;
        if (object == null) return !length;
        object = Object(object);
        while(index--){
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
        }
        while(++index < length){
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
                if (objValue === undefined && !(key in object)) return false;
            } else {
                var stack = new Stack;
                if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
            }
        }
        return true;
    }
    /**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) return false;
        var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
    }
    /**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
    }
    /**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
        // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
        // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
        if (typeof value == "function") return value;
        if (value == null) return identity;
        if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        return property(value);
    }
    /**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
        if (!isPrototype(object)) return nativeKeys(object);
        var result = [];
        for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
        return result;
    }
    /**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
        };
    }
    /**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
        return function(object) {
            var objValue = get(object, path);
            return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
        };
    }
    /**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
        return function(object) {
            return baseGet(object, path);
        };
    }
    /**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == "string") return value;
        if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    /**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
        return isArray(value) ? value : stringToPath(value);
    }
    /**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
        return function(object, iteratee, keysFunc) {
            var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
            while(length--){
                var key = props[fromRight ? length : ++index];
                if (iteratee(iterable[key], key, iterable) === false) break;
            }
            return object;
        };
    }
    /**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
        var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
        // Assume cyclic values are equal.
        var stacked = stack.get(array);
        if (stacked && stack.get(other)) return stacked == other;
        var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
        stack.set(array, other);
        stack.set(other, array);
        // Ignore non-index properties.
        while(++index < arrLength){
            var arrValue = array[index], othValue = other[index];
            if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            if (compared !== undefined) {
                if (compared) continue;
                result = false;
                break;
            }
            // Recursively compare arrays (susceptible to call stack limits).
            if (seen) {
                if (!arraySome(other, function(othValue, othIndex) {
                    if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
                })) {
                    result = false;
                    break;
                }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
                result = false;
                break;
            }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result;
    }
    /**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
        switch(tag){
            case dataViewTag:
                if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                object = object.buffer;
                other = other.buffer;
            case arrayBufferTag:
                if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array1(object), new Uint8Array1(other))) return false;
                return true;
            case boolTag:
            case dateTag:
            case numberTag:
                // Coerce booleans to `1` or `0` and dates to milliseconds.
                // Invalid dates are coerced to `NaN`.
                return eq(+object, +other);
            case errorTag:
                return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
                // Coerce regexes to strings and treat strings, primitives and objects,
                // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                // for more details.
                return object == other + "";
            case mapTag:
                var convert = mapToArray;
            case setTag:
                var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
                convert || (convert = setToArray);
                if (object.size != other.size && !isPartial) return false;
                // Assume cyclic values are equal.
                var stacked = stack.get(object);
                if (stacked) return stacked == other;
                bitmask |= UNORDERED_COMPARE_FLAG;
                // Recursively compare objects (susceptible to call stack limits).
                stack.set(object, other);
                var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
                stack["delete"](object);
                return result;
            case symbolTag:
                if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
        return false;
    }
    /**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
        var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) return false;
        var index = objLength;
        while(index--){
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked && stack.get(other)) return stacked == other;
        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while(++index < objLength){
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            // Recursively compare objects (susceptible to call stack limits).
            if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
                result = false;
                break;
            }
            skipCtor || (skipCtor = key == "constructor");
        }
        if (result && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            // Non `Object` object instances with different constructors are not equal.
            if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
        }
        stack["delete"](object);
        stack["delete"](other);
        return result;
    }
    /**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    /**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
        var result = keys(object), length = result.length;
        while(length--){
            var key = result[length], value = object[key];
            result[length] = [
                key,
                value,
                isStrictComparable(value)
            ];
        }
        return result;
    }
    /**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
    }
    /**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
    // Fallback for data views, maps, sets, and weak maps in IE 11,
    // for data views in Edge < 14, and promises in Node.js.
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map1 && getTag(new Map1) != mapTag || Promise1 && getTag(Promise1.resolve()) != promiseTag || Set1 && getTag(new Set1) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
        var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
        if (ctorString) switch(ctorString){
            case dataViewCtorString:
                return dataViewTag;
            case mapCtorString:
                return mapTag;
            case promiseCtorString:
                return promiseTag;
            case setCtorString:
                return setTag;
            case weakMapCtorString:
                return weakMapTag;
        }
        return result;
    };
    /**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
        path = isKey(path, object) ? [
            path
        ] : castPath(path);
        var result, index = -1, length = path.length;
        while(++index < length){
            var key = toKey(path[index]);
            if (!(result = object != null && hasFunc(object, key))) break;
            object = object[key];
        }
        if (result) return result;
        var length = object ? object.length : 0;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
    }
    /**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    /**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
        if (isArray(value)) return false;
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    /**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    /**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    /**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
    }
    /**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
        return value === value && !isObject(value);
    }
    /**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
        return function(object) {
            if (object == null) return false;
            return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
        };
    }
    /**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
        string = toString(string);
        var result = [];
        if (reLeadingDot.test(string)) result.push("");
        string.replace(rePropName, function(match, number, quote, string) {
            result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
        });
        return result;
    });
    /**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) return value;
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    /**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
        if (func != null) {
            try {
                return funcToString.call(func);
            } catch (e) {}
            try {
                return func + "";
            } catch (e) {}
        }
        return "";
    }
    /**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
        if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
        var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) return cache.get(key);
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result);
            return result;
        };
        memoized.cache = new (memoize.Cache || MapCache);
        return memoized;
    }
    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;
    /**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
        return value === other || value !== value && other !== other;
    }
    /**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
        // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
        return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
    }
    /**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
    /**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
    }
    /**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 8-9 which returns 'object' for typed array and other constructors.
        var tag = isObject(value) ? objectToString.call(value) : "";
        return tag == funcTag || tag == genTag;
    }
    /**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
        var type = typeof value;
        return !!value && (type == "object" || type == "function");
    }
    /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
        return !!value && typeof value == "object";
    }
    /**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    /**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    /**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
        return value == null ? "" : baseToString(value);
    }
    /**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
        var result = object == null ? undefined : baseGet(object, path);
        return result === undefined ? defaultValue : result;
    }
    /**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
    }
    /**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    /**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function transform(object, iteratee, accumulator) {
        var isArr = isArray(object) || isTypedArray(object);
        iteratee = baseIteratee(iteratee);
        if (accumulator == null) {
            if (isArr || isObject(object)) {
                var Ctor = object.constructor;
                if (isArr) accumulator = isArray(object) ? new Ctor : [];
                else accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else accumulator = {};
        }
        (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
            return iteratee(accumulator, value, index, object);
        });
        return accumulator;
    }
    /**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
        return value;
    }
    /**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }
    module.exports = transform;
})($508a5edf05a9a175$var$lodash_transform, $508a5edf05a9a175$var$lodash_transform.exports);
var $508a5edf05a9a175$var$transform = $508a5edf05a9a175$var$lodash_transform.exports;
var $508a5edf05a9a175$var$BigInteger = {
    exports: {}
};
(function(module) {
    var bigInt = function(undefined$1) {
        var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
        var supportsNativeBigInt = typeof BigInt === "function";
        function Integer(v, radix, alphabet, caseSensitive) {
            if (typeof v === "undefined") return Integer[0];
            if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
            return parseValue(v);
        }
        function BigInteger(value, sign) {
            this.value = value;
            this.sign = sign;
            this.isSmall = false;
        }
        BigInteger.prototype = Object.create(Integer.prototype);
        function SmallInteger(value) {
            this.value = value;
            this.sign = value < 0;
            this.isSmall = true;
        }
        SmallInteger.prototype = Object.create(Integer.prototype);
        function NativeBigInt(value) {
            this.value = value;
        }
        NativeBigInt.prototype = Object.create(Integer.prototype);
        function isPrecise(n) {
            return -MAX_INT < n && n < MAX_INT;
        }
        function smallToArray(n) {
            if (n < 1e7) return [
                n
            ];
            if (n < 1e14) return [
                n % 1e7,
                Math.floor(n / 1e7)
            ];
            return [
                n % 1e7,
                Math.floor(n / 1e7) % 1e7,
                Math.floor(n / 1e14)
            ];
        }
        function arrayToSmall(arr) {
            trim(arr);
            var length = arr.length;
            if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
                case 0:
                    return 0;
                case 1:
                    return arr[0];
                case 2:
                    return arr[0] + arr[1] * BASE;
                default:
                    return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
            }
            return arr;
        }
        function trim(v) {
            var i = v.length;
            while(v[--i] === 0);
            v.length = i + 1;
        }
        function createArray(length) {
            var x = new Array(length);
            var i = -1;
            while(++i < length)x[i] = 0;
            return x;
        }
        function truncate(n) {
            if (n > 0) return Math.floor(n);
            return Math.ceil(n);
        }
        function add(a, b) {
            var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
            for(i = 0; i < l_b; i++){
                sum = a[i] + b[i] + carry;
                carry = sum >= base ? 1 : 0;
                r[i] = sum - carry * base;
            }
            while(i < l_a){
                sum = a[i] + carry;
                carry = sum === base ? 1 : 0;
                r[i++] = sum - carry * base;
            }
            if (carry > 0) r.push(carry);
            return r;
        }
        function addAny(a, b) {
            if (a.length >= b.length) return add(a, b);
            return add(b, a);
        }
        function addSmall(a, carry) {
            var l = a.length, r = new Array(l), base = BASE, sum, i;
            for(i = 0; i < l; i++){
                sum = a[i] - base + carry;
                carry = Math.floor(sum / base);
                r[i] = sum - carry * base;
                carry += 1;
            }
            while(carry > 0){
                r[i++] = carry % base;
                carry = Math.floor(carry / base);
            }
            return r;
        }
        BigInteger.prototype.add = function(v) {
            var n = parseValue(v);
            if (this.sign !== n.sign) return this.subtract(n.negate());
            var a = this.value, b = n.value;
            if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
            return new BigInteger(addAny(a, b), this.sign);
        };
        BigInteger.prototype.plus = BigInteger.prototype.add;
        SmallInteger.prototype.add = function(v) {
            var n = parseValue(v);
            var a = this.value;
            if (a < 0 !== n.sign) return this.subtract(n.negate());
            var b = n.value;
            if (n.isSmall) {
                if (isPrecise(a + b)) return new SmallInteger(a + b);
                b = smallToArray(Math.abs(b));
            }
            return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
        };
        SmallInteger.prototype.plus = SmallInteger.prototype.add;
        NativeBigInt.prototype.add = function(v) {
            return new NativeBigInt(this.value + parseValue(v).value);
        };
        NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
        function subtract(a, b) {
            var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
            for(i = 0; i < b_l; i++){
                difference = a[i] - borrow - b[i];
                if (difference < 0) {
                    difference += base;
                    borrow = 1;
                } else borrow = 0;
                r[i] = difference;
            }
            for(i = b_l; i < a_l; i++){
                difference = a[i] - borrow;
                if (difference < 0) difference += base;
                else {
                    r[i++] = difference;
                    break;
                }
                r[i] = difference;
            }
            for(; i < a_l; i++)r[i] = a[i];
            trim(r);
            return r;
        }
        function subtractAny(a, b, sign) {
            var value;
            if (compareAbs(a, b) >= 0) value = subtract(a, b);
            else {
                value = subtract(b, a);
                sign = !sign;
            }
            value = arrayToSmall(value);
            if (typeof value === "number") {
                if (sign) value = -value;
                return new SmallInteger(value);
            }
            return new BigInteger(value, sign);
        }
        function subtractSmall(a, b, sign) {
            var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
            for(i = 0; i < l; i++){
                difference = a[i] + carry;
                carry = Math.floor(difference / base);
                difference %= base;
                r[i] = difference < 0 ? difference + base : difference;
            }
            r = arrayToSmall(r);
            if (typeof r === "number") {
                if (sign) r = -r;
                return new SmallInteger(r);
            }
            return new BigInteger(r, sign);
        }
        BigInteger.prototype.subtract = function(v) {
            var n = parseValue(v);
            if (this.sign !== n.sign) return this.add(n.negate());
            var a = this.value, b = n.value;
            if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
            return subtractAny(a, b, this.sign);
        };
        BigInteger.prototype.minus = BigInteger.prototype.subtract;
        SmallInteger.prototype.subtract = function(v) {
            var n = parseValue(v);
            var a = this.value;
            if (a < 0 !== n.sign) return this.add(n.negate());
            var b = n.value;
            if (n.isSmall) return new SmallInteger(a - b);
            return subtractSmall(b, Math.abs(a), a >= 0);
        };
        SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
        NativeBigInt.prototype.subtract = function(v) {
            return new NativeBigInt(this.value - parseValue(v).value);
        };
        NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
        BigInteger.prototype.negate = function() {
            return new BigInteger(this.value, !this.sign);
        };
        SmallInteger.prototype.negate = function() {
            var sign = this.sign;
            var small = new SmallInteger(-this.value);
            small.sign = !sign;
            return small;
        };
        NativeBigInt.prototype.negate = function() {
            return new NativeBigInt(-this.value);
        };
        BigInteger.prototype.abs = function() {
            return new BigInteger(this.value, false);
        };
        SmallInteger.prototype.abs = function() {
            return new SmallInteger(Math.abs(this.value));
        };
        NativeBigInt.prototype.abs = function() {
            return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
        };
        function multiplyLong(a, b) {
            var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
            for(i = 0; i < a_l; ++i){
                a_i = a[i];
                for(var j = 0; j < b_l; ++j){
                    b_j = b[j];
                    product = a_i * b_j + r[i + j];
                    carry = Math.floor(product / base);
                    r[i + j] = product - carry * base;
                    r[i + j + 1] += carry;
                }
            }
            trim(r);
            return r;
        }
        function multiplySmall(a, b) {
            var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
            for(i = 0; i < l; i++){
                product = a[i] * b + carry;
                carry = Math.floor(product / base);
                r[i] = product - carry * base;
            }
            while(carry > 0){
                r[i++] = carry % base;
                carry = Math.floor(carry / base);
            }
            return r;
        }
        function shiftLeft(x, n) {
            var r = [];
            while(n-- > 0)r.push(0);
            return r.concat(x);
        }
        function multiplyKaratsuba(x, y) {
            var n = Math.max(x.length, y.length);
            if (n <= 30) return multiplyLong(x, y);
            n = Math.ceil(n / 2);
            var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
            var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
            var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
            trim(product);
            return product;
        }
        // The following function is derived from a surface fit of a graph plotting the performance difference
        // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
        function useKaratsuba(l1, l2) {
            return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
        }
        BigInteger.prototype.multiply = function(v) {
            var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
            if (n.isSmall) {
                if (b === 0) return Integer[0];
                if (b === 1) return this;
                if (b === -1) return this.negate();
                abs = Math.abs(b);
                if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
                b = smallToArray(abs);
            }
            if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
            return new BigInteger(multiplyLong(a, b), sign);
        };
        BigInteger.prototype.times = BigInteger.prototype.multiply;
        function multiplySmallAndArray(a, b, sign) {
            if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
            return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
        }
        SmallInteger.prototype._multiplyBySmall = function(a) {
            if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
            return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
        };
        BigInteger.prototype._multiplyBySmall = function(a) {
            if (a.value === 0) return Integer[0];
            if (a.value === 1) return this;
            if (a.value === -1) return this.negate();
            return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
        };
        SmallInteger.prototype.multiply = function(v) {
            return parseValue(v)._multiplyBySmall(this);
        };
        SmallInteger.prototype.times = SmallInteger.prototype.multiply;
        NativeBigInt.prototype.multiply = function(v) {
            return new NativeBigInt(this.value * parseValue(v).value);
        };
        NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
        function square(a) {
            //console.assert(2 * BASE * BASE < MAX_INT);
            var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
            for(i = 0; i < l; i++){
                a_i = a[i];
                carry = 0 - a_i * a_i;
                for(var j = i; j < l; j++){
                    a_j = a[j];
                    product = 2 * (a_i * a_j) + r[i + j] + carry;
                    carry = Math.floor(product / base);
                    r[i + j] = product - carry * base;
                }
                r[i + l] = carry;
            }
            trim(r);
            return r;
        }
        BigInteger.prototype.square = function() {
            return new BigInteger(square(this.value), false);
        };
        SmallInteger.prototype.square = function() {
            var value = this.value * this.value;
            if (isPrecise(value)) return new SmallInteger(value);
            return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
        };
        NativeBigInt.prototype.square = function(v) {
            return new NativeBigInt(this.value * this.value);
        };
        function divMod1(a, b) {
            var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
            lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
            if (remainder.length <= a_l) remainder.push(0);
            divisor.push(0);
            divisorMostSignificantDigit = divisor[b_l - 1];
            for(shift = a_l - b_l; shift >= 0; shift--){
                quotientDigit = base - 1;
                if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
                // quotientDigit <= base - 1
                carry = 0;
                borrow = 0;
                l = divisor.length;
                for(i = 0; i < l; i++){
                    carry += quotientDigit * divisor[i];
                    q = Math.floor(carry / base);
                    borrow += remainder[shift + i] - (carry - q * base);
                    carry = q;
                    if (borrow < 0) {
                        remainder[shift + i] = borrow + base;
                        borrow = -1;
                    } else {
                        remainder[shift + i] = borrow;
                        borrow = 0;
                    }
                }
                while(borrow !== 0){
                    quotientDigit -= 1;
                    carry = 0;
                    for(i = 0; i < l; i++){
                        carry += remainder[shift + i] - base + divisor[i];
                        if (carry < 0) {
                            remainder[shift + i] = carry + base;
                            carry = 0;
                        } else {
                            remainder[shift + i] = carry;
                            carry = 1;
                        }
                    }
                    borrow += carry;
                }
                result[shift] = quotientDigit;
            }
            // denormalization
            remainder = divModSmall(remainder, lambda)[0];
            return [
                arrayToSmall(result),
                arrayToSmall(remainder)
            ];
        }
        function divMod2(a, b) {
            // Performs faster than divMod1 on larger input sizes.
            var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
            while(a_l){
                part.unshift(a[--a_l]);
                trim(part);
                if (compareAbs(part, b) < 0) {
                    result.push(0);
                    continue;
                }
                xlen = part.length;
                highx = part[xlen - 1] * base + part[xlen - 2];
                highy = b[b_l - 1] * base + b[b_l - 2];
                if (xlen > b_l) highx = (highx + 1) * base;
                guess = Math.ceil(highx / highy);
                do {
                    check = multiplySmall(b, guess);
                    if (compareAbs(check, part) <= 0) break;
                    guess--;
                }while (guess);
                result.push(guess);
                part = subtract(part, check);
            }
            result.reverse();
            return [
                arrayToSmall(result),
                arrayToSmall(part)
            ];
        }
        function divModSmall(value, lambda) {
            var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
            remainder = 0;
            for(i = length - 1; i >= 0; --i){
                divisor = remainder * base + value[i];
                q = truncate(divisor / lambda);
                remainder = divisor - q * lambda;
                quotient[i] = q | 0;
            }
            return [
                quotient,
                remainder | 0
            ];
        }
        function divModAny(self1, v) {
            var value, n = parseValue(v);
            if (supportsNativeBigInt) return [
                new NativeBigInt(self1.value / n.value),
                new NativeBigInt(self1.value % n.value)
            ];
            var a = self1.value, b = n.value;
            var quotient;
            if (b === 0) throw new Error("Cannot divide by zero");
            if (self1.isSmall) {
                if (n.isSmall) return [
                    new SmallInteger(truncate(a / b)),
                    new SmallInteger(a % b)
                ];
                return [
                    Integer[0],
                    self1
                ];
            }
            if (n.isSmall) {
                if (b === 1) return [
                    self1,
                    Integer[0]
                ];
                if (b == -1) return [
                    self1.negate(),
                    Integer[0]
                ];
                var abs = Math.abs(b);
                if (abs < BASE) {
                    value = divModSmall(a, abs);
                    quotient = arrayToSmall(value[0]);
                    var remainder = value[1];
                    if (self1.sign) remainder = -remainder;
                    if (typeof quotient === "number") {
                        if (self1.sign !== n.sign) quotient = -quotient;
                        return [
                            new SmallInteger(quotient),
                            new SmallInteger(remainder)
                        ];
                    }
                    return [
                        new BigInteger(quotient, self1.sign !== n.sign),
                        new SmallInteger(remainder)
                    ];
                }
                b = smallToArray(abs);
            }
            var comparison = compareAbs(a, b);
            if (comparison === -1) return [
                Integer[0],
                self1
            ];
            if (comparison === 0) return [
                Integer[self1.sign === n.sign ? 1 : -1],
                Integer[0]
            ];
            // divMod1 is faster on smaller input sizes
            if (a.length + b.length <= 200) value = divMod1(a, b);
            else value = divMod2(a, b);
            quotient = value[0];
            var qSign = self1.sign !== n.sign, mod = value[1], mSign = self1.sign;
            if (typeof quotient === "number") {
                if (qSign) quotient = -quotient;
                quotient = new SmallInteger(quotient);
            } else quotient = new BigInteger(quotient, qSign);
            if (typeof mod === "number") {
                if (mSign) mod = -mod;
                mod = new SmallInteger(mod);
            } else mod = new BigInteger(mod, mSign);
            return [
                quotient,
                mod
            ];
        }
        BigInteger.prototype.divmod = function(v) {
            var result = divModAny(this, v);
            return {
                quotient: result[0],
                remainder: result[1]
            };
        };
        NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
        BigInteger.prototype.divide = function(v) {
            return divModAny(this, v)[0];
        };
        NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
            return new NativeBigInt(this.value / parseValue(v).value);
        };
        SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
        BigInteger.prototype.mod = function(v) {
            return divModAny(this, v)[1];
        };
        NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
            return new NativeBigInt(this.value % parseValue(v).value);
        };
        SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
        BigInteger.prototype.pow = function(v) {
            var n = parseValue(v), a = this.value, b = n.value, value, x, y;
            if (b === 0) return Integer[1];
            if (a === 0) return Integer[0];
            if (a === 1) return Integer[1];
            if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
            if (n.sign) return Integer[0];
            if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
            if (this.isSmall) {
                if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
            }
            x = this;
            y = Integer[1];
            while(true){
                if (b & true) {
                    y = y.times(x);
                    --b;
                }
                if (b === 0) break;
                b /= 2;
                x = x.square();
            }
            return y;
        };
        SmallInteger.prototype.pow = BigInteger.prototype.pow;
        NativeBigInt.prototype.pow = function(v) {
            var n = parseValue(v);
            var a = this.value, b = n.value;
            var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
            if (b === _0) return Integer[1];
            if (a === _0) return Integer[0];
            if (a === _1) return Integer[1];
            if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
            if (n.isNegative()) return new NativeBigInt(_0);
            var x = this;
            var y = Integer[1];
            while(true){
                if ((b & _1) === _1) {
                    y = y.times(x);
                    --b;
                }
                if (b === _0) break;
                b /= _2;
                x = x.square();
            }
            return y;
        };
        BigInteger.prototype.modPow = function(exp, mod) {
            exp = parseValue(exp);
            mod = parseValue(mod);
            if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
            var r = Integer[1], base = this.mod(mod);
            if (exp.isNegative()) {
                exp = exp.multiply(Integer[-1]);
                base = base.modInv(mod);
            }
            while(exp.isPositive()){
                if (base.isZero()) return Integer[0];
                if (exp.isOdd()) r = r.multiply(base).mod(mod);
                exp = exp.divide(2);
                base = base.square().mod(mod);
            }
            return r;
        };
        NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
        function compareAbs(a, b) {
            if (a.length !== b.length) return a.length > b.length ? 1 : -1;
            for(var i = a.length - 1; i >= 0; i--){
                if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
            }
            return 0;
        }
        BigInteger.prototype.compareAbs = function(v) {
            var n = parseValue(v), a = this.value, b = n.value;
            if (n.isSmall) return 1;
            return compareAbs(a, b);
        };
        SmallInteger.prototype.compareAbs = function(v) {
            var n = parseValue(v), a = Math.abs(this.value), b = n.value;
            if (n.isSmall) {
                b = Math.abs(b);
                return a === b ? 0 : a > b ? 1 : -1;
            }
            return -1;
        };
        NativeBigInt.prototype.compareAbs = function(v) {
            var a = this.value;
            var b = parseValue(v).value;
            a = a >= 0 ? a : -a;
            b = b >= 0 ? b : -b;
            return a === b ? 0 : a > b ? 1 : -1;
        };
        BigInteger.prototype.compare = function(v) {
            // See discussion about comparison with Infinity:
            // https://github.com/peterolson/BigInteger.js/issues/61
            if (v === Infinity) return -1;
            if (v === -Infinity) return 1;
            var n = parseValue(v), a = this.value, b = n.value;
            if (this.sign !== n.sign) return n.sign ? 1 : -1;
            if (n.isSmall) return this.sign ? -1 : 1;
            return compareAbs(a, b) * (this.sign ? -1 : 1);
        };
        BigInteger.prototype.compareTo = BigInteger.prototype.compare;
        SmallInteger.prototype.compare = function(v) {
            if (v === Infinity) return -1;
            if (v === -Infinity) return 1;
            var n = parseValue(v), a = this.value, b = n.value;
            if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
            if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
            return a < 0 ? 1 : -1;
        };
        SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
        NativeBigInt.prototype.compare = function(v) {
            if (v === Infinity) return -1;
            if (v === -Infinity) return 1;
            var a = this.value;
            var b = parseValue(v).value;
            return a === b ? 0 : a > b ? 1 : -1;
        };
        NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
        BigInteger.prototype.equals = function(v) {
            return this.compare(v) === 0;
        };
        NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
        BigInteger.prototype.notEquals = function(v) {
            return this.compare(v) !== 0;
        };
        NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
        BigInteger.prototype.greater = function(v) {
            return this.compare(v) > 0;
        };
        NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
        BigInteger.prototype.lesser = function(v) {
            return this.compare(v) < 0;
        };
        NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
        BigInteger.prototype.greaterOrEquals = function(v) {
            return this.compare(v) >= 0;
        };
        NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
        BigInteger.prototype.lesserOrEquals = function(v) {
            return this.compare(v) <= 0;
        };
        NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
        BigInteger.prototype.isEven = function() {
            return (this.value[0] & 1) === 0;
        };
        SmallInteger.prototype.isEven = function() {
            return (this.value & 1) === 0;
        };
        NativeBigInt.prototype.isEven = function() {
            return (this.value & BigInt(1)) === BigInt(0);
        };
        BigInteger.prototype.isOdd = function() {
            return (this.value[0] & 1) === 1;
        };
        SmallInteger.prototype.isOdd = function() {
            return (this.value & 1) === 1;
        };
        NativeBigInt.prototype.isOdd = function() {
            return (this.value & BigInt(1)) === BigInt(1);
        };
        BigInteger.prototype.isPositive = function() {
            return !this.sign;
        };
        SmallInteger.prototype.isPositive = function() {
            return this.value > 0;
        };
        NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
        BigInteger.prototype.isNegative = function() {
            return this.sign;
        };
        SmallInteger.prototype.isNegative = function() {
            return this.value < 0;
        };
        NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
        BigInteger.prototype.isUnit = function() {
            return false;
        };
        SmallInteger.prototype.isUnit = function() {
            return Math.abs(this.value) === 1;
        };
        NativeBigInt.prototype.isUnit = function() {
            return this.abs().value === BigInt(1);
        };
        BigInteger.prototype.isZero = function() {
            return false;
        };
        SmallInteger.prototype.isZero = function() {
            return this.value === 0;
        };
        NativeBigInt.prototype.isZero = function() {
            return this.value === BigInt(0);
        };
        BigInteger.prototype.isDivisibleBy = function(v) {
            var n = parseValue(v);
            if (n.isZero()) return false;
            if (n.isUnit()) return true;
            if (n.compareAbs(2) === 0) return this.isEven();
            return this.mod(n).isZero();
        };
        NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
        function isBasicPrime(v) {
            var n = v.abs();
            if (n.isUnit()) return false;
            if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
            if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
            if (n.lesser(49)) return true;
        // we don't know if it's prime: let the other functions figure it out
        }
        function millerRabinTest(n, a) {
            var nPrev = n.prev(), b = nPrev, r = 0, d, i, x;
            while(b.isEven())b = b.divide(2), r++;
            next: for(i = 0; i < a.length; i++){
                if (n.lesser(a[i])) continue;
                x = bigInt(a[i]).modPow(b, n);
                if (x.isUnit() || x.equals(nPrev)) continue;
                for(d = r - 1; d != 0; d--){
                    x = x.square().mod(n);
                    if (x.isUnit()) return false;
                    if (x.equals(nPrev)) continue next;
                }
                return false;
            }
            return true;
        }
        // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
        BigInteger.prototype.isPrime = function(strict) {
            var isPrime = isBasicPrime(this);
            if (isPrime !== undefined$1) return isPrime;
            var n = this.abs();
            var bits = n.bitLength();
            if (bits <= 64) return millerRabinTest(n, [
                2,
                3,
                5,
                7,
                11,
                13,
                17,
                19,
                23,
                29,
                31,
                37
            ]);
            var logN = Math.log(2) * bits.toJSNumber();
            var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
            for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
            return millerRabinTest(n, a);
        };
        NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
        BigInteger.prototype.isProbablePrime = function(iterations, rng) {
            var isPrime = isBasicPrime(this);
            if (isPrime !== undefined$1) return isPrime;
            var n = this.abs();
            var t = iterations === undefined$1 ? 5 : iterations;
            for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
            return millerRabinTest(n, a);
        };
        NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
        BigInteger.prototype.modInv = function(n) {
            var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
            while(!newR.isZero()){
                q = r.divide(newR);
                lastT = t;
                lastR = r;
                t = newT;
                r = newR;
                newT = lastT.subtract(q.multiply(newT));
                newR = lastR.subtract(q.multiply(newR));
            }
            if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
            if (t.compare(0) === -1) t = t.add(n);
            if (this.isNegative()) return t.negate();
            return t;
        };
        NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
        BigInteger.prototype.next = function() {
            var value = this.value;
            if (this.sign) return subtractSmall(value, 1, this.sign);
            return new BigInteger(addSmall(value, 1), this.sign);
        };
        SmallInteger.prototype.next = function() {
            var value = this.value;
            if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
            return new BigInteger(MAX_INT_ARR, false);
        };
        NativeBigInt.prototype.next = function() {
            return new NativeBigInt(this.value + BigInt(1));
        };
        BigInteger.prototype.prev = function() {
            var value = this.value;
            if (this.sign) return new BigInteger(addSmall(value, 1), true);
            return subtractSmall(value, 1, this.sign);
        };
        SmallInteger.prototype.prev = function() {
            var value = this.value;
            if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
            return new BigInteger(MAX_INT_ARR, true);
        };
        NativeBigInt.prototype.prev = function() {
            return new NativeBigInt(this.value - BigInt(1));
        };
        var powersOfTwo = [
            1
        ];
        while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
        var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
        function shift_isSmall(n) {
            return Math.abs(n) <= BASE;
        }
        BigInteger.prototype.shiftLeft = function(v) {
            var n = parseValue(v).toJSNumber();
            if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
            if (n < 0) return this.shiftRight(-n);
            var result = this;
            if (result.isZero()) return result;
            while(n >= powers2Length){
                result = result.multiply(highestPower2);
                n -= powers2Length - 1;
            }
            return result.multiply(powersOfTwo[n]);
        };
        NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
        BigInteger.prototype.shiftRight = function(v) {
            var remQuo;
            var n = parseValue(v).toJSNumber();
            if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
            if (n < 0) return this.shiftLeft(-n);
            var result = this;
            while(n >= powers2Length){
                if (result.isZero() || result.isNegative() && result.isUnit()) return result;
                remQuo = divModAny(result, highestPower2);
                result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
                n -= powers2Length - 1;
            }
            remQuo = divModAny(result, powersOfTwo[n]);
            return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
        };
        NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
        function bitwise(x, y, fn) {
            y = parseValue(y);
            var xSign = x.isNegative(), ySign = y.isNegative();
            var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
            var xDigit = 0, yDigit = 0;
            var xDivMod = null, yDivMod = null;
            var result = [];
            while(!xRem.isZero() || !yRem.isZero()){
                xDivMod = divModAny(xRem, highestPower2);
                xDigit = xDivMod[1].toJSNumber();
                if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
                yDivMod = divModAny(yRem, highestPower2);
                yDigit = yDivMod[1].toJSNumber();
                if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
                xRem = xDivMod[0];
                yRem = yDivMod[0];
                result.push(fn(xDigit, yDigit));
            }
            var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
            for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
            return sum;
        }
        BigInteger.prototype.not = function() {
            return this.negate().prev();
        };
        NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
        BigInteger.prototype.and = function(n) {
            return bitwise(this, n, function(a, b) {
                return a & b;
            });
        };
        NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
        BigInteger.prototype.or = function(n) {
            return bitwise(this, n, function(a, b) {
                return a | b;
            });
        };
        NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
        BigInteger.prototype.xor = function(n) {
            return bitwise(this, n, function(a, b) {
                return a ^ b;
            });
        };
        NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
        var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
        function roughLOB(n) {
            // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
            // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
            var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
            return x & -x;
        }
        function integerLogarithm(value, base) {
            if (base.compareTo(value) <= 0) {
                var tmp = integerLogarithm(value, base.square(base));
                var p = tmp.p;
                var e = tmp.e;
                var t = p.multiply(base);
                return t.compareTo(value) <= 0 ? {
                    p: t,
                    e: e * 2 + 1
                } : {
                    p: p,
                    e: e * 2
                };
            }
            return {
                p: bigInt(1),
                e: 0
            };
        }
        BigInteger.prototype.bitLength = function() {
            var n = this;
            if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
            if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
            return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
        };
        NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
        function max(a, b) {
            a = parseValue(a);
            b = parseValue(b);
            return a.greater(b) ? a : b;
        }
        function min(a, b) {
            a = parseValue(a);
            b = parseValue(b);
            return a.lesser(b) ? a : b;
        }
        function gcd(a, b) {
            a = parseValue(a).abs();
            b = parseValue(b).abs();
            if (a.equals(b)) return a;
            if (a.isZero()) return b;
            if (b.isZero()) return a;
            var c = Integer[1], d, t;
            while(a.isEven() && b.isEven()){
                d = min(roughLOB(a), roughLOB(b));
                a = a.divide(d);
                b = b.divide(d);
                c = c.multiply(d);
            }
            while(a.isEven())a = a.divide(roughLOB(a));
            do {
                while(b.isEven())b = b.divide(roughLOB(b));
                if (a.greater(b)) {
                    t = b;
                    b = a;
                    a = t;
                }
                b = b.subtract(a);
            }while (!b.isZero());
            return c.isUnit() ? a : a.multiply(c);
        }
        function lcm(a, b) {
            a = parseValue(a).abs();
            b = parseValue(b).abs();
            return a.divide(gcd(a, b)).multiply(b);
        }
        function randBetween(a, b, rng) {
            a = parseValue(a);
            b = parseValue(b);
            var usedRNG = rng || Math.random;
            var low = min(a, b), high = max(a, b);
            var range = high.subtract(low).add(1);
            if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
            var digits = toBase(range, BASE).value;
            var result = [], restricted = true;
            for(var i = 0; i < digits.length; i++){
                var top = restricted ? digits[i] : BASE;
                var digit = truncate(usedRNG() * top);
                result.push(digit);
                if (digit < top) restricted = false;
            }
            return low.add(Integer.fromArray(result, BASE, false));
        }
        var parseBase = function(text, base, alphabet, caseSensitive) {
            alphabet = alphabet || DEFAULT_ALPHABET;
            text = String(text);
            if (!caseSensitive) {
                text = text.toLowerCase();
                alphabet = alphabet.toLowerCase();
            }
            var length = text.length;
            var i;
            var absBase = Math.abs(base);
            var alphabetValues = {};
            for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
            for(i = 0; i < length; i++){
                var c = text[i];
                if (c === "-") continue;
                if (c in alphabetValues) {
                    if (alphabetValues[c] >= absBase) {
                        if (c === "1" && absBase === 1) continue;
                        throw new Error(c + " is not a valid digit in base " + base + ".");
                    }
                }
            }
            base = parseValue(base);
            var digits = [];
            var isNegative = text[0] === "-";
            for(i = isNegative ? 1 : 0; i < text.length; i++){
                var c = text[i];
                if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
                else if (c === "<") {
                    var start = i;
                    do i++;
                    while (text[i] !== ">" && i < text.length);
                    digits.push(parseValue(text.slice(start + 1, i)));
                } else throw new Error(c + " is not a valid character");
            }
            return parseBaseFromArray(digits, base, isNegative);
        };
        function parseBaseFromArray(digits, base, isNegative) {
            var val = Integer[0], pow = Integer[1], i;
            for(i = digits.length - 1; i >= 0; i--){
                val = val.add(digits[i].times(pow));
                pow = pow.times(base);
            }
            return isNegative ? val.negate() : val;
        }
        function stringify(digit, alphabet) {
            alphabet = alphabet || DEFAULT_ALPHABET;
            if (digit < alphabet.length) return alphabet[digit];
            return "<" + digit + ">";
        }
        function toBase(n, base) {
            base = bigInt(base);
            if (base.isZero()) {
                if (n.isZero()) return {
                    value: [
                        0
                    ],
                    isNegative: false
                };
                throw new Error("Cannot convert nonzero numbers to base 0.");
            }
            if (base.equals(-1)) {
                if (n.isZero()) return {
                    value: [
                        0
                    ],
                    isNegative: false
                };
                if (n.isNegative()) return {
                    value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                        1,
                        0
                    ])),
                    isNegative: false
                };
                var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                    0,
                    1
                ]);
                arr.unshift([
                    1
                ]);
                return {
                    value: [].concat.apply([], arr),
                    isNegative: false
                };
            }
            var neg = false;
            if (n.isNegative() && base.isPositive()) {
                neg = true;
                n = n.abs();
            }
            if (base.isUnit()) {
                if (n.isZero()) return {
                    value: [
                        0
                    ],
                    isNegative: false
                };
                return {
                    value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                    isNegative: neg
                };
            }
            var out = [];
            var left = n, divmod;
            while(left.isNegative() || left.compareAbs(base) >= 0){
                divmod = left.divmod(base);
                left = divmod.quotient;
                var digit = divmod.remainder;
                if (digit.isNegative()) {
                    digit = base.minus(digit).abs();
                    left = left.next();
                }
                out.push(digit.toJSNumber());
            }
            out.push(left.toJSNumber());
            return {
                value: out.reverse(),
                isNegative: neg
            };
        }
        function toBaseString(n, base, alphabet) {
            var arr = toBase(n, base);
            return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
                return stringify(x, alphabet);
            }).join("");
        }
        BigInteger.prototype.toArray = function(radix) {
            return toBase(this, radix);
        };
        SmallInteger.prototype.toArray = function(radix) {
            return toBase(this, radix);
        };
        NativeBigInt.prototype.toArray = function(radix) {
            return toBase(this, radix);
        };
        BigInteger.prototype.toString = function(radix, alphabet) {
            if (radix === undefined$1) radix = 10;
            if (radix !== 10) return toBaseString(this, radix, alphabet);
            var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
            while(--l >= 0){
                digit = String(v[l]);
                str += zeros.slice(digit.length) + digit;
            }
            var sign = this.sign ? "-" : "";
            return sign + str;
        };
        SmallInteger.prototype.toString = function(radix, alphabet) {
            if (radix === undefined$1) radix = 10;
            if (radix != 10) return toBaseString(this, radix, alphabet);
            return String(this.value);
        };
        NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
        NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
            return this.toString();
        };
        BigInteger.prototype.valueOf = function() {
            return parseInt(this.toString(), 10);
        };
        BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
        SmallInteger.prototype.valueOf = function() {
            return this.value;
        };
        SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
        NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
            return parseInt(this.toString(), 10);
        };
        function parseStringValue(v) {
            if (isPrecise(+v)) {
                var x = +v;
                if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
                throw new Error("Invalid integer: " + v);
            }
            var sign = v[0] === "-";
            if (sign) v = v.slice(1);
            var split = v.split(/e/i);
            if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
            if (split.length === 2) {
                var exp = split[1];
                if (exp[0] === "+") exp = exp.slice(1);
                exp = +exp;
                if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
                var text = split[0];
                var decimalPlace = text.indexOf(".");
                if (decimalPlace >= 0) {
                    exp -= text.length - decimalPlace - 1;
                    text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
                }
                if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
                text += new Array(exp + 1).join("0");
                v = text;
            }
            var isValid = /^([0-9][0-9]*)$/.test(v);
            if (!isValid) throw new Error("Invalid integer: " + v);
            if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
            var r = [], max = v.length, l = LOG_BASE, min = max - l;
            while(max > 0){
                r.push(+v.slice(min, max));
                min -= l;
                if (min < 0) min = 0;
                max -= l;
            }
            trim(r);
            return new BigInteger(r, sign);
        }
        function parseNumberValue(v) {
            if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
            if (isPrecise(v)) {
                if (v !== truncate(v)) throw new Error(v + " is not an integer.");
                return new SmallInteger(v);
            }
            return parseStringValue(v.toString());
        }
        function parseValue(v) {
            if (typeof v === "number") return parseNumberValue(v);
            if (typeof v === "string") return parseStringValue(v);
            if (typeof v === "bigint") return new NativeBigInt(v);
            return v;
        }
        // Pre-define numbers in range [-999,999]
        for(var i = 0; i < 1000; i++){
            Integer[i] = parseValue(i);
            if (i > 0) Integer[-i] = parseValue(-i);
        }
        // Backwards compatibility
        Integer.one = Integer[1];
        Integer.zero = Integer[0];
        Integer.minusOne = Integer[-1];
        Integer.max = max;
        Integer.min = min;
        Integer.gcd = gcd;
        Integer.lcm = lcm;
        Integer.isInstance = function(x) {
            return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
        };
        Integer.randBetween = randBetween;
        Integer.fromArray = function(digits, base, isNegative) {
            return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
        };
        return Integer;
    }();
    // Node.js check
    if (module.hasOwnProperty("exports")) module.exports = bigInt;
})($508a5edf05a9a175$var$BigInteger);
var $508a5edf05a9a175$var$bigInt = $508a5edf05a9a175$var$BigInteger.exports;
var $508a5edf05a9a175$var$extendStatics = function(e, t) {
    return ($508a5edf05a9a175$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, t) {
        e.__proto__ = t;
    } || function(e, t) {
        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    })(e, t);
};
function $508a5edf05a9a175$var$__extends(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    function r() {
        this.constructor = e;
    }
    $508a5edf05a9a175$var$extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
}
var $508a5edf05a9a175$var$util, $508a5edf05a9a175$var$__assign = function() {
    return ($508a5edf05a9a175$var$__assign = Object.assign || function(e) {
        for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }).apply(this, arguments);
};
function $508a5edf05a9a175$var$__awaiter(e, i, s, u) {
    return new (s = s || Promise)(function(r, t) {
        function n(e) {
            try {
                a(u.next(e));
            } catch (e) {
                t(e);
            }
        }
        function o(e) {
            try {
                a(u.throw(e));
            } catch (e) {
                t(e);
            }
        }
        function a(e) {
            var t;
            e.done ? r(e.value) : ((t = e.value) instanceof s ? t : new s(function(e) {
                e(t);
            })).then(n, o);
        }
        a((u = u.apply(e, i || [])).next());
    });
}
function $508a5edf05a9a175$var$__generator(r, n) {
    var o, a, i, s = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    }, e = {
        next: t(0),
        throw: t(1),
        return: t(2)
    };
    return "function" == typeof Symbol && (e[Symbol.iterator] = function() {
        return this;
    }), e;
    function t(t) {
        return function(e) {
            return function(t) {
                if (o) throw new TypeError("Generator is already executing.");
                for(; s;)try {
                    if (o = 1, a && (i = 2 & t[0] ? a.return : t[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, t[1])).done) return i;
                    switch(a = 0, (t = i ? [
                        2 & t[0],
                        i.value
                    ] : t)[0]){
                        case 0:
                        case 1:
                            i = t;
                            break;
                        case 4:
                            return s.label++, {
                                value: t[1],
                                done: !1
                            };
                        case 5:
                            s.label++, a = t[1], t = [
                                0
                            ];
                            continue;
                        case 7:
                            t = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = 0 < (i = s.trys).length && i[i.length - 1]) && (6 === t[0] || 2 === t[0])) {
                                s = 0;
                                continue;
                            }
                            if (3 === t[0] && (!i || t[1] > i[0] && t[1] < i[3])) {
                                s.label = t[1];
                                break;
                            }
                            if (6 === t[0] && s.label < i[1]) {
                                s.label = i[1], i = t;
                                break;
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(t);
                                break;
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue;
                    }
                    t = n.call(r, s);
                } catch (e) {
                    t = [
                        6,
                        e
                    ], a = 0;
                } finally{
                    o = i = 0;
                }
                if (5 & t[0]) throw t[1];
                return {
                    value: t[0] ? t[1] : void 0,
                    done: !0
                };
            }([
                t,
                e
            ]);
        };
    }
}
function $508a5edf05a9a175$var$__values(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
    if (r) return r.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return {
                value: (e = e && n >= e.length ? void 0 : e) && e[n++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $508a5edf05a9a175$var$__read(e, t) {
    var r = "function" == typeof Symbol && e[Symbol.iterator];
    if (!r) return e;
    var n, o, a = r.call(e), i = [];
    try {
        for(; (void 0 === t || 0 < t--) && !(n = a.next()).done;)i.push(n.value);
    } catch (e) {
        o = {
            error: e
        };
    } finally{
        try {
            n && !n.done && (r = a.return) && r.call(a);
        } finally{
            if (o) throw o.error;
        }
    }
    return i;
}
function $508a5edf05a9a175$var$__spreadArray(e, t) {
    for(var r = 0, n = t.length, o = e.length; r < n; r++, o++)e[o] = t[r];
    return e;
}
!function(u) {
    u.assertNever = function(e) {
        throw new Error;
    }, u.arrayToEnum = function(e) {
        var t, r, n = {};
        try {
            for(var o = $508a5edf05a9a175$var$__values(e), a = o.next(); !a.done; a = o.next()){
                var i = a.value;
                n[i] = i;
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (r = o.return) && r.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return n;
    }, u.getValidEnumValues = function(t) {
        var r, e, n = u.objectKeys(t).filter(function(e) {
            return "number" != typeof t[t[e]];
        }), o = {};
        try {
            for(var a = $508a5edf05a9a175$var$__values(n), i = a.next(); !i.done; i = a.next()){
                var s = i.value;
                o[s] = t[s];
            }
        } catch (e) {
            r = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = a.return) && e.call(a);
            } finally{
                if (r) throw r.error;
            }
        }
        return u.objectValues(o);
    }, u.objectValues = function(t) {
        return u.objectKeys(t).map(function(e) {
            return t[e];
        });
    }, u.objectKeys = "function" == typeof Object.keys ? function(e) {
        return Object.keys(e);
    } : function(e) {
        var t, r = [];
        for(t in e)Object.prototype.hasOwnProperty.call(e, t) && r.push(t);
        return r;
    }, u.find = function(e, t) {
        var r, n;
        try {
            for(var o = $508a5edf05a9a175$var$__values(e), a = o.next(); !a.done; a = o.next()){
                var i = a.value;
                if (t(i)) return i;
            }
        } catch (e) {
            r = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (n = o.return) && n.call(o);
            } finally{
                if (r) throw r.error;
            }
        }
    }, u.isInteger = "function" == typeof Number.isInteger ? function(e) {
        return Number.isInteger(e);
    } : function(e) {
        return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
    };
}($508a5edf05a9a175$var$util = $508a5edf05a9a175$var$util || {});
var $508a5edf05a9a175$var$errorUtil, $508a5edf05a9a175$var$ZodIssueCode = $508a5edf05a9a175$var$util.arrayToEnum([
    "invalid_type",
    "custom",
    "invalid_union",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of"
]), $508a5edf05a9a175$var$quotelessJson = function(e) {
    return JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
}, $508a5edf05a9a175$var$ZodError = function(r) {
    function t(e) {
        var t = this.constructor, u = r.call(this) || this;
        u.issues = [], u.format = function() {
            var c = {
                _errors: []
            }, p = function(e) {
                var t, r;
                try {
                    for(var n = $508a5edf05a9a175$var$__values(e.issues), o = n.next(); !o.done; o = n.next()){
                        var a = o.value;
                        if ("invalid_union" === a.code) a.unionErrors.map(p);
                        else if ("invalid_return_type" === a.code) p(a.returnTypeError);
                        else if ("invalid_arguments" === a.code) p(a.argumentsError);
                        else if (0 === a.path.length) c._errors.push(a.message);
                        else for(var i = c, s = 0; s < a.path.length;){
                            var u, d = a.path[s];
                            s === a.path.length - 1 ? (i[d] = i[d] || {
                                _errors: []
                            }, i[d]._errors.push(a.message)) : "string" == typeof d ? i[d] = i[d] || {
                                _errors: []
                            } : "number" == typeof d && ((u = [])._errors = [], i[d] = i[d] || u), i = i[d], s++;
                        }
                    }
                } catch (e) {
                    t = {
                        error: e
                    };
                } finally{
                    try {
                        o && !o.done && (r = n.return) && r.call(n);
                    } finally{
                        if (t) throw t.error;
                    }
                }
            };
            return p(u), c;
        }, u.addIssue = function(e) {
            u.issues = $508a5edf05a9a175$var$__spreadArray($508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(u.issues), !1), [
                e
            ]);
        }, u.addIssues = function(e) {
            void 0 === e && (e = []), u.issues = $508a5edf05a9a175$var$__spreadArray($508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(u.issues), !1), $508a5edf05a9a175$var$__read(e));
        }, u.flatten = function(e) {
            var t, r;
            void 0 === e && (e = function(e) {
                return e.message;
            });
            var n = {}, o = [];
            try {
                for(var a = $508a5edf05a9a175$var$__values(u.issues), i = a.next(); !i.done; i = a.next()){
                    var s = i.value;
                    0 < s.path.length ? (n[s.path[0]] = n[s.path[0]] || [], n[s.path[0]].push(e(s))) : o.push(e(s));
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    i && !i.done && (r = a.return) && r.call(a);
                } finally{
                    if (t) throw t.error;
                }
            }
            return {
                formErrors: o,
                fieldErrors: n
            };
        };
        t = t.prototype;
        return Object.setPrototypeOf ? Object.setPrototypeOf(u, t) : u.__proto__ = t, u.name = "ZodError", u.issues = e, u;
    }
    return $508a5edf05a9a175$var$__extends(t, r), Object.defineProperty(t.prototype, "errors", {
        get: function() {
            return this.issues;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.toString = function() {
        return this.message;
    }, Object.defineProperty(t.prototype, "message", {
        get: function() {
            return JSON.stringify(this.issues, null, 2);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isEmpty", {
        get: function() {
            return 0 === this.issues.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "formErrors", {
        get: function() {
            return this.flatten();
        },
        enumerable: !1,
        configurable: !0
    }), t.create = function(e) {
        return new t(e);
    }, t;
}(Error), $508a5edf05a9a175$var$defaultErrorMap = function(e, t) {
    var r;
    switch(e.code){
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_type:
            r = "undefined" === e.received ? "Required" : "Expected " + e.expected + ", received " + e.received;
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.unrecognized_keys:
            r = "Unrecognized key(s) in object: " + e.keys.map(function(e) {
                return "'" + e + "'";
            }).join(", ");
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_union:
            r = "Invalid input";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_enum_value:
            r = "Invalid enum value. Expected " + e.options.map(function(e) {
                return "string" == typeof e ? "'" + e + "'" : e;
            }).join(" | ") + ", received " + ("string" == typeof t.data ? "'" + t.data + "'" : t.data);
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_arguments:
            r = "Invalid function arguments";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_return_type:
            r = "Invalid function return type";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_date:
            r = "Invalid date";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_string:
            r = "regex" !== e.validation ? "Invalid " + e.validation : "Invalid";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.too_small:
            r = "array" === e.type ? "Should have " + (e.inclusive ? "at least" : "more than") + " " + e.minimum + " items" : "string" === e.type ? "Should be " + (e.inclusive ? "at least" : "over") + " " + e.minimum + " characters" : "number" === e.type ? "Value should be greater than " + (e.inclusive ? "or equal to " : "") + e.minimum : "Invalid input";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.too_big:
            r = "array" === e.type ? "Should have " + (e.inclusive ? "at most" : "less than") + " " + e.maximum + " items" : "string" === e.type ? "Should be " + (e.inclusive ? "at most" : "under") + " " + e.maximum + " characters long" : "number" === e.type ? "Value should be less than " + (e.inclusive ? "or equal to " : "") + e.maximum : "Invalid input";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.custom:
            r = "Invalid input";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.invalid_intersection_types:
            r = "Intersection results could not be merged";
            break;
        case $508a5edf05a9a175$var$ZodIssueCode.not_multiple_of:
            r = "Should be multiple of " + e.multipleOf;
            break;
        default:
            r = t.defaultError, $508a5edf05a9a175$var$util.assertNever(e);
    }
    return {
        message: r
    };
}, $508a5edf05a9a175$var$overrideErrorMap = $508a5edf05a9a175$var$defaultErrorMap, $508a5edf05a9a175$var$setErrorMap = function(e) {
    $508a5edf05a9a175$var$overrideErrorMap = e;
}, $508a5edf05a9a175$var$ZodParsedType = $508a5edf05a9a175$var$util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]), $508a5edf05a9a175$var$getParsedType = function(e) {
    switch(typeof e){
        case "undefined":
            return $508a5edf05a9a175$var$ZodParsedType.undefined;
        case "string":
            return $508a5edf05a9a175$var$ZodParsedType.string;
        case "number":
            return isNaN(e) ? $508a5edf05a9a175$var$ZodParsedType.nan : $508a5edf05a9a175$var$ZodParsedType.number;
        case "boolean":
            return $508a5edf05a9a175$var$ZodParsedType.boolean;
        case "function":
            return $508a5edf05a9a175$var$ZodParsedType.function;
        case "bigint":
            return $508a5edf05a9a175$var$ZodParsedType.bigint;
        case "object":
            return Array.isArray(e) ? $508a5edf05a9a175$var$ZodParsedType.array : null === e ? $508a5edf05a9a175$var$ZodParsedType.null : e.then && "function" == typeof e.then && e.catch && "function" == typeof e.catch ? $508a5edf05a9a175$var$ZodParsedType.promise : e instanceof Map ? $508a5edf05a9a175$var$ZodParsedType.map : e instanceof Set ? $508a5edf05a9a175$var$ZodParsedType.set : e instanceof Date ? $508a5edf05a9a175$var$ZodParsedType.date : $508a5edf05a9a175$var$ZodParsedType.object;
        default:
            return $508a5edf05a9a175$var$ZodParsedType.unknown;
    }
}, $508a5edf05a9a175$var$makeIssue = function(e) {
    var t, r, n = e.data, o = e.path, a = e.errorMaps, e = e.issueData, o = $508a5edf05a9a175$var$__spreadArray($508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(o), !1), $508a5edf05a9a175$var$__read(e.path || [])), i = $508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, e), {
        path: o
    }), s = "", a = a.filter(function(e) {
        return !!e;
    }).slice().reverse();
    try {
        for(var u = $508a5edf05a9a175$var$__values(a), d = u.next(); !d.done; d = u.next())s = (0, d.value)(i, {
            data: n,
            defaultError: s
        }).message;
    } catch (e) {
        t = {
            error: e
        };
    } finally{
        try {
            d && !d.done && (r = u.return) && r.call(u);
        } finally{
            if (t) throw t.error;
        }
    }
    return $508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, e), {
        path: o,
        message: e.message || s
    });
}, $508a5edf05a9a175$var$EMPTY_PATH = null, $508a5edf05a9a175$var$pathToArray = function(e) {
    if (null === e) return [];
    for(var t = new Array(e.count); null !== e;)t[e.count - 1] = e.component, e = e.parent;
    return t;
}, $508a5edf05a9a175$var$pathFromArray = function(e) {
    for(var t = null, r = 0; r < e.length; r++)t = {
        parent: t,
        component: e[r],
        count: r + 1
    };
    return t;
}, $508a5edf05a9a175$var$ParseContext = function() {
    function t(e) {
        this.def = e;
    }
    return Object.defineProperty(t.prototype, "path", {
        get: function() {
            return this.def.path;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "issues", {
        get: function() {
            return this.def.issues;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "errorMap", {
        get: function() {
            return this.def.errorMap;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "async", {
        get: function() {
            return this.def.async;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.stepInto = function(e) {
        return new t($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this.def), {
            path: null === this.path ? {
                parent: null,
                count: 1,
                component: e
            } : {
                parent: this.path,
                count: this.path.count + 1,
                component: e
            }
        }));
    }, t.prototype._addIssue = function(e, t, r) {
        void 0 === r && (r = {});
        r = $508a5edf05a9a175$var$makeIssue({
            data: e,
            issueData: t,
            path: $508a5edf05a9a175$var$pathToArray(this.path),
            errorMaps: [
                this.def.errorMap,
                r.schemaErrorMap,
                $508a5edf05a9a175$var$overrideErrorMap,
                $508a5edf05a9a175$var$defaultErrorMap
            ]
        });
        this.issues.push(r);
    }, t;
}(), $508a5edf05a9a175$var$INVALID = Object.freeze({
    valid: !1
}), $508a5edf05a9a175$var$OK = function(e) {
    return {
        valid: !0,
        value: e
    };
}, $508a5edf05a9a175$var$isInvalid = function(e) {
    return !1 === e.valid;
}, $508a5edf05a9a175$var$isOk = function(e) {
    return !0 === e.valid;
}, $508a5edf05a9a175$var$isAsync = function(e) {
    return e instanceof Promise;
};
!function(e) {
    e.errToObj = function(e) {
        return "string" == typeof e ? {
            message: e
        } : e || {};
    }, e.toString = function(e) {
        return "string" == typeof e ? e : null == e ? void 0 : e.message;
    };
}($508a5edf05a9a175$var$errorUtil = $508a5edf05a9a175$var$errorUtil || {});
var $508a5edf05a9a175$var$createRootContext = function(e) {
    return new $508a5edf05a9a175$var$ParseContext({
        path: $508a5edf05a9a175$var$pathFromArray(e.path || []),
        issues: [],
        errorMap: e.errorMap,
        async: null !== (e = e.async) && void 0 !== e && e
    });
}, $508a5edf05a9a175$var$handleResult = function(e, t) {
    return $508a5edf05a9a175$var$isOk(t) && !e.issues.length ? {
        success: !0,
        data: t.value
    } : {
        success: !1,
        error: new $508a5edf05a9a175$var$ZodError(e.issues)
    };
};
function $508a5edf05a9a175$var$processCreateParams(r) {
    if (!r) return {};
    if (r.errorMap && (r.invalid_type_error || r.required_error)) throw new Error('Can\'t use "invalid" or "required" in conjunction with custom error map.');
    if (r.errorMap) return {
        errorMap: r.errorMap
    };
    return {
        errorMap: function(e, t) {
            return "invalid_type" !== e.code ? {
                message: t.defaultError
            } : void 0 === t.data && r.required_error ? {
                message: r.required_error
            } : r.invalid_type_error ? {
                message: r.invalid_type_error
            } : {
                message: t.defaultError
            };
        }
    };
}
var $508a5edf05a9a175$var$objectUtil, $508a5edf05a9a175$var$ZodType = function() {
    function e(e) {
        this.spa = this.safeParseAsync, this.superRefine = this._refinement, this._def = e, this.transform = this.transform.bind(this), this.default = this.default.bind(this);
    }
    return e.prototype.addIssue = function(e, t, r) {
        e._addIssue(r.data, t, {
            schemaErrorMap: this._def.errorMap
        });
    }, e.prototype._parseSync = function(e, t, r) {
        r = this._parse(e, t, r);
        if ($508a5edf05a9a175$var$isAsync(r)) throw new Error("Synchronous parse encountered promise.");
        return r;
    }, e.prototype._parseAsync = function(e, t, r) {
        r = this._parse(e, t, r);
        return Promise.resolve(r);
    }, e.prototype.parse = function(e, t) {
        t = this.safeParse(e, t);
        if (t.success) return t.data;
        throw t.error;
    }, e.prototype.safeParse = function(e, t) {
        t = $508a5edf05a9a175$var$createRootContext($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, t), {
            async: !1
        })), e = this._parseSync(t, e, $508a5edf05a9a175$var$getParsedType(e));
        return $508a5edf05a9a175$var$handleResult(t, e);
    }, e.prototype.parseAsync = function(r, n) {
        return $508a5edf05a9a175$var$__awaiter(this, void 0, void 0, function() {
            var t;
            return $508a5edf05a9a175$var$__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.safeParseAsync(r, n)
                        ];
                    case 1:
                        if ((t = e.sent()).success) return [
                            2,
                            t.data
                        ];
                        throw t.error;
                }
            });
        });
    }, e.prototype.safeParseAsync = function(n, o) {
        return $508a5edf05a9a175$var$__awaiter(this, void 0, void 0, function() {
            var t, r;
            return $508a5edf05a9a175$var$__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = $508a5edf05a9a175$var$createRootContext($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, o), {
                            async: !0
                        })), r = this._parse(t, n, $508a5edf05a9a175$var$getParsedType(n)), [
                            4,
                            $508a5edf05a9a175$var$isAsync(r) ? r : Promise.resolve(r)
                        ];
                    case 1:
                        return r = e.sent(), [
                            2,
                            $508a5edf05a9a175$var$handleResult(t, r)
                        ];
                }
            });
        });
    }, e.prototype.refine = function(o, a) {
        return this._refinement(function(t, r) {
            function n() {
                var e;
                return r.addIssue($508a5edf05a9a175$var$__assign({
                    code: $508a5edf05a9a175$var$ZodIssueCode.custom
                }, (e = t, "string" == typeof a || void 0 === a ? {
                    message: a
                } : "function" == typeof a ? a(e) : a)));
            }
            var e = o(t);
            return e instanceof Promise ? e.then(function(e) {
                return !!e || (n(), !1);
            }) : !!e || (n(), !1);
        });
    }, e.prototype.refinement = function(r, n) {
        return this._refinement(function(e, t) {
            return !!r(e) || (t.addIssue("function" == typeof n ? n(e, t) : n), !1);
        });
    }, e.prototype._refinement = function(e) {
        return new $508a5edf05a9a175$var$ZodEffects({
            schema: this,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement: e
            }
        });
    }, e.prototype.optional = function() {
        return $508a5edf05a9a175$var$ZodOptional.create(this);
    }, e.prototype.nullable = function() {
        return $508a5edf05a9a175$var$ZodNullable.create(this);
    }, e.prototype.nullish = function() {
        return this.optional().nullable();
    }, e.prototype.array = function() {
        return $508a5edf05a9a175$var$ZodArray.create(this);
    }, e.prototype.promise = function() {
        return $508a5edf05a9a175$var$ZodPromise.create(this);
    }, e.prototype.or = function(e) {
        return $508a5edf05a9a175$var$ZodUnion.create([
            this,
            e
        ]);
    }, e.prototype.and = function(e) {
        return $508a5edf05a9a175$var$ZodIntersection.create(this, e);
    }, e.prototype.transform = function(e) {
        return new $508a5edf05a9a175$var$ZodEffects({
            schema: this,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform: e
            }
        });
    }, e.prototype.default = function(e) {
        return new $508a5edf05a9a175$var$ZodDefault({
            innerType: this,
            defaultValue: "function" == typeof e ? e : function() {
                return e;
            },
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodDefault
        });
    }, e.prototype.isOptional = function() {
        return this.safeParse(void 0).success;
    }, e.prototype.isNullable = function() {
        return this.safeParse(null).success;
    }, e;
}(), $508a5edf05a9a175$var$cuidRegex = /^c[^\s-]{8,}$/i, $508a5edf05a9a175$var$uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, $508a5edf05a9a175$var$emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, $508a5edf05a9a175$var$ZodString = function(e) {
    function t() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n._regex = function(t, e, r) {
            return n.refinement(function(e) {
                return t.test(e);
            }, $508a5edf05a9a175$var$__assign({
                validation: e,
                code: $508a5edf05a9a175$var$ZodIssueCode.invalid_string
            }, $508a5edf05a9a175$var$errorUtil.errToObj(r)));
        }, n.nonempty = function(e) {
            return n.min(1, $508a5edf05a9a175$var$errorUtil.errToObj(e));
        }, n;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(t, r, e) {
        var n, o;
        if (e !== $508a5edf05a9a175$var$ZodParsedType.string) return this.addIssue(t, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.string,
            received: e
        }, {
            data: r
        }), $508a5edf05a9a175$var$INVALID;
        var a = !1;
        try {
            for(var i = $508a5edf05a9a175$var$__values(this._def.checks), s = i.next(); !s.done; s = i.next()){
                var u = s.value;
                if ("min" === u.kind) r.length < u.value && (a = !0, this.addIssue(t, {
                    code: $508a5edf05a9a175$var$ZodIssueCode.too_small,
                    minimum: u.value,
                    type: "string",
                    inclusive: !0,
                    message: u.message
                }, {
                    data: r
                }));
                else if ("max" === u.kind) r.length > u.value && (a = !0, this.addIssue(t, {
                    code: $508a5edf05a9a175$var$ZodIssueCode.too_big,
                    maximum: u.value,
                    type: "string",
                    inclusive: !0,
                    message: u.message
                }, {
                    data: r
                }));
                else if ("email" === u.kind) $508a5edf05a9a175$var$emailRegex.test(r) || (a = !0, this.addIssue(t, {
                    validation: "email",
                    code: $508a5edf05a9a175$var$ZodIssueCode.invalid_string,
                    message: u.message
                }, {
                    data: r
                }));
                else if ("uuid" === u.kind) $508a5edf05a9a175$var$uuidRegex.test(r) || (a = !0, this.addIssue(t, {
                    validation: "uuid",
                    code: $508a5edf05a9a175$var$ZodIssueCode.invalid_string,
                    message: u.message
                }, {
                    data: r
                }));
                else if ("cuid" === u.kind) $508a5edf05a9a175$var$cuidRegex.test(r) || (a = !0, this.addIssue(t, {
                    validation: "cuid",
                    code: $508a5edf05a9a175$var$ZodIssueCode.invalid_string,
                    message: u.message
                }, {
                    data: r
                }));
                else if ("url" === u.kind) try {
                    new URL(r);
                } catch (e) {
                    a = !0, this.addIssue(t, {
                        validation: "url",
                        code: $508a5edf05a9a175$var$ZodIssueCode.invalid_string,
                        message: u.message
                    }, {
                        data: r
                    });
                }
                else "regex" === u.kind && (u.regex.lastIndex = 0, u.regex.test(r) || (a = !0, this.addIssue(t, {
                    validation: "regex",
                    code: $508a5edf05a9a175$var$ZodIssueCode.invalid_string,
                    message: u.message
                }, {
                    data: r
                })));
            }
        } catch (e) {
            n = {
                error: e
            };
        } finally{
            try {
                s && !s.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        return a ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(r);
    }, t.prototype._addCheck = function(e) {
        return new t($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            checks: $508a5edf05a9a175$var$__spreadArray($508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(this._def.checks), !1), [
                e
            ])
        }));
    }, t.prototype.email = function(e) {
        return this._addCheck($508a5edf05a9a175$var$__assign({
            kind: "email"
        }, $508a5edf05a9a175$var$errorUtil.errToObj(e)));
    }, t.prototype.url = function(e) {
        return this._addCheck($508a5edf05a9a175$var$__assign({
            kind: "url"
        }, $508a5edf05a9a175$var$errorUtil.errToObj(e)));
    }, t.prototype.uuid = function(e) {
        return this._addCheck($508a5edf05a9a175$var$__assign({
            kind: "uuid"
        }, $508a5edf05a9a175$var$errorUtil.errToObj(e)));
    }, t.prototype.cuid = function(e) {
        return this._addCheck($508a5edf05a9a175$var$__assign({
            kind: "cuid"
        }, $508a5edf05a9a175$var$errorUtil.errToObj(e)));
    }, t.prototype.regex = function(e, t) {
        return this._addCheck($508a5edf05a9a175$var$__assign({
            kind: "regex",
            regex: e
        }, $508a5edf05a9a175$var$errorUtil.errToObj(t)));
    }, t.prototype.min = function(e, t) {
        return this._addCheck($508a5edf05a9a175$var$__assign({
            kind: "min",
            value: e
        }, $508a5edf05a9a175$var$errorUtil.errToObj(t)));
    }, t.prototype.max = function(e, t) {
        return this._addCheck($508a5edf05a9a175$var$__assign({
            kind: "max",
            value: e
        }, $508a5edf05a9a175$var$errorUtil.errToObj(t)));
    }, t.prototype.length = function(e, t) {
        return this.min(e, t).max(e, t);
    }, Object.defineProperty(t.prototype, "isEmail", {
        get: function() {
            return !!this._def.checks.find(function(e) {
                return "email" === e.kind;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isURL", {
        get: function() {
            return !!this._def.checks.find(function(e) {
                return "url" === e.kind;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isUUID", {
        get: function() {
            return !!this._def.checks.find(function(e) {
                return "uuid" === e.kind;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isCUID", {
        get: function() {
            return !!this._def.checks.find(function(e) {
                return "cuid" === e.kind;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "minLength", {
        get: function() {
            var t = -1 / 0;
            return this._def.checks.map(function(e) {
                "min" === e.kind && (null === t || e.value > t) && (t = e.value);
            }), t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "maxLength", {
        get: function() {
            var t = null;
            return this._def.checks.map(function(e) {
                "max" === e.kind && (null === t || e.value < t) && (t = e.value);
            }), t;
        },
        enumerable: !1,
        configurable: !0
    }), t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            checks: [],
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodString
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodNumber = function(t) {
    function o() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.min = e.gte, e.max = e.lte, e.step = e.multipleOf, e;
    }
    return $508a5edf05a9a175$var$__extends(o, t), o.prototype._parse = function(e, t, r) {
        var n, o;
        if (r !== $508a5edf05a9a175$var$ZodParsedType.number) return this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.number,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID;
        var a = !1;
        try {
            for(var i = $508a5edf05a9a175$var$__values(this._def.checks), s = i.next(); !s.done; s = i.next()){
                var u = s.value;
                "int" === u.kind ? $508a5edf05a9a175$var$util.isInteger(t) || (a = !0, this.addIssue(e, {
                    code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
                    expected: "integer",
                    received: "float",
                    message: u.message
                }, {
                    data: t
                })) : "min" === u.kind ? (u.inclusive ? t < u.value : t <= u.value) && (a = !0, this.addIssue(e, {
                    code: $508a5edf05a9a175$var$ZodIssueCode.too_small,
                    minimum: u.value,
                    type: "number",
                    inclusive: u.inclusive,
                    message: u.message
                }, {
                    data: t
                })) : "max" === u.kind ? (u.inclusive ? t > u.value : t >= u.value) && (a = !0, this.addIssue(e, {
                    code: $508a5edf05a9a175$var$ZodIssueCode.too_big,
                    maximum: u.value,
                    type: "number",
                    inclusive: u.inclusive,
                    message: u.message
                }, {
                    data: t
                })) : "multipleOf" === u.kind ? t % u.value != 0 && (a = !0, this.addIssue(e, {
                    code: $508a5edf05a9a175$var$ZodIssueCode.not_multiple_of,
                    multipleOf: u.value,
                    message: u.message
                }, {
                    data: t
                })) : $508a5edf05a9a175$var$util.assertNever(u);
            }
        } catch (e) {
            n = {
                error: e
            };
        } finally{
            try {
                s && !s.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        return a ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(t);
    }, o.prototype.gte = function(e, t) {
        return this.setLimit("min", e, !0, $508a5edf05a9a175$var$errorUtil.toString(t));
    }, o.prototype.gt = function(e, t) {
        return this.setLimit("min", e, !1, $508a5edf05a9a175$var$errorUtil.toString(t));
    }, o.prototype.lte = function(e, t) {
        return this.setLimit("max", e, !0, $508a5edf05a9a175$var$errorUtil.toString(t));
    }, o.prototype.lt = function(e, t) {
        return this.setLimit("max", e, !1, $508a5edf05a9a175$var$errorUtil.toString(t));
    }, o.prototype.setLimit = function(e, t, r, n) {
        return new o($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            checks: $508a5edf05a9a175$var$__spreadArray($508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(this._def.checks), !1), [
                {
                    kind: e,
                    value: t,
                    inclusive: r,
                    message: $508a5edf05a9a175$var$errorUtil.toString(n)
                }
            ])
        }));
    }, o.prototype._addCheck = function(e) {
        return new o($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            checks: $508a5edf05a9a175$var$__spreadArray($508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(this._def.checks), !1), [
                e
            ])
        }));
    }, o.prototype.int = function(e) {
        return this._addCheck({
            kind: "int",
            message: $508a5edf05a9a175$var$errorUtil.toString(e)
        });
    }, o.prototype.positive = function(e) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: !1,
            message: $508a5edf05a9a175$var$errorUtil.toString(e)
        });
    }, o.prototype.negative = function(e) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: !1,
            message: $508a5edf05a9a175$var$errorUtil.toString(e)
        });
    }, o.prototype.nonpositive = function(e) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: !0,
            message: $508a5edf05a9a175$var$errorUtil.toString(e)
        });
    }, o.prototype.nonnegative = function(e) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: !0,
            message: $508a5edf05a9a175$var$errorUtil.toString(e)
        });
    }, o.prototype.multipleOf = function(e, t) {
        return this._addCheck({
            kind: "multipleOf",
            value: e,
            message: $508a5edf05a9a175$var$errorUtil.toString(t)
        });
    }, Object.defineProperty(o.prototype, "minValue", {
        get: function() {
            var t, e, r = null;
            try {
                for(var n = $508a5edf05a9a175$var$__values(this._def.checks), o = n.next(); !o.done; o = n.next()){
                    var a = o.value;
                    "min" === a.kind && (null === r || a.value > r) && (r = a.value);
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    o && !o.done && (e = n.return) && e.call(n);
                } finally{
                    if (t) throw t.error;
                }
            }
            return r;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(o.prototype, "maxValue", {
        get: function() {
            var t, e, r = null;
            try {
                for(var n = $508a5edf05a9a175$var$__values(this._def.checks), o = n.next(); !o.done; o = n.next()){
                    var a = o.value;
                    "max" === a.kind && (null === r || a.value < r) && (r = a.value);
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    o && !o.done && (e = n.return) && e.call(n);
                } finally{
                    if (t) throw t.error;
                }
            }
            return r;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(o.prototype, "isInt", {
        get: function() {
            return !!this._def.checks.find(function(e) {
                return "int" === e.kind;
            });
        },
        enumerable: !1,
        configurable: !0
    }), o.create = function(e) {
        return new o($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({
            checks: [],
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodNumber
        }, $508a5edf05a9a175$var$processCreateParams(e)), $508a5edf05a9a175$var$processCreateParams(e)));
    }, o;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodBigInt = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return r !== $508a5edf05a9a175$var$ZodParsedType.bigint ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.bigint,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodBigInt
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodBoolean = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return r !== $508a5edf05a9a175$var$ZodParsedType.boolean ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.boolean,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodBoolean
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodDate = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return r !== $508a5edf05a9a175$var$ZodParsedType.date ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.date,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : isNaN(t.getTime()) ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_date
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(new Date(t.getTime()));
    }, t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodDate
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodUndefined = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return r !== $508a5edf05a9a175$var$ZodParsedType.undefined ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.undefined,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodUndefined
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodNull = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return r !== $508a5edf05a9a175$var$ZodParsedType.null ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.null,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodNull
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodAny = function(t) {
    function r() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._any = !0, e;
    }
    return $508a5edf05a9a175$var$__extends(r, t), r.prototype._parse = function(e, t, r) {
        return $508a5edf05a9a175$var$OK(t);
    }, r.create = function(e) {
        return new r($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodAny
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodUnknown = function(t) {
    function r() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._unknown = !0, e;
    }
    return $508a5edf05a9a175$var$__extends(r, t), r.prototype._parse = function(e, t, r) {
        return $508a5edf05a9a175$var$OK(t);
    }, r.create = function(e) {
        return new r($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodUnknown
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodNever = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.never,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID;
    }, t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodNever
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodVoid = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return r !== $508a5edf05a9a175$var$ZodParsedType.undefined ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.void,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, t.create = function(e) {
        return new t($508a5edf05a9a175$var$__assign({
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodVoid
        }, $508a5edf05a9a175$var$processCreateParams(e)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodArray = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(r, e, t) {
        var n = this._def;
        if (t !== $508a5edf05a9a175$var$ZodParsedType.array) return this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.array,
            received: t
        }, {
            data: e
        }), $508a5edf05a9a175$var$INVALID;
        var e = e, o = !1;
        null !== n.minLength && e.length < n.minLength.value && (o = !0, this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.too_small,
            minimum: n.minLength.value,
            type: "array",
            inclusive: !0,
            message: n.minLength.message
        }, {
            data: e
        })), null !== n.maxLength && e.length > n.maxLength.value && (o = !0, this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.too_big,
            maximum: n.maxLength.value,
            type: "array",
            inclusive: !0,
            message: n.maxLength.message
        }, {
            data: e
        }));
        var a = [], i = new Array(e.length), s = n.type, u = function(t, e) {
            $508a5edf05a9a175$var$isOk(e) ? i[t] = e.value : $508a5edf05a9a175$var$isInvalid(e) ? o = !0 : a.push(e.then(function(e) {
                return u(t, e);
            }));
        };
        return e.forEach(function(e, t) {
            u(t, s._parse(r.stepInto(t), e, $508a5edf05a9a175$var$getParsedType(e)));
        }), r.async ? Promise.all(a).then(function() {
            return o ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(i);
        }) : o ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(i);
    }, Object.defineProperty(r.prototype, "element", {
        get: function() {
            return this._def.type;
        },
        enumerable: !1,
        configurable: !0
    }), r.prototype.min = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            minLength: {
                value: e,
                message: $508a5edf05a9a175$var$errorUtil.toString(t)
            }
        }));
    }, r.prototype.max = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            maxLength: {
                value: e,
                message: $508a5edf05a9a175$var$errorUtil.toString(t)
            }
        }));
    }, r.prototype.length = function(e, t) {
        return this.min(e, t).max(e, t);
    }, r.prototype.nonempty = function(e) {
        return this.min(1, e);
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            type: e,
            minLength: null,
            maxLength: null,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodArray
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType);
!function(e) {
    e.mergeShapes = function(e, t) {
        return $508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, e), t);
    }, e.intersectShapes = function(e, t) {
        var r, n, o = $508a5edf05a9a175$var$util.objectKeys(e), a = $508a5edf05a9a175$var$util.objectKeys(t), o = o.filter(function(e) {
            return -1 !== a.indexOf(e);
        }), i = {};
        try {
            for(var s = $508a5edf05a9a175$var$__values(o), u = s.next(); !u.done; u = s.next()){
                var d = u.value;
                i[d] = $508a5edf05a9a175$var$ZodIntersection.create(e[d], t[d]);
            }
        } catch (e) {
            r = {
                error: e
            };
        } finally{
            try {
                u && !u.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
        return $508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, e), t), i);
    };
}($508a5edf05a9a175$var$objectUtil = $508a5edf05a9a175$var$objectUtil || {});
var $508a5edf05a9a175$var$mergeObjects = function(r) {
    return function(e) {
        var t = $508a5edf05a9a175$var$objectUtil.mergeShapes(r._def.shape(), e._def.shape());
        return new $508a5edf05a9a175$var$ZodObject({
            unknownKeys: r._def.unknownKeys,
            catchall: r._def.catchall,
            shape: function() {
                return t;
            },
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodObject
        });
    };
}, $508a5edf05a9a175$var$AugmentFactory = function(t) {
    return function(e) {
        return new $508a5edf05a9a175$var$ZodObject($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, t), {
            shape: function() {
                return $508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, t.shape()), e);
            }
        }));
    };
};
function $508a5edf05a9a175$var$deepPartialify(e) {
    if (e instanceof $508a5edf05a9a175$var$ZodObject) {
        var t, r = {};
        for(t in e.shape){
            var n = e.shape[t];
            r[t] = $508a5edf05a9a175$var$ZodOptional.create($508a5edf05a9a175$var$deepPartialify(n));
        }
        return new $508a5edf05a9a175$var$ZodObject($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, e._def), {
            shape: function() {
                return r;
            }
        }));
    }
    return e instanceof $508a5edf05a9a175$var$ZodArray ? $508a5edf05a9a175$var$ZodArray.create($508a5edf05a9a175$var$deepPartialify(e.element)) : e instanceof $508a5edf05a9a175$var$ZodOptional ? $508a5edf05a9a175$var$ZodOptional.create($508a5edf05a9a175$var$deepPartialify(e.unwrap())) : e instanceof $508a5edf05a9a175$var$ZodNullable ? $508a5edf05a9a175$var$ZodNullable.create($508a5edf05a9a175$var$deepPartialify(e.unwrap())) : e instanceof $508a5edf05a9a175$var$ZodTuple ? $508a5edf05a9a175$var$ZodTuple.create(e.items.map(function(e) {
        return $508a5edf05a9a175$var$deepPartialify(e);
    })) : e;
}
var $508a5edf05a9a175$var$ZodObject = function(t) {
    function a() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._cached = null, e.nonstrict = e.passthrough, e.augment = $508a5edf05a9a175$var$AugmentFactory(e._def), e.extend = $508a5edf05a9a175$var$AugmentFactory(e._def), e;
    }
    return $508a5edf05a9a175$var$__extends(a, t), a.prototype._getCached = function() {
        if (null !== this._cached) return this._cached;
        var e = this._def.shape(), t = $508a5edf05a9a175$var$util.objectKeys(e);
        return this._cached = {
            shape: e,
            keys: t
        };
    }, a.prototype._parse = function(e, n, t) {
        var r, o, a, i, s;
        if (t !== $508a5edf05a9a175$var$ZodParsedType.object) return this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.object,
            received: t
        }, {
            data: n
        }), $508a5edf05a9a175$var$INVALID;
        var t = this._getCached(), u = t.shape, t = t.keys, d = !1, c = [], p = {}, l = function(t, e) {
            var r;
            $508a5edf05a9a175$var$isOk(e) ? (void 0 !== (r = e.value) || t in n) && (p[t] = r) : $508a5edf05a9a175$var$isInvalid(e) ? d = !0 : c.push(e.then(function(e) {
                return l(t, e);
            }));
        };
        try {
            for(var f = $508a5edf05a9a175$var$__values(t), y = f.next(); !y.done; y = f.next()){
                var _ = y.value, h = u[_], m = n[_];
                l(_, h._parse(e.stepInto(_), m, $508a5edf05a9a175$var$getParsedType(m)));
            }
        } catch (e) {
            v = {
                error: e
            };
        } finally{
            try {
                y && !y.done && (r = f.return) && r.call(f);
            } finally{
                if (v) throw v.error;
            }
        }
        if (this._def.catchall instanceof $508a5edf05a9a175$var$ZodNever) {
            var v = this._def.unknownKeys;
            if ("passthrough" === v) {
                var Z = $508a5edf05a9a175$var$util.objectKeys(n).filter(function(e) {
                    return !(e in u);
                });
                try {
                    for(var g = $508a5edf05a9a175$var$__values(Z), T = g.next(); !T.done; T = g.next()){
                        _ = T.value;
                        p[_] = n[_];
                    }
                } catch (e) {
                    o = {
                        error: e
                    };
                } finally{
                    try {
                        T && !T.done && (a = g.return) && a.call(g);
                    } finally{
                        if (o) throw o.error;
                    }
                }
            } else if ("strict" === v) 0 < (Z = $508a5edf05a9a175$var$util.objectKeys(n).filter(function(e) {
                return !(e in u);
            })).length && (d = !0, this.addIssue(e, {
                code: $508a5edf05a9a175$var$ZodIssueCode.unrecognized_keys,
                keys: Z
            }, {
                data: n
            }));
            else if ("strip" !== v) throw new Error("Internal ZodObject error: invalid unknownKeys value.");
        } else {
            var b = this._def.catchall, Z = $508a5edf05a9a175$var$util.objectKeys(n).filter(function(e) {
                return !(e in u);
            });
            try {
                for(var I = $508a5edf05a9a175$var$__values(Z), P = I.next(); !P.done; P = I.next()){
                    _ = P.value, m = n[_];
                    l(_, b._parse(e.stepInto(_), m, $508a5edf05a9a175$var$getParsedType(m)));
                }
            } catch (e) {
                i = {
                    error: e
                };
            } finally{
                try {
                    P && !P.done && (s = I.return) && s.call(I);
                } finally{
                    if (i) throw i.error;
                }
            }
        }
        return e.async ? Promise.all(c).then(function() {
            return d ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(p);
        }) : d ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(p);
    }, Object.defineProperty(a.prototype, "shape", {
        get: function() {
            return this._def.shape();
        },
        enumerable: !1,
        configurable: !0
    }), a.prototype.strict = function() {
        return new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            unknownKeys: "strict"
        }));
    }, a.prototype.strip = function() {
        return new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            unknownKeys: "strip"
        }));
    }, a.prototype.passthrough = function() {
        return new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            unknownKeys: "passthrough"
        }));
    }, a.prototype.setKey = function(e, t) {
        var r;
        return this.augment(((r = {})[e] = t, r));
    }, a.prototype.merge = function(e) {
        var t = $508a5edf05a9a175$var$objectUtil.mergeShapes(this._def.shape(), e._def.shape());
        return new a({
            unknownKeys: e._def.unknownKeys,
            catchall: e._def.catchall,
            shape: function() {
                return t;
            },
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodObject
        });
    }, a.prototype.catchall = function(e) {
        return new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            catchall: e
        }));
    }, a.prototype.pick = function(e) {
        var t = this, r = {};
        return $508a5edf05a9a175$var$util.objectKeys(e).map(function(e) {
            r[e] = t.shape[e];
        }), new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            shape: function() {
                return r;
            }
        }));
    }, a.prototype.omit = function(t) {
        var r = this, n = {};
        return $508a5edf05a9a175$var$util.objectKeys(this.shape).map(function(e) {
            -1 === $508a5edf05a9a175$var$util.objectKeys(t).indexOf(e) && (n[e] = r.shape[e]);
        }), new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            shape: function() {
                return n;
            }
        }));
    }, a.prototype.deepPartial = function() {
        return $508a5edf05a9a175$var$deepPartialify(this);
    }, a.prototype.partial = function(t) {
        var e, r = this, n = {};
        if (t) return $508a5edf05a9a175$var$util.objectKeys(this.shape).map(function(e) {
            -1 === $508a5edf05a9a175$var$util.objectKeys(t).indexOf(e) ? n[e] = r.shape[e] : n[e] = r.shape[e].optional();
        }), new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            shape: function() {
                return n;
            }
        }));
        for(e in this.shape){
            var o = this.shape[e];
            n[e] = o.optional();
        }
        return new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            shape: function() {
                return n;
            }
        }));
    }, a.prototype.required = function() {
        var e, t = {};
        for(e in this.shape){
            for(var r = this.shape[e]; r instanceof $508a5edf05a9a175$var$ZodOptional;)r = r._def.innerType;
            t[e] = r;
        }
        return new a($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            shape: function() {
                return t;
            }
        }));
    }, a.create = function(e, t) {
        return new a($508a5edf05a9a175$var$__assign({
            shape: function() {
                return e;
            },
            unknownKeys: "strip",
            catchall: $508a5edf05a9a175$var$ZodNever.create(),
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodObject
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, a.strictCreate = function(e, t) {
        return new a($508a5edf05a9a175$var$__assign({
            shape: function() {
                return e;
            },
            unknownKeys: "strict",
            catchall: $508a5edf05a9a175$var$ZodNever.create(),
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodObject
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, a.lazycreate = function(e, t) {
        return new a($508a5edf05a9a175$var$__assign({
            shape: e,
            unknownKeys: "strip",
            catchall: $508a5edf05a9a175$var$ZodNever.create(),
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodObject
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, a;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodUnion = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(r, n, o) {
        function i(e) {
            var t = e.map(function(e) {
                return new $508a5edf05a9a175$var$ZodError(e);
            });
            return 1 === (e = t.filter(function(e) {
                return "invalid_type" !== e.issues[0].code;
            })).length ? e[0].issues.forEach(function(e) {
                return r.issues.push(e);
            }) : a.addIssue(r, {
                code: $508a5edf05a9a175$var$ZodIssueCode.invalid_union,
                unionErrors: t
            }, {
                data: n
            }), $508a5edf05a9a175$var$INVALID;
        }
        var t, e, a = this, s = this._def.options;
        if (r.async) {
            var u = s.map(function() {
                return new $508a5edf05a9a175$var$ParseContext($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, r.def), {
                    issues: []
                }));
            });
            return Promise.all(s.map(function(e, t) {
                return e._parse(u[t], n, o);
            })).then(function(e) {
                var t, r;
                try {
                    for(var n = $508a5edf05a9a175$var$__values(e), o = n.next(); !o.done; o = n.next()){
                        var a = o.value;
                        if ($508a5edf05a9a175$var$isOk(a)) return a;
                    }
                } catch (e) {
                    t = {
                        error: e
                    };
                } finally{
                    try {
                        o && !o.done && (r = n.return) && r.call(n);
                    } finally{
                        if (t) throw t.error;
                    }
                }
                return i(u.map(function(e) {
                    return e.issues;
                }));
            });
        }
        var d = [];
        try {
            for(var c = $508a5edf05a9a175$var$__values(s), p = c.next(); !p.done; p = c.next()){
                var l = p.value, f = new $508a5edf05a9a175$var$ParseContext($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, r.def), {
                    issues: []
                })), y = l._parseSync(f, n, o);
                if (!$508a5edf05a9a175$var$isInvalid(y)) return y;
                d.push(f.issues);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                p && !p.done && (e = c.return) && e.call(c);
            } finally{
                if (t) throw t.error;
            }
        }
        return i(d);
    }, Object.defineProperty(r.prototype, "options", {
        get: function() {
            return this._def.options;
        },
        enumerable: !1,
        configurable: !0
    }), r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            options: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodUnion
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType);
function $508a5edf05a9a175$var$mergeValues(e, t) {
    var r, n, o = $508a5edf05a9a175$var$getParsedType(e), a = $508a5edf05a9a175$var$getParsedType(t);
    if (e === t) return {
        valid: !0,
        data: e
    };
    if (o === $508a5edf05a9a175$var$ZodParsedType.object && a === $508a5edf05a9a175$var$ZodParsedType.object) {
        var i = $508a5edf05a9a175$var$util.objectKeys(t), s = $508a5edf05a9a175$var$util.objectKeys(e).filter(function(e) {
            return -1 !== i.indexOf(e);
        }), u = $508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, e), t);
        try {
            for(var d = $508a5edf05a9a175$var$__values(s), c = d.next(); !c.done; c = d.next()){
                var p = c.value;
                if (!(l = $508a5edf05a9a175$var$mergeValues(e[p], t[p])).valid) return {
                    valid: !1
                };
                u[p] = l.data;
            }
        } catch (e) {
            r = {
                error: e
            };
        } finally{
            try {
                c && !c.done && (n = d.return) && n.call(d);
            } finally{
                if (r) throw r.error;
            }
        }
        return {
            valid: !0,
            data: u
        };
    }
    if (o !== $508a5edf05a9a175$var$ZodParsedType.array || a !== $508a5edf05a9a175$var$ZodParsedType.array) return {
        valid: !1
    };
    if (e.length !== t.length) return {
        valid: !1
    };
    for(var l, f = [], y = 0; y < e.length; y++){
        if (!(l = $508a5edf05a9a175$var$mergeValues(e[y], t[y])).valid) return {
            valid: !1
        };
        f.push(l.data);
    }
    return {
        valid: !0,
        data: f
    };
}
var $508a5edf05a9a175$var$ZodIntersection = function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(n, e), n.prototype._parse = function(r, n, e) {
        function o(e, t) {
            return $508a5edf05a9a175$var$isInvalid(e) || $508a5edf05a9a175$var$isInvalid(t) ? $508a5edf05a9a175$var$INVALID : (t = $508a5edf05a9a175$var$mergeValues(e.value, t.value)).valid ? $508a5edf05a9a175$var$OK(t.data) : (a.addIssue(r, {
                code: $508a5edf05a9a175$var$ZodIssueCode.invalid_intersection_types
            }, {
                data: n
            }), $508a5edf05a9a175$var$INVALID);
        }
        var a = this;
        return r.async ? Promise.all([
            this._def.left._parse(r, n, e),
            this._def.right._parse(r, n, e)
        ]).then(function(e) {
            var t = $508a5edf05a9a175$var$__read(e, 2), e = t[0], t = t[1];
            return o(e, t);
        }) : o(this._def.left._parseSync(r, n, e), this._def.right._parseSync(r, n, e));
    }, n.create = function(e, t, r) {
        return new n($508a5edf05a9a175$var$__assign({
            left: e,
            right: t,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodIntersection
        }, $508a5edf05a9a175$var$processCreateParams(r)));
    }, n;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodTuple = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(r, n, e) {
        if (e !== $508a5edf05a9a175$var$ZodParsedType.array) return this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.array,
            received: e
        }, {
            data: n
        }), $508a5edf05a9a175$var$INVALID;
        var o = this._def.rest;
        if (!o && n.length > this._def.items.length) return this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.too_big,
            maximum: this._def.items.length,
            inclusive: !0,
            type: "array"
        }, {
            data: n
        }), $508a5edf05a9a175$var$INVALID;
        if (n.length < this._def.items.length) return this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.too_small,
            minimum: this._def.items.length,
            inclusive: !0,
            type: "array"
        }, {
            data: n
        }), $508a5edf05a9a175$var$INVALID;
        var a = [], i = this._def.items, s = new Array(n.length), u = !1, d = function(t, e) {
            $508a5edf05a9a175$var$isOk(e) ? s[t] = e.value : $508a5edf05a9a175$var$isInvalid(e) ? u = !0 : a.push(e.then(function(e) {
                return d(t, e);
            }));
        };
        return i.forEach(function(e, t) {
            d(t, e._parse(r.stepInto(t), n[t], $508a5edf05a9a175$var$getParsedType(n[t])));
        }), o && n.slice(i.length).forEach(function(e, t) {
            t += i.length;
            d(t, o._parse(r.stepInto(t), e, $508a5edf05a9a175$var$getParsedType(e)));
        }), r.async ? Promise.all(a).then(function() {
            return u ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(s);
        }) : u ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(s);
    }, Object.defineProperty(r.prototype, "items", {
        get: function() {
            return this._def.items;
        },
        enumerable: !1,
        configurable: !0
    }), r.prototype.rest = function(e) {
        return new r($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            rest: e
        }));
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            items: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodTuple,
            rest: null
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodRecord = function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(n, e), Object.defineProperty(n.prototype, "keySchema", {
        get: function() {
            return this._def.keyType;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "valueSchema", {
        get: function() {
            return this._def.valueType;
        },
        enumerable: !1,
        configurable: !0
    }), n.prototype._parse = function(e, t, r) {
        if (r !== $508a5edf05a9a175$var$ZodParsedType.object) return this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.object,
            received: r
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID;
        var n, o = [], a = this._def.keyType, i = this._def.valueType, s = {}, u = !1, d = function(e, t) {
            $508a5edf05a9a175$var$isOk(e) && $508a5edf05a9a175$var$isOk(t) ? s[e.value] = t.value : $508a5edf05a9a175$var$isAsync(e) || $508a5edf05a9a175$var$isAsync(t) ? o.push(Promise.all([
                e,
                t
            ]).then(function(e) {
                var t = $508a5edf05a9a175$var$__read(e, 2), e = t[0], t = t[1];
                return d(e, t);
            })) : u = !0;
        };
        for(n in t)d(a._parse(e.stepInto(n), n, $508a5edf05a9a175$var$getParsedType(n)), i._parse(e.stepInto(n), t[n], $508a5edf05a9a175$var$getParsedType(t[n])));
        return e.async ? Promise.all(o).then(function() {
            return u ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(s);
        }) : u ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(s);
    }, Object.defineProperty(n.prototype, "element", {
        get: function() {
            return this._def.valueType;
        },
        enumerable: !1,
        configurable: !0
    }), n.create = function(e, t, r) {
        return new n(t instanceof $508a5edf05a9a175$var$ZodType ? $508a5edf05a9a175$var$__assign({
            keyType: e,
            valueType: t,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodRecord
        }, $508a5edf05a9a175$var$processCreateParams(r)) : $508a5edf05a9a175$var$__assign({
            keyType: $508a5edf05a9a175$var$ZodString.create(),
            valueType: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodRecord
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, n;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodMap = function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(n, e), n.prototype._parse = function(n, e, t) {
        if (t !== $508a5edf05a9a175$var$ZodParsedType.map) return this.addIssue(n, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.map,
            received: t
        }, {
            data: e
        }), $508a5edf05a9a175$var$INVALID;
        var o = this._def.keyType, a = this._def.valueType, e = e, r = new Map, i = [], s = !1, u = function(e, t) {
            $508a5edf05a9a175$var$isAsync(e) || $508a5edf05a9a175$var$isAsync(t) ? i.push(Promise.all([
                e,
                t
            ]).then(function(e) {
                var t = $508a5edf05a9a175$var$__read(e, 2), e = t[0], t = t[1];
                return u(e, t);
            })) : $508a5edf05a9a175$var$isInvalid(e) || $508a5edf05a9a175$var$isInvalid(t) ? s = !0 : r.set(e.value, t.value);
        };
        return $508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(e.entries())).forEach(function(e, t) {
            var r = $508a5edf05a9a175$var$__read(e, 2), e = r[0], r = r[1], t = n.stepInto(t), e = o._parse(t.stepInto("key"), e, $508a5edf05a9a175$var$getParsedType(e)), r = a._parse(t.stepInto("value"), r, $508a5edf05a9a175$var$getParsedType(r));
            u(e, r);
        }), n.async ? Promise.all(i).then(function() {
            return s ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(r);
        }) : s ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(r);
    }, n.create = function(e, t, r) {
        return new n($508a5edf05a9a175$var$__assign({
            valueType: t,
            keyType: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodMap
        }, $508a5edf05a9a175$var$processCreateParams(r)));
    }, n;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodSet = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(r, e, t) {
        if (t !== $508a5edf05a9a175$var$ZodParsedType.set) return this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.set,
            received: t
        }, {
            data: e
        }), $508a5edf05a9a175$var$INVALID;
        var e = e, n = this._def.valueType, o = new Set, a = [], i = !1, s = function(e) {
            $508a5edf05a9a175$var$isOk(e) ? o.add(e.value) : $508a5edf05a9a175$var$isInvalid(e) ? i = !0 : a.push(e.then(function(e) {
                return s(e);
            }));
        };
        return $508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(e.values())).forEach(function(e, t) {
            return s(n._parse(r.stepInto(t), e, $508a5edf05a9a175$var$getParsedType(e)));
        }), r.async ? Promise.all(a).then(function() {
            return i ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(o);
        }) : i ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(o);
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            valueType: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodSet
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodFunction = function(t) {
    function n() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.validate = e.implement, e;
    }
    return $508a5edf05a9a175$var$__extends(n, t), n.prototype._parse = function(r, e, t) {
        var a = this;
        if (t !== $508a5edf05a9a175$var$ZodParsedType.function) return this.addIssue(r, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.function,
            received: t
        }, {
            data: e
        }), $508a5edf05a9a175$var$INVALID;
        function i(e, t) {
            return $508a5edf05a9a175$var$makeIssue({
                data: e,
                path: $508a5edf05a9a175$var$pathToArray(r.path),
                errorMaps: [
                    r.errorMap
                ],
                issueData: {
                    code: $508a5edf05a9a175$var$ZodIssueCode.invalid_arguments,
                    argumentsError: t
                }
            });
        }
        function s(e, t) {
            return $508a5edf05a9a175$var$makeIssue({
                data: e,
                path: $508a5edf05a9a175$var$pathToArray(r.path),
                errorMaps: [
                    r.errorMap
                ],
                issueData: {
                    code: $508a5edf05a9a175$var$ZodIssueCode.invalid_return_type,
                    returnTypeError: t
                }
            });
        }
        var u = {
            errorMap: r.errorMap
        }, d = e;
        return this._def.returns instanceof $508a5edf05a9a175$var$ZodPromise ? $508a5edf05a9a175$var$OK(function() {
            for(var o = [], e = 0; e < arguments.length; e++)o[e] = arguments[e];
            return $508a5edf05a9a175$var$__awaiter(a, void 0, void 0, function() {
                var t, r, n;
                return $508a5edf05a9a175$var$__generator(this, function(e) {
                    switch(e.label){
                        case 0:
                            return t = new $508a5edf05a9a175$var$ZodError([]), [
                                4,
                                this._def.args.parseAsync(o, u).catch(function(e) {
                                    throw t.addIssue(i(o, e)), t;
                                })
                            ];
                        case 1:
                            return r = e.sent(), [
                                4,
                                d.apply(void 0, $508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(r)))
                            ];
                        case 2:
                            return n = e.sent(), [
                                4,
                                this._def.returns.parseAsync(n, u).catch(function(e) {
                                    throw t.addIssue(s(n, e)), t;
                                })
                            ];
                        case 3:
                            return [
                                2,
                                e.sent()
                            ];
                    }
                });
            });
        }) : $508a5edf05a9a175$var$OK(function() {
            for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
            var r = a._def.args.safeParse(e, u);
            if (!r.success) throw new $508a5edf05a9a175$var$ZodError([
                i(e, r.error)
            ]);
            var n = d.apply(void 0, $508a5edf05a9a175$var$__spreadArray([], $508a5edf05a9a175$var$__read(r.data))), r = a._def.returns.safeParse(n, u);
            if (!r.success) throw new $508a5edf05a9a175$var$ZodError([
                s(n, r.error)
            ]);
            return r.data;
        });
    }, n.prototype.parameters = function() {
        return this._def.args;
    }, n.prototype.returnType = function() {
        return this._def.returns;
    }, n.prototype.args = function() {
        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
        return new n($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            args: $508a5edf05a9a175$var$ZodTuple.create(e).rest($508a5edf05a9a175$var$ZodUnknown.create())
        }));
    }, n.prototype.returns = function(e) {
        return new n($508a5edf05a9a175$var$__assign($508a5edf05a9a175$var$__assign({}, this._def), {
            returns: e
        }));
    }, n.prototype.implement = function(e) {
        return this.parse(e);
    }, n.prototype.strictImplement = function(e) {
        return this.parse(e);
    }, n.create = function(e, t, r) {
        return new n($508a5edf05a9a175$var$__assign({
            args: (e || $508a5edf05a9a175$var$ZodTuple.create([])).rest($508a5edf05a9a175$var$ZodUnknown.create()),
            returns: t || $508a5edf05a9a175$var$ZodUnknown.create(),
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodFunction
        }, $508a5edf05a9a175$var$processCreateParams(r)));
    }, n;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodLazy = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), Object.defineProperty(r.prototype, "schema", {
        get: function() {
            return this._def.getter();
        },
        enumerable: !1,
        configurable: !0
    }), r.prototype._parse = function(e, t, r) {
        return this._def.getter()._parse(e, t, r);
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            getter: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodLazy
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodLiteral = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(e, t, r) {
        return t !== this._def.value ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: this._def.value,
            received: t
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, Object.defineProperty(r.prototype, "value", {
        get: function() {
            return this._def.value;
        },
        enumerable: !1,
        configurable: !0
    }), r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            value: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodLiteral
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType);
function $508a5edf05a9a175$var$createZodEnum(e) {
    return new $508a5edf05a9a175$var$ZodEnum({
        values: e,
        typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodEnum
    });
}
var $508a5edf05a9a175$var$ZodFirstPartyTypeKind, $508a5edf05a9a175$var$ZodEnum = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return -1 === this._def.values.indexOf(t) ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_enum_value,
            options: this._def.values
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, Object.defineProperty(t.prototype, "options", {
        get: function() {
            return this._def.values;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "enum", {
        get: function() {
            var t, e, r = {};
            try {
                for(var n = $508a5edf05a9a175$var$__values(this._def.values), o = n.next(); !o.done; o = n.next()){
                    var a = o.value;
                    r[a] = a;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    o && !o.done && (e = n.return) && e.call(n);
                } finally{
                    if (t) throw t.error;
                }
            }
            return r;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "Values", {
        get: function() {
            var t, e, r = {};
            try {
                for(var n = $508a5edf05a9a175$var$__values(this._def.values), o = n.next(); !o.done; o = n.next()){
                    var a = o.value;
                    r[a] = a;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    o && !o.done && (e = n.return) && e.call(n);
                } finally{
                    if (t) throw t.error;
                }
            }
            return r;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "Enum", {
        get: function() {
            var t, e, r = {};
            try {
                for(var n = $508a5edf05a9a175$var$__values(this._def.values), o = n.next(); !o.done; o = n.next()){
                    var a = o.value;
                    r[a] = a;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    o && !o.done && (e = n.return) && e.call(n);
                } finally{
                    if (t) throw t.error;
                }
            }
            return r;
        },
        enumerable: !1,
        configurable: !0
    }), t.create = $508a5edf05a9a175$var$createZodEnum, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodNativeEnum = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(e, t, r) {
        var n = $508a5edf05a9a175$var$util.getValidEnumValues(this._def.values);
        return -1 === n.indexOf(t) ? (this.addIssue(e, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_enum_value,
            options: $508a5edf05a9a175$var$util.objectValues(n)
        }, {
            data: t
        }), $508a5edf05a9a175$var$INVALID) : $508a5edf05a9a175$var$OK(t);
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            values: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodNativeEnum
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodPromise = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(t, e, r) {
        var n = this;
        if (r !== $508a5edf05a9a175$var$ZodParsedType.promise && !1 === t.async) return this.addIssue(t, {
            code: $508a5edf05a9a175$var$ZodIssueCode.invalid_type,
            expected: $508a5edf05a9a175$var$ZodParsedType.promise,
            received: r
        }, {
            data: e
        }), $508a5edf05a9a175$var$INVALID;
        e = r === $508a5edf05a9a175$var$ZodParsedType.promise ? e : Promise.resolve(e);
        return $508a5edf05a9a175$var$OK(e.then(function(e) {
            return n._def.type.parseAsync(e, {
                path: $508a5edf05a9a175$var$pathToArray(t.path),
                errorMap: t.errorMap
            });
        }));
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            type: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodPromise
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodEffects = function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(n, e), n.prototype.innerType = function() {
        return this._def.schema;
    }, n.prototype._parse = function(t, e, r) {
        var n = this, o = !1 === t.async, a = this._def.effect || null, i = e, r = r;
        if ("preprocess" === a.type) {
            var s = a.transform(e);
            if (t.async) return Promise.resolve(s).then(function(e) {
                return n._def.schema._parseAsync(t, e, $508a5edf05a9a175$var$getParsedType(e));
            });
            if ((s = this._def.schema._parseSync(t, s, $508a5edf05a9a175$var$getParsedType(s))) instanceof Promise) throw new Error("Asynchronous preprocess step encountered during synchronous parse operation. Use .parseAsync instead.");
            return s;
        }
        if ("refinement" === a.type) {
            function u(e, t) {
                t = t.refinement(e, c);
                if (t instanceof Promise) {
                    if (o) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                    return t.then(function() {
                        return e;
                    });
                }
                return e;
            }
            var d = !1, c = {
                addIssue: function(e) {
                    d = !0, n.addIssue(t, e, {
                        data: i
                    });
                },
                get path () {
                    return $508a5edf05a9a175$var$pathToArray(t.path);
                }
            };
            if (c.addIssue = c.addIssue.bind(c), o) {
                var p = this._def.schema._parseSync(t, i, r);
                if ($508a5edf05a9a175$var$isInvalid(p)) return $508a5edf05a9a175$var$INVALID;
                s = u(p.value, a);
                return d ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(s);
            }
            return this._def.schema._parseAsync(t, i, r).then(function(e) {
                return $508a5edf05a9a175$var$isInvalid(e) ? $508a5edf05a9a175$var$INVALID : u(e.value, a);
            }).then(function(e) {
                return d ? $508a5edf05a9a175$var$INVALID : $508a5edf05a9a175$var$OK(e);
            });
        }
        if ("transform" === a.type) {
            function l(e, t) {
                e = t.transform(e);
                if (e instanceof Promise && o) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                return e;
            }
            if (o) {
                p = this._def.schema._parseSync(t, i, r);
                if ($508a5edf05a9a175$var$isInvalid(p)) return $508a5edf05a9a175$var$INVALID;
                s = l(p.value, a);
                return $508a5edf05a9a175$var$OK(s);
            }
            return this._def.schema._parseAsync(t, i, r).then(function(e) {
                return $508a5edf05a9a175$var$isInvalid(e) ? $508a5edf05a9a175$var$INVALID : l(e.value, a);
            }).then(function(e) {
                return $508a5edf05a9a175$var$OK(e);
            });
        }
        $508a5edf05a9a175$var$util.assertNever(a);
    }, n.create = function(e, t, r) {
        return new n($508a5edf05a9a175$var$__assign({
            schema: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodEffects,
            effect: t
        }, $508a5edf05a9a175$var$processCreateParams(r)));
    }, n.createWithPreprocess = function(e, t, r) {
        return new n($508a5edf05a9a175$var$__assign({
            schema: t,
            effect: {
                type: "preprocess",
                transform: e
            },
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodEffects
        }, $508a5edf05a9a175$var$processCreateParams(r)));
    }, n;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodOptional = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(e, t, r) {
        return r === $508a5edf05a9a175$var$ZodParsedType.undefined ? $508a5edf05a9a175$var$OK(void 0) : this._def.innerType._parse(e, t, r);
    }, r.prototype.unwrap = function() {
        return this._def.innerType;
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            innerType: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodOptional
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodNullable = function(e) {
    function r() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(r, e), r.prototype._parse = function(e, t, r) {
        return r === $508a5edf05a9a175$var$ZodParsedType.null ? $508a5edf05a9a175$var$OK(null) : this._def.innerType._parse(e, t, r);
    }, r.prototype.unwrap = function() {
        return this._def.innerType;
    }, r.create = function(e, t) {
        return new r($508a5edf05a9a175$var$__assign({
            innerType: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodNullable
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, r;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$ZodDefault = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $508a5edf05a9a175$var$__extends(t, e), t.prototype._parse = function(e, t, r) {
        return r === $508a5edf05a9a175$var$ZodParsedType.undefined && (t = this._def.defaultValue()), this._def.innerType._parse(e, t, $508a5edf05a9a175$var$getParsedType(t));
    }, t.prototype.removeDefault = function() {
        return this._def.innerType;
    }, t.create = function(e, t) {
        return new $508a5edf05a9a175$var$ZodOptional($508a5edf05a9a175$var$__assign({
            innerType: e,
            typeName: $508a5edf05a9a175$var$ZodFirstPartyTypeKind.ZodOptional
        }, $508a5edf05a9a175$var$processCreateParams(t)));
    }, t;
}($508a5edf05a9a175$var$ZodType), $508a5edf05a9a175$var$custom = function(e, t) {
    return e ? $508a5edf05a9a175$var$ZodAny.create().refine(e, t) : $508a5edf05a9a175$var$ZodAny.create();
}, $508a5edf05a9a175$var$late = {
    object: $508a5edf05a9a175$var$ZodObject.lazycreate
};
!function(e) {
    e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodPromise = "ZodPromise";
}($508a5edf05a9a175$var$ZodFirstPartyTypeKind = $508a5edf05a9a175$var$ZodFirstPartyTypeKind || {});
var $508a5edf05a9a175$var$instanceOfType = function(t, e) {
    return void 0 === e && (e = {
        message: "Input not instance of " + t.name
    }), $508a5edf05a9a175$var$custom(function(e) {
        return e instanceof t;
    }, e);
}, $508a5edf05a9a175$var$stringType = $508a5edf05a9a175$var$ZodString.create, $508a5edf05a9a175$var$numberType = $508a5edf05a9a175$var$ZodNumber.create, $508a5edf05a9a175$var$bigIntType = $508a5edf05a9a175$var$ZodBigInt.create, $508a5edf05a9a175$var$booleanType = $508a5edf05a9a175$var$ZodBoolean.create, $508a5edf05a9a175$var$dateType = $508a5edf05a9a175$var$ZodDate.create, $508a5edf05a9a175$var$undefinedType = $508a5edf05a9a175$var$ZodUndefined.create, $508a5edf05a9a175$var$nullType = $508a5edf05a9a175$var$ZodNull.create, $508a5edf05a9a175$var$anyType = $508a5edf05a9a175$var$ZodAny.create, $508a5edf05a9a175$var$unknownType = $508a5edf05a9a175$var$ZodUnknown.create, $508a5edf05a9a175$var$neverType = $508a5edf05a9a175$var$ZodNever.create, $508a5edf05a9a175$var$voidType = $508a5edf05a9a175$var$ZodVoid.create, $508a5edf05a9a175$var$arrayType = $508a5edf05a9a175$var$ZodArray.create, $508a5edf05a9a175$var$objectType = $508a5edf05a9a175$var$ZodObject.create, $508a5edf05a9a175$var$strictObjectType = $508a5edf05a9a175$var$ZodObject.strictCreate, $508a5edf05a9a175$var$unionType = $508a5edf05a9a175$var$ZodUnion.create, $508a5edf05a9a175$var$intersectionType = $508a5edf05a9a175$var$ZodIntersection.create, $508a5edf05a9a175$var$tupleType = $508a5edf05a9a175$var$ZodTuple.create, $508a5edf05a9a175$var$recordType = $508a5edf05a9a175$var$ZodRecord.create, $508a5edf05a9a175$var$mapType = $508a5edf05a9a175$var$ZodMap.create, $508a5edf05a9a175$var$setType = $508a5edf05a9a175$var$ZodSet.create, $508a5edf05a9a175$var$functionType = $508a5edf05a9a175$var$ZodFunction.create, $508a5edf05a9a175$var$lazyType = $508a5edf05a9a175$var$ZodLazy.create, $508a5edf05a9a175$var$literalType = $508a5edf05a9a175$var$ZodLiteral.create, $508a5edf05a9a175$var$enumType = $508a5edf05a9a175$var$ZodEnum.create, $508a5edf05a9a175$var$nativeEnumType = $508a5edf05a9a175$var$ZodNativeEnum.create, $508a5edf05a9a175$var$promiseType = $508a5edf05a9a175$var$ZodPromise.create, $508a5edf05a9a175$var$effectsType = $508a5edf05a9a175$var$ZodEffects.create, $508a5edf05a9a175$var$optionalType = $508a5edf05a9a175$var$ZodOptional.create, $508a5edf05a9a175$var$nullableType = $508a5edf05a9a175$var$ZodNullable.create, $508a5edf05a9a175$var$preprocessType = $508a5edf05a9a175$var$ZodEffects.createWithPreprocess, $508a5edf05a9a175$var$ostring = function() {
    return $508a5edf05a9a175$var$stringType().optional();
}, $508a5edf05a9a175$var$onumber = function() {
    return $508a5edf05a9a175$var$numberType().optional();
}, $508a5edf05a9a175$var$oboolean = function() {
    return $508a5edf05a9a175$var$booleanType().optional();
};
Object.freeze({
    __proto__: null,
    ZodParsedType: $508a5edf05a9a175$var$ZodParsedType,
    getParsedType: $508a5edf05a9a175$var$getParsedType,
    makeIssue: $508a5edf05a9a175$var$makeIssue,
    EMPTY_PATH: $508a5edf05a9a175$var$EMPTY_PATH,
    pathToArray: $508a5edf05a9a175$var$pathToArray,
    pathFromArray: $508a5edf05a9a175$var$pathFromArray,
    ParseContext: $508a5edf05a9a175$var$ParseContext,
    INVALID: $508a5edf05a9a175$var$INVALID,
    OK: $508a5edf05a9a175$var$OK,
    isInvalid: $508a5edf05a9a175$var$isInvalid,
    isOk: $508a5edf05a9a175$var$isOk,
    isAsync: $508a5edf05a9a175$var$isAsync,
    ZodType: $508a5edf05a9a175$var$ZodType,
    ZodString: $508a5edf05a9a175$var$ZodString,
    ZodNumber: $508a5edf05a9a175$var$ZodNumber,
    ZodBigInt: $508a5edf05a9a175$var$ZodBigInt,
    ZodBoolean: $508a5edf05a9a175$var$ZodBoolean,
    ZodDate: $508a5edf05a9a175$var$ZodDate,
    ZodUndefined: $508a5edf05a9a175$var$ZodUndefined,
    ZodNull: $508a5edf05a9a175$var$ZodNull,
    ZodAny: $508a5edf05a9a175$var$ZodAny,
    ZodUnknown: $508a5edf05a9a175$var$ZodUnknown,
    ZodNever: $508a5edf05a9a175$var$ZodNever,
    ZodVoid: $508a5edf05a9a175$var$ZodVoid,
    ZodArray: $508a5edf05a9a175$var$ZodArray,
    get objectUtil () {
        return $508a5edf05a9a175$var$objectUtil;
    },
    mergeObjects: $508a5edf05a9a175$var$mergeObjects,
    ZodObject: $508a5edf05a9a175$var$ZodObject,
    ZodUnion: $508a5edf05a9a175$var$ZodUnion,
    ZodIntersection: $508a5edf05a9a175$var$ZodIntersection,
    ZodTuple: $508a5edf05a9a175$var$ZodTuple,
    ZodRecord: $508a5edf05a9a175$var$ZodRecord,
    ZodMap: $508a5edf05a9a175$var$ZodMap,
    ZodSet: $508a5edf05a9a175$var$ZodSet,
    ZodFunction: $508a5edf05a9a175$var$ZodFunction,
    ZodLazy: $508a5edf05a9a175$var$ZodLazy,
    ZodLiteral: $508a5edf05a9a175$var$ZodLiteral,
    ZodEnum: $508a5edf05a9a175$var$ZodEnum,
    ZodNativeEnum: $508a5edf05a9a175$var$ZodNativeEnum,
    ZodPromise: $508a5edf05a9a175$var$ZodPromise,
    ZodEffects: $508a5edf05a9a175$var$ZodEffects,
    ZodTransformer: $508a5edf05a9a175$var$ZodEffects,
    ZodOptional: $508a5edf05a9a175$var$ZodOptional,
    ZodNullable: $508a5edf05a9a175$var$ZodNullable,
    ZodDefault: $508a5edf05a9a175$var$ZodDefault,
    custom: $508a5edf05a9a175$var$custom,
    Schema: $508a5edf05a9a175$var$ZodType,
    ZodSchema: $508a5edf05a9a175$var$ZodType,
    late: $508a5edf05a9a175$var$late,
    get ZodFirstPartyTypeKind () {
        return $508a5edf05a9a175$var$ZodFirstPartyTypeKind;
    },
    any: $508a5edf05a9a175$var$anyType,
    array: $508a5edf05a9a175$var$arrayType,
    bigint: $508a5edf05a9a175$var$bigIntType,
    boolean: $508a5edf05a9a175$var$booleanType,
    date: $508a5edf05a9a175$var$dateType,
    effect: $508a5edf05a9a175$var$effectsType,
    enum: $508a5edf05a9a175$var$enumType,
    function: $508a5edf05a9a175$var$functionType,
    instanceof: $508a5edf05a9a175$var$instanceOfType,
    intersection: $508a5edf05a9a175$var$intersectionType,
    lazy: $508a5edf05a9a175$var$lazyType,
    literal: $508a5edf05a9a175$var$literalType,
    map: $508a5edf05a9a175$var$mapType,
    nativeEnum: $508a5edf05a9a175$var$nativeEnumType,
    never: $508a5edf05a9a175$var$neverType,
    null: $508a5edf05a9a175$var$nullType,
    nullable: $508a5edf05a9a175$var$nullableType,
    number: $508a5edf05a9a175$var$numberType,
    object: $508a5edf05a9a175$var$objectType,
    oboolean: $508a5edf05a9a175$var$oboolean,
    onumber: $508a5edf05a9a175$var$onumber,
    optional: $508a5edf05a9a175$var$optionalType,
    ostring: $508a5edf05a9a175$var$ostring,
    preprocess: $508a5edf05a9a175$var$preprocessType,
    promise: $508a5edf05a9a175$var$promiseType,
    record: $508a5edf05a9a175$var$recordType,
    set: $508a5edf05a9a175$var$setType,
    strictObject: $508a5edf05a9a175$var$strictObjectType,
    string: $508a5edf05a9a175$var$stringType,
    transformer: $508a5edf05a9a175$var$effectsType,
    tuple: $508a5edf05a9a175$var$tupleType,
    undefined: $508a5edf05a9a175$var$undefinedType,
    union: $508a5edf05a9a175$var$unionType,
    unknown: $508a5edf05a9a175$var$unknownType,
    void: $508a5edf05a9a175$var$voidType,
    ZodIssueCode: $508a5edf05a9a175$var$ZodIssueCode,
    quotelessJson: $508a5edf05a9a175$var$quotelessJson,
    ZodError: $508a5edf05a9a175$var$ZodError,
    defaultErrorMap: $508a5edf05a9a175$var$defaultErrorMap,
    get overrideErrorMap () {
        return $508a5edf05a9a175$var$overrideErrorMap;
    },
    setErrorMap: $508a5edf05a9a175$var$setErrorMap
});
/**
 * Context: Due to Discord supporting more than 32 permissions, permission calculation has become more complicated than naive
 * bit operations on `number`s. To support this generically, we have created BigFlagUtils to work with bit-flags greater
 * than 32-bits in size.
 *
 * Ideally, we would like to use BigInt, which is pretty efficient, but some JavaScript engines do not support it.
 *
 * This file is intended to be a set of lower-level operators that act directly on "BigFlags".
 *
 * If you're working with permissions, in most cases you can probably use PermissionUtils.
 */ const $508a5edf05a9a175$var$MAX_BIG_INT = 64;
const $508a5edf05a9a175$var$SMALL_INT = 16;
const $508a5edf05a9a175$var$PARTS = $508a5edf05a9a175$var$MAX_BIG_INT / $508a5edf05a9a175$var$SMALL_INT;
function $508a5edf05a9a175$var$checkBrowserSupportsBigInt() {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        BigInt;
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Takes the sliced output of `toHexReverseArray` and converts hex to decimal.
 */ function $508a5edf05a9a175$var$fromHexReverseArray(hexValues, start, size) {
    let value = 0;
    for(let i = 0; i < size; i++){
        const byte = hexValues[start + i];
        if (byte === undefined) break;
        value += byte * Math.pow(16, i);
    }
    return value;
}
/**
 * Converts a number string to array of hex bytes based on the implementation found at
 * https://stackoverflow.com/questions/18626844/convert-a-large-integer-to-a-hex-string-in-javascript
 *
 * To avoid extra allocations it returns the values in reverse.
 */ function $508a5edf05a9a175$var$toHexReverseArray(value) {
    const sum = [];
    for(let i = 0; i < value.length; i++){
        let s = Number(value[i]);
        for(let j = 0; s || j < sum.length; j++){
            s += (sum[j] || 0) * 10;
            sum[j] = s % 16;
            s = (s - sum[j]) / 16;
        }
    }
    return sum;
}
/**
 * Splits a big integers into array of small integers to perform fast bitwise operations.
 */ function $508a5edf05a9a175$var$splitBigInt(value) {
    const sum = $508a5edf05a9a175$var$toHexReverseArray(value);
    const parts = Array($508a5edf05a9a175$var$PARTS);
    for(let i = 0; i < $508a5edf05a9a175$var$PARTS; i++)// Highest bits to lowest bits.
    parts[$508a5edf05a9a175$var$PARTS - 1 - i] = $508a5edf05a9a175$var$fromHexReverseArray(sum, i * $508a5edf05a9a175$var$PARTS, $508a5edf05a9a175$var$PARTS);
    return parts;
}
class $508a5edf05a9a175$var$HighLow {
    constructor(parts, str){
        this.parts = parts;
        this.str = str;
    }
    static fromString(value) {
        return new $508a5edf05a9a175$var$HighLow($508a5edf05a9a175$var$splitBigInt(value), value);
    }
    static fromBit(index) {
        const parts = Array($508a5edf05a9a175$var$PARTS);
        const offset = Math.floor(index / $508a5edf05a9a175$var$SMALL_INT);
        for(let i = 0; i < $508a5edf05a9a175$var$PARTS; i++)// Highest bits to lowest bits.
        parts[$508a5edf05a9a175$var$PARTS - 1 - i] = i === offset ? 1 << index - offset * $508a5edf05a9a175$var$SMALL_INT : 0;
        return new $508a5edf05a9a175$var$HighLow(parts);
    }
    and({ parts: parts  }) {
        return new $508a5edf05a9a175$var$HighLow(this.parts.map((v, i)=>v & parts[i]));
    }
    or({ parts: parts  }) {
        return new $508a5edf05a9a175$var$HighLow(this.parts.map((v, i)=>v | parts[i]));
    }
    xor({ parts: parts  }) {
        return new $508a5edf05a9a175$var$HighLow(this.parts.map((v, i)=>v ^ parts[i]));
    }
    not() {
        return new $508a5edf05a9a175$var$HighLow(this.parts.map((v)=>~v));
    }
    equals({ parts: parts  }) {
        return this.parts.every((v, i)=>v === parts[i]);
    }
    /**
     * For the average case the string representation is provided, but
     * when we need to convert high and low to string we just let the
     * slower big-integer library do it.
     */ toString() {
        if (this.str != null) return this.str;
        const array = new Array($508a5edf05a9a175$var$MAX_BIG_INT / 4);
        this.parts.forEach((value, offset)=>{
            const hex = $508a5edf05a9a175$var$toHexReverseArray(value.toString());
            for(let i = 0; i < 4; i++)array[i + offset * 4] = hex[3 - i] || 0;
        });
        return this.str = $508a5edf05a9a175$var$bigInt.fromArray(array, 16).toString();
    }
    toJSON() {
        return this.toString();
    }
}
const $508a5edf05a9a175$var$SUPPORTS_BIGINT = $508a5edf05a9a175$var$checkBrowserSupportsBigInt();
// Polyfill toJSON on BigInt if necessary.
if ($508a5edf05a9a175$var$SUPPORTS_BIGINT && BigInt.prototype.toJSON == null) BigInt.prototype.toJSON = function() {
    return this.toString();
};
const $508a5edf05a9a175$var$HIGH_LOW_CACHE = {};
const $508a5edf05a9a175$var$convertToBigFlag = $508a5edf05a9a175$var$SUPPORTS_BIGINT ? function convertToBigFlagBigInt(value) {
    return BigInt(value);
} : function convertToBigFlagHighLow(value) {
    if (value instanceof $508a5edf05a9a175$var$HighLow) return value;
    if (typeof value === "number") value = value.toString();
    // These type assertions are ugly, but there doesn't seem to be a
    // runtime costless way to do a type assertion above.
    if ($508a5edf05a9a175$var$HIGH_LOW_CACHE[value] != null) return $508a5edf05a9a175$var$HIGH_LOW_CACHE[value];
    $508a5edf05a9a175$var$HIGH_LOW_CACHE[value] = $508a5edf05a9a175$var$HighLow.fromString(value);
    return $508a5edf05a9a175$var$HIGH_LOW_CACHE[value];
};
const $508a5edf05a9a175$var$EMPTY_FLAG = $508a5edf05a9a175$var$convertToBigFlag(0);
const $508a5edf05a9a175$var$flagAnd = $508a5edf05a9a175$var$SUPPORTS_BIGINT ? function flagAndBigInt(first = $508a5edf05a9a175$var$EMPTY_FLAG, second = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return first & second;
} : function flagAndHighLow(first = $508a5edf05a9a175$var$EMPTY_FLAG, second = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return first.and(second);
};
const $508a5edf05a9a175$var$flagOr = $508a5edf05a9a175$var$SUPPORTS_BIGINT ? function flagOrBigInt(first = $508a5edf05a9a175$var$EMPTY_FLAG, second = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return first | second;
} : function flagOrHighLow(first = $508a5edf05a9a175$var$EMPTY_FLAG, second = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return first.or(second);
};
const $508a5edf05a9a175$var$flagXor = $508a5edf05a9a175$var$SUPPORTS_BIGINT ? function flagXorBigInt(first = $508a5edf05a9a175$var$EMPTY_FLAG, second = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return first ^ second;
} : function flagXorHighLow(first = $508a5edf05a9a175$var$EMPTY_FLAG, second = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return first.xor(second);
};
const $508a5edf05a9a175$var$flagNot = $508a5edf05a9a175$var$SUPPORTS_BIGINT ? function flagNotBigInt(first = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return ~first;
} : function flagNotHighLow(first = $508a5edf05a9a175$var$EMPTY_FLAG) {
    return first.not();
};
const $508a5edf05a9a175$var$flagEquals = $508a5edf05a9a175$var$SUPPORTS_BIGINT ? function flagEqualsBigInt(first, second) {
    return first === second;
} : function flagEqualsHighLow(first, second) {
    if (first == null || second == null) // eslint-disable-next-line eqeqeq
    return first == second;
    return first.equals(second);
};
function $508a5edf05a9a175$var$flagOrMultiple(...flags) {
    let result = flags[0];
    for(let i = 1; i < flags.length; i++)result = $508a5edf05a9a175$var$flagOr(result, flags[i]);
    return result;
}
function $508a5edf05a9a175$var$flagHas(base, flag) {
    return $508a5edf05a9a175$var$flagEquals($508a5edf05a9a175$var$flagAnd(base, flag), flag);
}
function $508a5edf05a9a175$var$flagHasAny(base, flag) {
    return !$508a5edf05a9a175$var$flagEquals($508a5edf05a9a175$var$flagAnd(base, flag), $508a5edf05a9a175$var$EMPTY_FLAG);
}
function $508a5edf05a9a175$var$flagAdd(base, flag) {
    return flag === $508a5edf05a9a175$var$EMPTY_FLAG ? base : $508a5edf05a9a175$var$flagOr(base, flag);
}
function $508a5edf05a9a175$var$flagRemove(base, flag) {
    return flag === $508a5edf05a9a175$var$EMPTY_FLAG ? base : $508a5edf05a9a175$var$flagXor(base, $508a5edf05a9a175$var$flagAnd(base, flag));
}
const $508a5edf05a9a175$var$getFlag = $508a5edf05a9a175$var$SUPPORTS_BIGINT ? function getFlagBigInt(index) {
    return BigInt(1) << BigInt(index);
} : function getFlagHighLow(index) {
    return $508a5edf05a9a175$var$HighLow.fromBit(index);
};
var $508a5edf05a9a175$var$BigFlagUtils = {
    combine: $508a5edf05a9a175$var$flagOrMultiple,
    add: $508a5edf05a9a175$var$flagAdd,
    remove: $508a5edf05a9a175$var$flagRemove,
    filter: $508a5edf05a9a175$var$flagAnd,
    invert: $508a5edf05a9a175$var$flagNot,
    has: $508a5edf05a9a175$var$flagHas,
    hasAny: $508a5edf05a9a175$var$flagHasAny,
    equals: $508a5edf05a9a175$var$flagEquals,
    deserialize: $508a5edf05a9a175$var$convertToBigFlag,
    getFlag: $508a5edf05a9a175$var$getFlag
};
$508a5edf05a9a175$exports.RPCCloseCodes = void 0;
(function(RPCCloseCodes) {
    RPCCloseCodes[RPCCloseCodes["CLOSE_NORMAL"] = 1000] = "CLOSE_NORMAL";
    RPCCloseCodes[RPCCloseCodes["CLOSE_UNSUPPORTED"] = 1003] = "CLOSE_UNSUPPORTED";
    RPCCloseCodes[RPCCloseCodes["CLOSE_ABNORMAL"] = 1006] = "CLOSE_ABNORMAL";
    RPCCloseCodes[RPCCloseCodes["INVALID_CLIENTID"] = 4000] = "INVALID_CLIENTID";
    RPCCloseCodes[RPCCloseCodes["INVALID_ORIGIN"] = 4001] = "INVALID_ORIGIN";
    RPCCloseCodes[RPCCloseCodes["RATELIMITED"] = 4002] = "RATELIMITED";
    RPCCloseCodes[RPCCloseCodes["TOKEN_REVOKED"] = 4003] = "TOKEN_REVOKED";
    RPCCloseCodes[RPCCloseCodes["INVALID_VERSION"] = 4004] = "INVALID_VERSION";
    RPCCloseCodes[RPCCloseCodes["INVALID_ENCODING"] = 4005] = "INVALID_ENCODING";
})($508a5edf05a9a175$exports.RPCCloseCodes || ($508a5edf05a9a175$exports.RPCCloseCodes = {}));
$508a5edf05a9a175$exports.RPCErrorCodes = void 0;
(function(RPCErrorCodes) {
    RPCErrorCodes[RPCErrorCodes["INVALID_PAYLOAD"] = 4000] = "INVALID_PAYLOAD";
    RPCErrorCodes[RPCErrorCodes["INVALID_COMMAND"] = 4002] = "INVALID_COMMAND";
    RPCErrorCodes[RPCErrorCodes["INVALID_EVENT"] = 4004] = "INVALID_EVENT";
    RPCErrorCodes[RPCErrorCodes["INVALID_PERMISSIONS"] = 4006] = "INVALID_PERMISSIONS";
})($508a5edf05a9a175$exports.RPCErrorCodes || ($508a5edf05a9a175$exports.RPCErrorCodes = {}));
/**
 * @deprecated use OrientationTypeObject instead
 */ $508a5edf05a9a175$exports.Orientation = void 0;
(function(Orientation) {
    Orientation["LANDSCAPE"] = "landscape";
    Orientation["PORTRAIT"] = "portrait";
})($508a5edf05a9a175$exports.Orientation || ($508a5edf05a9a175$exports.Orientation = {}));
$508a5edf05a9a175$exports.Platform = void 0;
(function(Platform) {
    Platform["MOBILE"] = "mobile";
    Platform["DESKTOP"] = "desktop";
})($508a5edf05a9a175$exports.Platform || ($508a5edf05a9a175$exports.Platform = {}));
const $508a5edf05a9a175$var$Permissions = Object.freeze({
    CREATE_INSTANT_INVITE: $508a5edf05a9a175$var$BigFlagUtils.getFlag(0)
});
/**
 * This is a helper function which coerces an unsupported arg value to the key/value UNHANDLED: -1
 * This is necessary to handle a scenario where a new enum value is added in the Discord Client,
 * so that the sdk will not throw an error when given a (newly) valid enum value.
 *
 * To remove the requirement for consumers of this sdk to import an enum when parsing data,
 * we instead use an object cast as const (readonly). This maintains parity with the previous
 * schema (which used zod.enum), and behaves more like a union type, i.e. 'foo' | 'bar' | -1
 *
 * @param inputObject This object must include the key/value pair UNHANDLED = -1
 */ function $508a5edf05a9a175$var$zodCoerceUnhandledValue(inputObject) {
    return $508a5edf05a9a175$var$preprocessType((arg)=>{
        var _a;
        const [objectKey] = (_a = Object.entries(inputObject).find(([, value])=>value === arg)) !== null && _a !== void 0 ? _a : [];
        if (arg != null && objectKey === undefined) return inputObject.UNHANDLED;
        return arg;
    }, $508a5edf05a9a175$var$stringType().or($508a5edf05a9a175$var$numberType()));
}
var $508a5edf05a9a175$var$Commands$1;
(function(Commands) {
    Commands["DISPATCH"] = "DISPATCH";
    Commands["AUTHORIZE"] = "AUTHORIZE";
    Commands["AUTHENTICATE"] = "AUTHENTICATE";
    Commands["GET_GUILDS"] = "GET_GUILDS";
    Commands["GET_GUILD"] = "GET_GUILD";
    Commands["GET_CHANNEL"] = "GET_CHANNEL";
    Commands["GET_CHANNELS"] = "GET_CHANNELS";
    Commands["SET_USER_VOICE_SETTINGS"] = "SET_USER_VOICE_SETTINGS";
    Commands["SELECT_VOICE_CHANNEL"] = "SELECT_VOICE_CHANNEL";
    Commands["GET_SELECTED_VOICE_CHANNEL"] = "GET_SELECTED_VOICE_CHANNEL";
    Commands["SELECT_TEXT_CHANNEL"] = "SELECT_TEXT_CHANNEL";
    Commands["GET_VOICE_SETTINGS"] = "GET_VOICE_SETTINGS";
    Commands["SET_VOICE_SETTINGS"] = "SET_VOICE_SETTINGS";
    Commands["SUBSCRIBE"] = "SUBSCRIBE";
    Commands["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    Commands["CAPTURE_SHORTCUT"] = "CAPTURE_SHORTCUT";
    Commands["SET_CERTIFIED_DEVICES"] = "SET_CERTIFIED_DEVICES";
    Commands["SET_ACTIVITY"] = "SET_ACTIVITY";
    Commands["GET_SKUS"] = "GET_SKUS";
    Commands["GET_ENTITLEMENTS"] = "GET_ENTITLEMENTS";
    Commands["START_PURCHASE"] = "START_PURCHASE";
    Commands["START_PREMIUM_PURCHASE"] = "START_PREMIUM_PURCHASE";
    Commands["SET_CONFIG"] = "SET_CONFIG";
    Commands["SEND_ANALYTICS_EVENT"] = "SEND_ANALYTICS_EVENT";
    Commands["USER_SETTINGS_GET_LOCALE"] = "USER_SETTINGS_GET_LOCALE";
    Commands["OPEN_EXTERNAL_LINK"] = "OPEN_EXTERNAL_LINK";
    Commands["ENCOURAGE_HW_ACCELERATION"] = "ENCOURAGE_HW_ACCELERATION";
    Commands["CAPTURE_LOG"] = "CAPTURE_LOG";
    Commands["SET_ORIENTATION_LOCK_STATE"] = "SET_ORIENTATION_LOCK_STATE";
    Commands["OPEN_INVITE_DIALOG"] = "OPEN_INVITE_DIALOG";
    Commands["GET_PLATFORM_BEHAVIORS"] = "GET_PLATFORM_BEHAVIORS";
    Commands["GET_CHANNEL_PERMISSIONS"] = "GET_CHANNEL_PERMISSIONS";
})($508a5edf05a9a175$var$Commands$1 || ($508a5edf05a9a175$var$Commands$1 = {}));
const $508a5edf05a9a175$var$ReceiveFramePayload = $508a5edf05a9a175$var$objectType({
    cmd: $508a5edf05a9a175$var$stringType(),
    data: $508a5edf05a9a175$var$unknownType(),
    evt: $508a5edf05a9a175$var$nullType(),
    nonce: $508a5edf05a9a175$var$stringType()
}).nonstrict();
const $508a5edf05a9a175$var$ScopesObject = {
    UNHANDLED: -1,
    bot: "bot",
    rpc: "rpc",
    identify: "identify",
    connections: "connections",
    email: "email",
    guilds: "guilds",
    "guilds.join": "guilds.join",
    "guilds.members.read": "guilds.members.read",
    "gdm.join": "gdm.join",
    "messages.read": "messages.read",
    "rpc.notifications.read": "rpc.notifications.read",
    "rpc.voice.write": "rpc.voice.write",
    "rpc.voice.read": "rpc.voice.read",
    "rpc.activities.write": "rpc.activities.write",
    "webhook.incoming": "webhook.incoming",
    "applications.builds.upload": "applications.builds.upload",
    "applications.builds.read": "applications.builds.read",
    "applications.store.update": "applications.store.update",
    "applications.entitlements": "applications.entitlements",
    "relationships.read": "relationships.read",
    "activities.read": "activities.read",
    "activities.write": "activities.write"
};
const $508a5edf05a9a175$var$Scopes = $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$ScopesObject);
const $508a5edf05a9a175$var$User = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    username: $508a5edf05a9a175$var$stringType(),
    discriminator: $508a5edf05a9a175$var$stringType(),
    avatar: $508a5edf05a9a175$var$stringType().optional().nullable(),
    publicFlags: $508a5edf05a9a175$var$numberType().optional().nullable()
});
const $508a5edf05a9a175$var$GuildMember = $508a5edf05a9a175$var$objectType({
    user: $508a5edf05a9a175$var$User,
    nick: $508a5edf05a9a175$var$stringType().optional().nullable(),
    roles: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$stringType()),
    joined_at: $508a5edf05a9a175$var$stringType(),
    deaf: $508a5edf05a9a175$var$booleanType(),
    mute: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$Emoji = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    name: $508a5edf05a9a175$var$stringType().optional().nullable(),
    roles: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$stringType()).optional().nullable(),
    user: $508a5edf05a9a175$var$User.optional().nullable(),
    require_colons: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    managed: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    animated: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    available: $508a5edf05a9a175$var$booleanType().optional().nullable()
});
const $508a5edf05a9a175$var$VoiceState = $508a5edf05a9a175$var$objectType({
    mute: $508a5edf05a9a175$var$booleanType(),
    deaf: $508a5edf05a9a175$var$booleanType(),
    self_mute: $508a5edf05a9a175$var$booleanType(),
    self_deaf: $508a5edf05a9a175$var$booleanType(),
    suppress: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$UserVoiceState = $508a5edf05a9a175$var$objectType({
    mute: $508a5edf05a9a175$var$booleanType(),
    nick: $508a5edf05a9a175$var$stringType(),
    user: $508a5edf05a9a175$var$User,
    voice_state: $508a5edf05a9a175$var$VoiceState,
    volume: $508a5edf05a9a175$var$numberType()
});
const $508a5edf05a9a175$var$StatusObject = {
    UNHANDLED: -1,
    IDLE: "idle",
    DND: "dnd",
    ONLINE: "online",
    OFFLINE: "offline"
};
const $508a5edf05a9a175$var$Status = $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$StatusObject);
const $508a5edf05a9a175$var$Activity = $508a5edf05a9a175$var$objectType({
    name: $508a5edf05a9a175$var$stringType(),
    type: $508a5edf05a9a175$var$numberType(),
    url: $508a5edf05a9a175$var$stringType().optional().nullable(),
    created_at: $508a5edf05a9a175$var$numberType().optional().nullable(),
    timestamps: $508a5edf05a9a175$var$objectType({
        start: $508a5edf05a9a175$var$numberType(),
        end: $508a5edf05a9a175$var$numberType()
    }).partial().optional().nullable(),
    application_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    details: $508a5edf05a9a175$var$stringType().optional().nullable(),
    state: $508a5edf05a9a175$var$stringType().optional().nullable(),
    emoji: $508a5edf05a9a175$var$Emoji.optional().nullable(),
    party: $508a5edf05a9a175$var$objectType({
        id: $508a5edf05a9a175$var$stringType().optional().nullable(),
        size: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$numberType()).optional().nullable()
    }).optional().nullable(),
    assets: $508a5edf05a9a175$var$objectType({
        large_image: $508a5edf05a9a175$var$stringType().nullable(),
        large_text: $508a5edf05a9a175$var$stringType().nullable(),
        small_image: $508a5edf05a9a175$var$stringType().nullable(),
        small_text: $508a5edf05a9a175$var$stringType().nullable()
    }).partial().optional().nullable(),
    secrets: $508a5edf05a9a175$var$objectType({
        join: $508a5edf05a9a175$var$stringType(),
        match: $508a5edf05a9a175$var$stringType()
    }).partial().optional().nullable(),
    instance: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    flags: $508a5edf05a9a175$var$numberType().optional().nullable()
});
const $508a5edf05a9a175$var$PermissionOverwriteTypeObject = {
    UNHANDLED: -1,
    ROLE: 0,
    MEMBER: 1
};
const $508a5edf05a9a175$var$PermissionOverwrite = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$PermissionOverwriteTypeObject),
    allow: $508a5edf05a9a175$var$stringType(),
    deny: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$ChannelTypesObject = {
    UNHANDLED: -1,
    DM: 1,
    GROUP_DM: 3,
    GUILD_TEXT: 0,
    GUILD_VOICE: 2,
    GUILD_CATEGORY: 4,
    GUILD_ANNOUNCEMENT: 5,
    GUILD_STORE: 6,
    ANNOUNCEMENT_THREAD: 10,
    PUBLIC_THREAD: 11,
    PRIVATE_THREAD: 12,
    GUILD_STAGE_VOICE: 13,
    GUILD_DIRECTORY: 14,
    GUILD_FORUM: 15
};
const $508a5edf05a9a175$var$Channel = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$ChannelTypesObject),
    guild_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    position: $508a5edf05a9a175$var$numberType().optional().nullable(),
    permission_overwrites: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$PermissionOverwrite).optional().nullable(),
    name: $508a5edf05a9a175$var$stringType().optional().nullable(),
    topic: $508a5edf05a9a175$var$stringType().optional().nullable(),
    nsfw: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    last_message_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    bitrate: $508a5edf05a9a175$var$numberType().optional().nullable(),
    user_limit: $508a5edf05a9a175$var$numberType().optional().nullable(),
    rate_limit_per_user: $508a5edf05a9a175$var$numberType().optional().nullable(),
    recipients: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$User).optional().nullable(),
    icon: $508a5edf05a9a175$var$stringType().optional().nullable(),
    owner_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    application_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    parent_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    last_pin_timestamp: $508a5edf05a9a175$var$stringType().optional().nullable()
});
const $508a5edf05a9a175$var$PresenceUpdate = $508a5edf05a9a175$var$objectType({
    user: $508a5edf05a9a175$var$User,
    guild_id: $508a5edf05a9a175$var$stringType(),
    status: $508a5edf05a9a175$var$Status,
    activities: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Activity),
    client_status: $508a5edf05a9a175$var$objectType({
        desktop: $508a5edf05a9a175$var$Status,
        mobile: $508a5edf05a9a175$var$Status,
        web: $508a5edf05a9a175$var$Status
    }).partial()
});
const $508a5edf05a9a175$var$Role = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    name: $508a5edf05a9a175$var$stringType(),
    color: $508a5edf05a9a175$var$numberType(),
    hoist: $508a5edf05a9a175$var$booleanType(),
    position: $508a5edf05a9a175$var$numberType(),
    permissions: $508a5edf05a9a175$var$stringType(),
    managed: $508a5edf05a9a175$var$booleanType(),
    mentionable: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$Guild = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    name: $508a5edf05a9a175$var$stringType(),
    owner_id: $508a5edf05a9a175$var$stringType(),
    icon: $508a5edf05a9a175$var$stringType().nullable(),
    icon_hash: $508a5edf05a9a175$var$stringType().optional().nullable(),
    splash: $508a5edf05a9a175$var$stringType().nullable(),
    discovery_splash: $508a5edf05a9a175$var$stringType().nullable(),
    owner: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    permissions: $508a5edf05a9a175$var$stringType().optional().nullable(),
    region: $508a5edf05a9a175$var$stringType(),
    afk_channel_id: $508a5edf05a9a175$var$stringType().nullable(),
    afk_timeout: $508a5edf05a9a175$var$numberType(),
    widget_enabled: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    widget_channel_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    verification_level: $508a5edf05a9a175$var$numberType(),
    default_message_notifications: $508a5edf05a9a175$var$numberType(),
    explicit_content_filter: $508a5edf05a9a175$var$numberType(),
    roles: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Role),
    emojis: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Emoji),
    features: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$stringType()),
    mfa_level: $508a5edf05a9a175$var$numberType(),
    application_id: $508a5edf05a9a175$var$stringType().nullable(),
    system_channel_id: $508a5edf05a9a175$var$stringType().nullable(),
    system_channel_flags: $508a5edf05a9a175$var$numberType(),
    rules_channel_id: $508a5edf05a9a175$var$stringType().nullable(),
    joined_at: $508a5edf05a9a175$var$stringType().optional().nullable(),
    large: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    unavailable: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    member_count: $508a5edf05a9a175$var$numberType().optional().nullable(),
    voice_states: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$VoiceState).optional().nullable(),
    members: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$GuildMember).optional().nullable(),
    channels: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Channel).optional().nullable(),
    presences: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$PresenceUpdate).optional().nullable(),
    max_presences: $508a5edf05a9a175$var$numberType().optional().nullable(),
    max_members: $508a5edf05a9a175$var$numberType().optional().nullable(),
    vanity_url_code: $508a5edf05a9a175$var$stringType().nullable(),
    description: $508a5edf05a9a175$var$stringType().nullable(),
    banner: $508a5edf05a9a175$var$stringType().nullable(),
    premium_tier: $508a5edf05a9a175$var$numberType(),
    premium_subscription_count: $508a5edf05a9a175$var$numberType().optional().nullable(),
    preferred_locale: $508a5edf05a9a175$var$stringType(),
    public_updates_channel_id: $508a5edf05a9a175$var$stringType().nullable(),
    max_video_channel_users: $508a5edf05a9a175$var$numberType().optional().nullable(),
    approximate_member_count: $508a5edf05a9a175$var$numberType().optional().nullable(),
    approximate_presence_count: $508a5edf05a9a175$var$numberType().optional().nullable()
});
const $508a5edf05a9a175$var$ChannelMention = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    guild_id: $508a5edf05a9a175$var$stringType(),
    type: $508a5edf05a9a175$var$numberType(),
    name: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$Attachment = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    filename: $508a5edf05a9a175$var$stringType(),
    size: $508a5edf05a9a175$var$numberType(),
    url: $508a5edf05a9a175$var$stringType(),
    proxy_url: $508a5edf05a9a175$var$stringType(),
    height: $508a5edf05a9a175$var$numberType().optional().nullable(),
    width: $508a5edf05a9a175$var$numberType().optional().nullable()
});
const $508a5edf05a9a175$var$EmbedFooter = $508a5edf05a9a175$var$objectType({
    text: $508a5edf05a9a175$var$stringType(),
    icon_url: $508a5edf05a9a175$var$stringType().optional().nullable(),
    proxy_icon_url: $508a5edf05a9a175$var$stringType().optional().nullable()
});
const $508a5edf05a9a175$var$Image = $508a5edf05a9a175$var$objectType({
    url: $508a5edf05a9a175$var$stringType().optional().nullable(),
    proxy_url: $508a5edf05a9a175$var$stringType().optional().nullable(),
    height: $508a5edf05a9a175$var$numberType().optional().nullable(),
    width: $508a5edf05a9a175$var$numberType().optional().nullable()
});
const $508a5edf05a9a175$var$Video = $508a5edf05a9a175$var$Image.omit({
    proxy_url: true
});
const $508a5edf05a9a175$var$EmbedProvider = $508a5edf05a9a175$var$objectType({
    name: $508a5edf05a9a175$var$stringType().optional().nullable(),
    url: $508a5edf05a9a175$var$stringType().optional().nullable()
});
const $508a5edf05a9a175$var$EmbedAuthor = $508a5edf05a9a175$var$objectType({
    name: $508a5edf05a9a175$var$stringType().optional().nullable(),
    url: $508a5edf05a9a175$var$stringType().optional().nullable(),
    icon_url: $508a5edf05a9a175$var$stringType().optional().nullable(),
    proxy_icon_url: $508a5edf05a9a175$var$stringType().optional().nullable()
});
const $508a5edf05a9a175$var$EmbedField = $508a5edf05a9a175$var$objectType({
    name: $508a5edf05a9a175$var$stringType(),
    value: $508a5edf05a9a175$var$stringType(),
    inline: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$Embed = $508a5edf05a9a175$var$objectType({
    title: $508a5edf05a9a175$var$stringType().optional().nullable(),
    type: $508a5edf05a9a175$var$stringType().optional().nullable(),
    description: $508a5edf05a9a175$var$stringType().optional().nullable(),
    url: $508a5edf05a9a175$var$stringType().optional().nullable(),
    timestamp: $508a5edf05a9a175$var$stringType().optional().nullable(),
    color: $508a5edf05a9a175$var$numberType().optional().nullable(),
    footer: $508a5edf05a9a175$var$EmbedFooter.optional().nullable(),
    image: $508a5edf05a9a175$var$Image.optional().nullable(),
    thumbnail: $508a5edf05a9a175$var$Image.optional().nullable(),
    video: $508a5edf05a9a175$var$Video.optional().nullable(),
    provider: $508a5edf05a9a175$var$EmbedProvider.optional().nullable(),
    author: $508a5edf05a9a175$var$EmbedAuthor.optional().nullable(),
    fields: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$EmbedField).optional().nullable()
});
const $508a5edf05a9a175$var$Reaction = $508a5edf05a9a175$var$objectType({
    count: $508a5edf05a9a175$var$numberType(),
    me: $508a5edf05a9a175$var$booleanType(),
    emoji: $508a5edf05a9a175$var$Emoji
});
const $508a5edf05a9a175$var$MessageActivity = $508a5edf05a9a175$var$objectType({
    type: $508a5edf05a9a175$var$numberType(),
    party_id: $508a5edf05a9a175$var$stringType().optional().nullable()
});
const $508a5edf05a9a175$var$MessageApplication = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    cover_image: $508a5edf05a9a175$var$stringType().optional().nullable(),
    description: $508a5edf05a9a175$var$stringType(),
    icon: $508a5edf05a9a175$var$stringType().optional().nullable(),
    name: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$MessageReference = $508a5edf05a9a175$var$objectType({
    message_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    channel_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    guild_id: $508a5edf05a9a175$var$stringType().optional().nullable()
});
const $508a5edf05a9a175$var$Message = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    channel_id: $508a5edf05a9a175$var$stringType(),
    guild_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    author: $508a5edf05a9a175$var$User.optional().nullable(),
    member: $508a5edf05a9a175$var$GuildMember.optional().nullable(),
    content: $508a5edf05a9a175$var$stringType(),
    timestamp: $508a5edf05a9a175$var$stringType(),
    edited_timestamp: $508a5edf05a9a175$var$stringType().optional().nullable(),
    tts: $508a5edf05a9a175$var$booleanType(),
    mention_everyone: $508a5edf05a9a175$var$booleanType(),
    mentions: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$User),
    mention_roles: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$stringType()),
    mention_channels: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$ChannelMention),
    attachments: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Attachment),
    embeds: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Embed),
    reactions: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Reaction).optional().nullable(),
    nonce: $508a5edf05a9a175$var$unionType([
        $508a5edf05a9a175$var$stringType(),
        $508a5edf05a9a175$var$numberType()
    ]).optional().nullable(),
    pinned: $508a5edf05a9a175$var$booleanType(),
    webhook_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    type: $508a5edf05a9a175$var$numberType(),
    activity: $508a5edf05a9a175$var$MessageActivity.optional().nullable(),
    application: $508a5edf05a9a175$var$MessageApplication.optional().nullable(),
    message_reference: $508a5edf05a9a175$var$MessageReference.optional().nullable(),
    flags: $508a5edf05a9a175$var$numberType().optional().nullable(),
    stickers: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$unknownType()).optional().nullable(),
    // Cannot self reference, but this is possibly a Message
    referenced_message: $508a5edf05a9a175$var$unknownType().optional().nullable()
});
const $508a5edf05a9a175$var$VoiceDevice = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    name: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$KeyTypesObject = {
    UNHANDLED: -1,
    KEYBOARD_KEY: 0,
    MOUSE_BUTTON: 1,
    KEYBOARD_MODIFIER_KEY: 2,
    GAMEPAD_BUTTON: 3
};
const $508a5edf05a9a175$var$ShortcutKey = $508a5edf05a9a175$var$objectType({
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$KeyTypesObject),
    code: $508a5edf05a9a175$var$numberType(),
    name: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$VoiceSettingModeTypeObject = {
    UNHANDLED: -1,
    PUSH_TO_TALK: "PUSH_TO_TALK",
    VOICE_ACTIVITY: "VOICE_ACTIVITY"
};
const $508a5edf05a9a175$var$VoiceSettingsMode = $508a5edf05a9a175$var$objectType({
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$VoiceSettingModeTypeObject),
    auto_threshold: $508a5edf05a9a175$var$booleanType(),
    threshold: $508a5edf05a9a175$var$numberType(),
    shortcut: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$ShortcutKey),
    delay: $508a5edf05a9a175$var$numberType()
});
const $508a5edf05a9a175$var$VoiceSettingsIO = $508a5edf05a9a175$var$objectType({
    device_id: $508a5edf05a9a175$var$stringType(),
    volume: $508a5edf05a9a175$var$numberType(),
    available_devices: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$VoiceDevice)
});
const $508a5edf05a9a175$var$CertifiedDeviceTypeObject = {
    UNHANDLED: -1,
    AUDIO_INPUT: "AUDIO_INPUT",
    AUDIO_OUTPUT: "AUDIO_OUTPUT",
    VIDEO_INPUT: "VIDEO_INPUT"
};
const $508a5edf05a9a175$var$CertifiedDevice = $508a5edf05a9a175$var$objectType({
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$CertifiedDeviceTypeObject),
    id: $508a5edf05a9a175$var$stringType(),
    vendor: $508a5edf05a9a175$var$objectType({
        name: $508a5edf05a9a175$var$stringType(),
        url: $508a5edf05a9a175$var$stringType()
    }),
    model: $508a5edf05a9a175$var$objectType({
        name: $508a5edf05a9a175$var$stringType(),
        url: $508a5edf05a9a175$var$stringType()
    }),
    related: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$stringType()),
    echo_cancellation: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    noise_suppression: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    automatic_gain_control: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    hardware_mute: $508a5edf05a9a175$var$booleanType().optional().nullable()
});
const $508a5edf05a9a175$var$SkuTypeObject = {
    UNHANDLED: -1,
    APPLICATION: 1,
    DLC: 2,
    CONSUMABLE: 3,
    BUNDLE: 4,
    SUBSCRIPTION: 5
};
const $508a5edf05a9a175$var$Sku = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    name: $508a5edf05a9a175$var$stringType(),
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$SkuTypeObject),
    price: $508a5edf05a9a175$var$objectType({
        amount: $508a5edf05a9a175$var$numberType(),
        currency: $508a5edf05a9a175$var$stringType()
    }),
    application_id: $508a5edf05a9a175$var$stringType(),
    flags: $508a5edf05a9a175$var$numberType(),
    release_date: $508a5edf05a9a175$var$stringType().nullable()
});
const $508a5edf05a9a175$var$EntitlementTypesObject = {
    UNHANDLED: -1,
    PURCHASE: 1,
    PREMIUM_SUBSCRIPTION: 2,
    DEVELOPER_GIFT: 3,
    TEST_MODE_PURCHASE: 4,
    FREE_PURCHASE: 5,
    USER_GIFT: 6,
    PREMIUM_PURCHASE: 7
};
const $508a5edf05a9a175$var$Entitlement = $508a5edf05a9a175$var$objectType({
    id: $508a5edf05a9a175$var$stringType(),
    sku_id: $508a5edf05a9a175$var$stringType(),
    application_id: $508a5edf05a9a175$var$stringType(),
    user_id: $508a5edf05a9a175$var$stringType(),
    gift_code_flags: $508a5edf05a9a175$var$numberType(),
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$EntitlementTypesObject),
    gifter_user_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    branches: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$stringType()).optional().nullable(),
    starts_at: $508a5edf05a9a175$var$stringType().optional().nullable(),
    ends_at: $508a5edf05a9a175$var$stringType().optional().nullable(),
    parent_id: $508a5edf05a9a175$var$stringType().optional().nullable(),
    consumed: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    deleted: $508a5edf05a9a175$var$booleanType().optional().nullable(),
    gift_code_batch_id: $508a5edf05a9a175$var$stringType().optional().nullable()
});
const $508a5edf05a9a175$var$OrientationLockStateTypeObject = {
    UNHANDLED: -1,
    UNLOCKED: 1,
    PORTRAIT: 2,
    LANDSCAPE: 3
};
const $508a5edf05a9a175$var$OrientationLockState = $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$OrientationLockStateTypeObject);
const $508a5edf05a9a175$var$ThermalStateTypeObject = {
    UNHANDLED: -1,
    NOMINAL: 0,
    FAIR: 1,
    SERIOUS: 2,
    CRITICAL: 3
};
const $508a5edf05a9a175$var$ThermalState = $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$ThermalStateTypeObject);
const $508a5edf05a9a175$var$OrientationTypeObject = {
    UNHANDLED: -1,
    PORTRAIT: 0,
    LANDSCAPE: 1
};
const $508a5edf05a9a175$var$Orientation = $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$OrientationTypeObject);
const $508a5edf05a9a175$var$LayoutModeTypeObject = {
    UNHANDLED: -1,
    FOCUSED: 0,
    PIP: 1,
    GRID: 2
};
const $508a5edf05a9a175$var$LayoutMode = $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$LayoutModeTypeObject);
var $508a5edf05a9a175$var$Common = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get Commands () {
        return $508a5edf05a9a175$var$Commands$1;
    },
    ReceiveFramePayload: $508a5edf05a9a175$var$ReceiveFramePayload,
    ScopesObject: $508a5edf05a9a175$var$ScopesObject,
    Scopes: $508a5edf05a9a175$var$Scopes,
    User: $508a5edf05a9a175$var$User,
    GuildMember: $508a5edf05a9a175$var$GuildMember,
    Emoji: $508a5edf05a9a175$var$Emoji,
    VoiceState: $508a5edf05a9a175$var$VoiceState,
    UserVoiceState: $508a5edf05a9a175$var$UserVoiceState,
    StatusObject: $508a5edf05a9a175$var$StatusObject,
    Status: $508a5edf05a9a175$var$Status,
    Activity: $508a5edf05a9a175$var$Activity,
    PermissionOverwriteTypeObject: $508a5edf05a9a175$var$PermissionOverwriteTypeObject,
    PermissionOverwrite: $508a5edf05a9a175$var$PermissionOverwrite,
    ChannelTypesObject: $508a5edf05a9a175$var$ChannelTypesObject,
    Channel: $508a5edf05a9a175$var$Channel,
    PresenceUpdate: $508a5edf05a9a175$var$PresenceUpdate,
    Role: $508a5edf05a9a175$var$Role,
    Guild: $508a5edf05a9a175$var$Guild,
    ChannelMention: $508a5edf05a9a175$var$ChannelMention,
    Attachment: $508a5edf05a9a175$var$Attachment,
    EmbedFooter: $508a5edf05a9a175$var$EmbedFooter,
    Image: $508a5edf05a9a175$var$Image,
    Video: $508a5edf05a9a175$var$Video,
    EmbedProvider: $508a5edf05a9a175$var$EmbedProvider,
    EmbedAuthor: $508a5edf05a9a175$var$EmbedAuthor,
    EmbedField: $508a5edf05a9a175$var$EmbedField,
    Embed: $508a5edf05a9a175$var$Embed,
    Reaction: $508a5edf05a9a175$var$Reaction,
    MessageActivity: $508a5edf05a9a175$var$MessageActivity,
    MessageApplication: $508a5edf05a9a175$var$MessageApplication,
    MessageReference: $508a5edf05a9a175$var$MessageReference,
    Message: $508a5edf05a9a175$var$Message,
    VoiceDevice: $508a5edf05a9a175$var$VoiceDevice,
    KeyTypesObject: $508a5edf05a9a175$var$KeyTypesObject,
    ShortcutKey: $508a5edf05a9a175$var$ShortcutKey,
    VoiceSettingModeTypeObject: $508a5edf05a9a175$var$VoiceSettingModeTypeObject,
    VoiceSettingsMode: $508a5edf05a9a175$var$VoiceSettingsMode,
    VoiceSettingsIO: $508a5edf05a9a175$var$VoiceSettingsIO,
    CertifiedDeviceTypeObject: $508a5edf05a9a175$var$CertifiedDeviceTypeObject,
    CertifiedDevice: $508a5edf05a9a175$var$CertifiedDevice,
    SkuTypeObject: $508a5edf05a9a175$var$SkuTypeObject,
    Sku: $508a5edf05a9a175$var$Sku,
    EntitlementTypesObject: $508a5edf05a9a175$var$EntitlementTypesObject,
    Entitlement: $508a5edf05a9a175$var$Entitlement,
    OrientationLockStateTypeObject: $508a5edf05a9a175$var$OrientationLockStateTypeObject,
    OrientationLockState: $508a5edf05a9a175$var$OrientationLockState,
    ThermalStateTypeObject: $508a5edf05a9a175$var$ThermalStateTypeObject,
    ThermalState: $508a5edf05a9a175$var$ThermalState,
    OrientationTypeObject: $508a5edf05a9a175$var$OrientationTypeObject,
    Orientation: $508a5edf05a9a175$var$Orientation,
    LayoutModeTypeObject: $508a5edf05a9a175$var$LayoutModeTypeObject,
    LayoutMode: $508a5edf05a9a175$var$LayoutMode
});
const $508a5edf05a9a175$var$AuthorizeResponse = $508a5edf05a9a175$var$objectType({
    code: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$AuthorizePayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.AUTHORIZE),
    data: $508a5edf05a9a175$var$AuthorizeResponse
});
const $508a5edf05a9a175$var$AuthenticateResponse = $508a5edf05a9a175$var$objectType({
    access_token: $508a5edf05a9a175$var$stringType(),
    user: $508a5edf05a9a175$var$objectType({
        username: $508a5edf05a9a175$var$stringType(),
        discriminator: $508a5edf05a9a175$var$stringType(),
        id: $508a5edf05a9a175$var$stringType(),
        avatar: $508a5edf05a9a175$var$stringType().nullable(),
        public_flags: $508a5edf05a9a175$var$numberType()
    }),
    scopes: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Scopes),
    expires: $508a5edf05a9a175$var$stringType(),
    application: $508a5edf05a9a175$var$objectType({
        description: $508a5edf05a9a175$var$stringType(),
        icon: $508a5edf05a9a175$var$stringType().nullable(),
        id: $508a5edf05a9a175$var$stringType(),
        rpc_origins: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$stringType()).optional(),
        name: $508a5edf05a9a175$var$stringType()
    })
});
const $508a5edf05a9a175$var$AuthenticatePayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.AUTHENTICATE),
    data: $508a5edf05a9a175$var$AuthenticateResponse
});
const $508a5edf05a9a175$var$GetGuildsPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_GUILDS),
    data: $508a5edf05a9a175$var$objectType({
        guilds: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$objectType({
            id: $508a5edf05a9a175$var$stringType(),
            name: $508a5edf05a9a175$var$stringType()
        }))
    })
});
const $508a5edf05a9a175$var$GetGuildPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_GUILD),
    data: $508a5edf05a9a175$var$objectType({
        id: $508a5edf05a9a175$var$stringType(),
        name: $508a5edf05a9a175$var$stringType(),
        icon_url: $508a5edf05a9a175$var$stringType().optional(),
        members: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$GuildMember)
    })
});
const $508a5edf05a9a175$var$GetChannelPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType("GET_CHANNEL"),
    data: $508a5edf05a9a175$var$Channel.pick({
        id: true,
        guild_id: true,
        type: true,
        name: true,
        topic: true,
        bitrate: true,
        user_limit: true,
        position: true
    }).extend({
        voice_states: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$UserVoiceState),
        messages: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Message)
    })
});
const $508a5edf05a9a175$var$GetChannelsPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_CHANNELS),
    data: $508a5edf05a9a175$var$objectType({
        channels: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Channel)
    })
});
const $508a5edf05a9a175$var$SetUserVoiceSettingsResponse = $508a5edf05a9a175$var$objectType({
    user_id: $508a5edf05a9a175$var$stringType(),
    pan: $508a5edf05a9a175$var$objectType({
        left: $508a5edf05a9a175$var$numberType(),
        right: $508a5edf05a9a175$var$numberType()
    }).optional(),
    volume: $508a5edf05a9a175$var$numberType().optional(),
    mute: $508a5edf05a9a175$var$booleanType().optional()
});
const $508a5edf05a9a175$var$SetUserVoiceSettingsPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SET_USER_VOICE_SETTINGS),
    data: $508a5edf05a9a175$var$SetUserVoiceSettingsResponse
});
const $508a5edf05a9a175$var$SelectVoiceChannelPayload = $508a5edf05a9a175$var$GetChannelPayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SELECT_VOICE_CHANNEL),
    data: $508a5edf05a9a175$var$GetChannelPayload.shape.data.nullable()
});
const $508a5edf05a9a175$var$GetSelectedVoiceChannelResponse = $508a5edf05a9a175$var$GetChannelPayload.shape.data.nullable();
const $508a5edf05a9a175$var$GetSelectedVoiceChannelPayload = $508a5edf05a9a175$var$GetChannelPayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_SELECTED_VOICE_CHANNEL),
    data: $508a5edf05a9a175$var$GetSelectedVoiceChannelResponse
});
const $508a5edf05a9a175$var$SelectTextChannelPayload = $508a5edf05a9a175$var$GetChannelPayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SELECT_TEXT_CHANNEL),
    data: $508a5edf05a9a175$var$GetChannelPayload.shape.data.nullable()
});
const $508a5edf05a9a175$var$GetVoiceSettingsResponse = $508a5edf05a9a175$var$objectType({
    input: $508a5edf05a9a175$var$VoiceSettingsIO,
    output: $508a5edf05a9a175$var$VoiceSettingsIO,
    mode: $508a5edf05a9a175$var$VoiceSettingsMode,
    automatic_gain_control: $508a5edf05a9a175$var$booleanType(),
    echo_cancellation: $508a5edf05a9a175$var$booleanType(),
    noise_suppression: $508a5edf05a9a175$var$booleanType(),
    qos: $508a5edf05a9a175$var$booleanType(),
    silence_warning: $508a5edf05a9a175$var$booleanType(),
    deaf: $508a5edf05a9a175$var$booleanType(),
    mute: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$GetVoiceSettingsPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_VOICE_SETTINGS),
    data: $508a5edf05a9a175$var$GetVoiceSettingsResponse
});
const $508a5edf05a9a175$var$SetVoiceSettingsPayload = $508a5edf05a9a175$var$GetVoiceSettingsPayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SET_VOICE_SETTINGS)
});
const $508a5edf05a9a175$var$SubscribePayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SUBSCRIBE),
    data: $508a5edf05a9a175$var$objectType({
        evt: $508a5edf05a9a175$var$stringType()
    })
});
const $508a5edf05a9a175$var$UnsubscribePayload = $508a5edf05a9a175$var$SubscribePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.UNSUBSCRIBE),
    data: $508a5edf05a9a175$var$objectType({
        evt: $508a5edf05a9a175$var$stringType()
    })
});
const $508a5edf05a9a175$var$CaptureShortcutPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.CAPTURE_SHORTCUT),
    data: $508a5edf05a9a175$var$objectType({
        shortcut: $508a5edf05a9a175$var$ShortcutKey
    })
});
const $508a5edf05a9a175$var$SetCertifiedDevicesPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SET_CERTIFIED_DEVICES),
    data: $508a5edf05a9a175$var$objectType({}).nullable()
});
const $508a5edf05a9a175$var$SetActivityResponse = $508a5edf05a9a175$var$Activity;
const $508a5edf05a9a175$var$SetActivityPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SET_ACTIVITY),
    data: $508a5edf05a9a175$var$SetActivityResponse
});
const $508a5edf05a9a175$var$GetSkusResponse = $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Sku);
const $508a5edf05a9a175$var$GetSkusPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_SKUS),
    data: $508a5edf05a9a175$var$GetSkusResponse
});
const $508a5edf05a9a175$var$GetEntitlementsResponse = $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Entitlement);
const $508a5edf05a9a175$var$GetEntitlementsPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_ENTITLEMENTS),
    data: $508a5edf05a9a175$var$GetEntitlementsResponse
});
const $508a5edf05a9a175$var$StartPurchaseResponse = $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$Entitlement);
const $508a5edf05a9a175$var$StartPurchasePayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.START_PURCHASE),
    data: $508a5edf05a9a175$var$StartPurchaseResponse
});
const $508a5edf05a9a175$var$StartPremiumPurchaseResponse = $508a5edf05a9a175$var$objectType({}).nullable();
const $508a5edf05a9a175$var$StartPremiumPurchasePayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.START_PREMIUM_PURCHASE),
    data: $508a5edf05a9a175$var$StartPremiumPurchaseResponse
});
const $508a5edf05a9a175$var$SetConfigResponse = $508a5edf05a9a175$var$objectType({
    use_interactive_pip: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$SetConfigPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SET_CONFIG),
    data: $508a5edf05a9a175$var$SetConfigResponse
});
const $508a5edf05a9a175$var$SendAnalyticsEventPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SEND_ANALYTICS_EVENT),
    data: $508a5edf05a9a175$var$objectType({}).nullable()
});
const $508a5edf05a9a175$var$UserSettingsGetLocaleResponse = $508a5edf05a9a175$var$objectType({
    locale: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$UserSettingsGetLocalePayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.USER_SETTINGS_GET_LOCALE),
    data: $508a5edf05a9a175$var$UserSettingsGetLocaleResponse
});
const $508a5edf05a9a175$var$OpenExternalLinkResponse = $508a5edf05a9a175$var$objectType({}).nullable();
const $508a5edf05a9a175$var$OpenExternalLinkPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.OPEN_EXTERNAL_LINK),
    data: $508a5edf05a9a175$var$OpenExternalLinkResponse
});
const $508a5edf05a9a175$var$EncourageHardwareAccelerationResponse = $508a5edf05a9a175$var$objectType({
    enabled: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$EncourageHardwareAccelerationPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.ENCOURAGE_HW_ACCELERATION),
    data: $508a5edf05a9a175$var$EncourageHardwareAccelerationResponse
});
const $508a5edf05a9a175$var$CaptureLogResponse = $508a5edf05a9a175$var$objectType({}).nullable();
const $508a5edf05a9a175$var$CaptureLogPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.CAPTURE_LOG),
    data: $508a5edf05a9a175$var$CaptureLogResponse
});
const $508a5edf05a9a175$var$SetOrientationLockStateResponse = $508a5edf05a9a175$var$objectType({}).nullable();
const $508a5edf05a9a175$var$SetOrientationLockStatePayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.SET_ORIENTATION_LOCK_STATE),
    data: $508a5edf05a9a175$var$SetOrientationLockStateResponse
});
const $508a5edf05a9a175$var$OpenInviteDialogResponse = $508a5edf05a9a175$var$objectType({}).nullable();
const $508a5edf05a9a175$var$OpenInviteDialogPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.OPEN_INVITE_DIALOG),
    data: $508a5edf05a9a175$var$OpenInviteDialogResponse
});
const $508a5edf05a9a175$var$GetChannelPermissionsResponse = $508a5edf05a9a175$var$objectType({
    permissions: $508a5edf05a9a175$var$bigIntType().or($508a5edf05a9a175$var$stringType())
});
const $508a5edf05a9a175$var$GetChannelPermissionsPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_CHANNEL_PERMISSIONS),
    data: $508a5edf05a9a175$var$GetChannelPermissionsResponse
});
/**
 * Because of the nature of Platform Behavior changes
 * every key/value is optional and may eventually be removed
 */ const $508a5edf05a9a175$var$GetPlatformBehaviorsResponse = $508a5edf05a9a175$var$objectType({
    iosKeyboardResizesView: $508a5edf05a9a175$var$optionalType($508a5edf05a9a175$var$booleanType())
});
const $508a5edf05a9a175$var$GetPlatformBehaviorsPayload = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    cmd: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$var$Commands$1.GET_PLATFORM_BEHAVIORS),
    data: $508a5edf05a9a175$var$GetPlatformBehaviorsResponse
});
function $508a5edf05a9a175$var$parseResponsePayload(data) {
    switch(data.cmd){
        case $508a5edf05a9a175$var$Commands$1.AUTHENTICATE:
            return $508a5edf05a9a175$var$AuthenticatePayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.AUTHORIZE:
            return $508a5edf05a9a175$var$AuthorizePayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.CAPTURE_SHORTCUT:
            return $508a5edf05a9a175$var$CaptureShortcutPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.CAPTURE_LOG:
            return $508a5edf05a9a175$var$CaptureLogPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.ENCOURAGE_HW_ACCELERATION:
            return $508a5edf05a9a175$var$EncourageHardwareAccelerationPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_CHANNEL:
            return $508a5edf05a9a175$var$GetChannelPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_CHANNELS:
            return $508a5edf05a9a175$var$GetChannelsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_CHANNEL_PERMISSIONS:
            return $508a5edf05a9a175$var$GetChannelPermissionsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_GUILD:
            return $508a5edf05a9a175$var$GetGuildPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_GUILDS:
            return $508a5edf05a9a175$var$GetGuildsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_PLATFORM_BEHAVIORS:
            return $508a5edf05a9a175$var$GetPlatformBehaviorsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_SELECTED_VOICE_CHANNEL:
            return $508a5edf05a9a175$var$GetSelectedVoiceChannelPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_VOICE_SETTINGS:
            return $508a5edf05a9a175$var$GetVoiceSettingsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.OPEN_EXTERNAL_LINK:
            return $508a5edf05a9a175$var$OpenExternalLinkPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.OPEN_INVITE_DIALOG:
            return $508a5edf05a9a175$var$OpenInviteDialogPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SELECT_TEXT_CHANNEL:
            return $508a5edf05a9a175$var$SelectTextChannelPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SELECT_VOICE_CHANNEL:
            return $508a5edf05a9a175$var$SelectVoiceChannelPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SEND_ANALYTICS_EVENT:
            return $508a5edf05a9a175$var$SendAnalyticsEventPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SET_ACTIVITY:
            return $508a5edf05a9a175$var$SetActivityPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_SKUS:
            return $508a5edf05a9a175$var$GetSkusPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.GET_ENTITLEMENTS:
            return $508a5edf05a9a175$var$GetEntitlementsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SET_CERTIFIED_DEVICES:
            return $508a5edf05a9a175$var$SetCertifiedDevicesPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SET_CONFIG:
            return $508a5edf05a9a175$var$SetConfigPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SET_ORIENTATION_LOCK_STATE:
            return $508a5edf05a9a175$var$SetOrientationLockStatePayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SET_USER_VOICE_SETTINGS:
            return $508a5edf05a9a175$var$SetUserVoiceSettingsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SET_VOICE_SETTINGS:
            return $508a5edf05a9a175$var$SetVoiceSettingsPayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.START_PURCHASE:
            return $508a5edf05a9a175$var$StartPurchasePayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.SUBSCRIBE:
            return $508a5edf05a9a175$var$SubscribePayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.UNSUBSCRIBE:
            return $508a5edf05a9a175$var$UnsubscribePayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.START_PREMIUM_PURCHASE:
            return $508a5edf05a9a175$var$StartPremiumPurchasePayload.parse(data);
        case $508a5edf05a9a175$var$Commands$1.USER_SETTINGS_GET_LOCALE:
            return $508a5edf05a9a175$var$UserSettingsGetLocalePayload.parse(data);
        default:
            throw new Error(`Unrecognized command ${data.cmd}`);
    }
}
var $508a5edf05a9a175$var$responses = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AuthorizeResponse: $508a5edf05a9a175$var$AuthorizeResponse,
    AuthorizePayload: $508a5edf05a9a175$var$AuthorizePayload,
    AuthenticateResponse: $508a5edf05a9a175$var$AuthenticateResponse,
    AuthenticatePayload: $508a5edf05a9a175$var$AuthenticatePayload,
    GetGuildsPayload: $508a5edf05a9a175$var$GetGuildsPayload,
    GetGuildPayload: $508a5edf05a9a175$var$GetGuildPayload,
    GetChannelPayload: $508a5edf05a9a175$var$GetChannelPayload,
    GetChannelsPayload: $508a5edf05a9a175$var$GetChannelsPayload,
    SetUserVoiceSettingsResponse: $508a5edf05a9a175$var$SetUserVoiceSettingsResponse,
    SetUserVoiceSettingsPayload: $508a5edf05a9a175$var$SetUserVoiceSettingsPayload,
    SelectVoiceChannelPayload: $508a5edf05a9a175$var$SelectVoiceChannelPayload,
    GetSelectedVoiceChannelResponse: $508a5edf05a9a175$var$GetSelectedVoiceChannelResponse,
    GetSelectedVoiceChannelPayload: $508a5edf05a9a175$var$GetSelectedVoiceChannelPayload,
    SelectTextChannelPayload: $508a5edf05a9a175$var$SelectTextChannelPayload,
    GetVoiceSettingsResponse: $508a5edf05a9a175$var$GetVoiceSettingsResponse,
    GetVoiceSettingsPayload: $508a5edf05a9a175$var$GetVoiceSettingsPayload,
    SetVoiceSettingsPayload: $508a5edf05a9a175$var$SetVoiceSettingsPayload,
    SubscribePayload: $508a5edf05a9a175$var$SubscribePayload,
    UnsubscribePayload: $508a5edf05a9a175$var$UnsubscribePayload,
    CaptureShortcutPayload: $508a5edf05a9a175$var$CaptureShortcutPayload,
    SetCertifiedDevicesPayload: $508a5edf05a9a175$var$SetCertifiedDevicesPayload,
    SetActivityResponse: $508a5edf05a9a175$var$SetActivityResponse,
    SetActivityPayload: $508a5edf05a9a175$var$SetActivityPayload,
    GetSkusResponse: $508a5edf05a9a175$var$GetSkusResponse,
    GetSkusPayload: $508a5edf05a9a175$var$GetSkusPayload,
    GetEntitlementsResponse: $508a5edf05a9a175$var$GetEntitlementsResponse,
    GetEntitlementsPayload: $508a5edf05a9a175$var$GetEntitlementsPayload,
    StartPurchaseResponse: $508a5edf05a9a175$var$StartPurchaseResponse,
    StartPurchasePayload: $508a5edf05a9a175$var$StartPurchasePayload,
    StartPremiumPurchaseResponse: $508a5edf05a9a175$var$StartPremiumPurchaseResponse,
    StartPremiumPurchasePayload: $508a5edf05a9a175$var$StartPremiumPurchasePayload,
    SetConfigResponse: $508a5edf05a9a175$var$SetConfigResponse,
    SetConfigPayload: $508a5edf05a9a175$var$SetConfigPayload,
    SendAnalyticsEventPayload: $508a5edf05a9a175$var$SendAnalyticsEventPayload,
    UserSettingsGetLocaleResponse: $508a5edf05a9a175$var$UserSettingsGetLocaleResponse,
    UserSettingsGetLocalePayload: $508a5edf05a9a175$var$UserSettingsGetLocalePayload,
    OpenExternalLinkResponse: $508a5edf05a9a175$var$OpenExternalLinkResponse,
    OpenExternalLinkPayload: $508a5edf05a9a175$var$OpenExternalLinkPayload,
    EncourageHardwareAccelerationResponse: $508a5edf05a9a175$var$EncourageHardwareAccelerationResponse,
    EncourageHardwareAccelerationPayload: $508a5edf05a9a175$var$EncourageHardwareAccelerationPayload,
    CaptureLogResponse: $508a5edf05a9a175$var$CaptureLogResponse,
    CaptureLogPayload: $508a5edf05a9a175$var$CaptureLogPayload,
    SetOrientationLockStateResponse: $508a5edf05a9a175$var$SetOrientationLockStateResponse,
    SetOrientationLockStatePayload: $508a5edf05a9a175$var$SetOrientationLockStatePayload,
    OpenInviteDialogResponse: $508a5edf05a9a175$var$OpenInviteDialogResponse,
    OpenInviteDialogPayload: $508a5edf05a9a175$var$OpenInviteDialogPayload,
    GetChannelPermissionsResponse: $508a5edf05a9a175$var$GetChannelPermissionsResponse,
    GetChannelPermissionsPayload: $508a5edf05a9a175$var$GetChannelPermissionsPayload,
    GetPlatformBehaviorsResponse: $508a5edf05a9a175$var$GetPlatformBehaviorsResponse,
    GetPlatformBehaviorsPayload: $508a5edf05a9a175$var$GetPlatformBehaviorsPayload,
    parseResponsePayload: $508a5edf05a9a175$var$parseResponsePayload
});
$508a5edf05a9a175$exports.Events = void 0;
(function(Events) {
    Events["READY"] = "READY";
    Events["ERROR"] = "ERROR";
    Events["GUILD_STATUS"] = "GUILD_STATUS";
    Events["GUILD_CREATE"] = "GUILD_CREATE";
    Events["CHANNEL_CREATE"] = "CHANNEL_CREATE";
    Events["VOICE_CHANNEL_SELECT"] = "VOICE_CHANNEL_SELECT";
    Events["VOICE_SETTINGS_UPDATE"] = "VOICE_SETTINGS_UPDATE";
    Events["VOICE_STATE_CREATE"] = "VOICE_STATE_CREATE";
    Events["VOICE_STATE_UPDATE"] = "VOICE_STATE_UPDATE";
    Events["VOICE_STATE_DELETE"] = "VOICE_STATE_DELETE";
    Events["VOICE_CONNECTION_STATUS"] = "VOICE_CONNECTION_STATUS";
    Events["MESSAGE_CREATE"] = "MESSAGE_CREATE";
    Events["MESSAGE_UPDATE"] = "MESSAGE_UPDATE";
    Events["MESSAGE_DELETE"] = "MESSAGE_DELETE";
    Events["SPEAKING_START"] = "SPEAKING_START";
    Events["SPEAKING_STOP"] = "SPEAKING_STOP";
    Events["NOTIFICATION_CREATE"] = "NOTIFICATION_CREATE";
    Events["CAPTURE_SHORTCUT_CHANGE"] = "CAPTURE_SHORTCUT_CHANGE";
    Events["ACTIVITY_JOIN"] = "ACTIVITY_JOIN";
    Events["ACTIVITY_JOIN_REQUEST"] = "ACTIVITY_JOIN_REQUEST";
    Events["ACTIVITY_PIP_MODE_UPDATE"] = "ACTIVITY_PIP_MODE_UPDATE";
    Events["ACTIVITY_LAYOUT_MODE_UPDATE"] = "ACTIVITY_LAYOUT_MODE_UPDATE";
    Events["ORIENTATION_UPDATE"] = "ORIENTATION_UPDATE";
    Events["CURRENT_USER_UPDATE"] = "CURRENT_USER_UPDATE";
    Events["ENTITLEMENT_CREATE"] = "ENTITLEMENT_CREATE";
    Events["THERMAL_STATE_UPDATE"] = "THERMAL_STATE_UPDATE";
})($508a5edf05a9a175$exports.Events || ($508a5edf05a9a175$exports.Events = {}));
const $508a5edf05a9a175$var$EventFrame = $508a5edf05a9a175$var$ReceiveFramePayload.extend({
    evt: $508a5edf05a9a175$var$stringType(),
    nonce: $508a5edf05a9a175$var$ReceiveFramePayload.shape.nonce.optional().nullable()
});
function $508a5edf05a9a175$var$makeEvent(name, data) {
    return $508a5edf05a9a175$var$EventFrame.extend({
        evt: $508a5edf05a9a175$var$literalType(name),
        data: $508a5edf05a9a175$var$objectType(data)
    });
}
const $508a5edf05a9a175$var$Ready = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.READY, {
    v: $508a5edf05a9a175$var$numberType(),
    config: $508a5edf05a9a175$var$objectType({
        cdn_host: $508a5edf05a9a175$var$stringType().optional(),
        api_endpoint: $508a5edf05a9a175$var$stringType(),
        environment: $508a5edf05a9a175$var$stringType()
    }),
    user: $508a5edf05a9a175$var$objectType({
        id: $508a5edf05a9a175$var$stringType(),
        username: $508a5edf05a9a175$var$stringType(),
        discriminator: $508a5edf05a9a175$var$stringType(),
        avatar: $508a5edf05a9a175$var$stringType().optional()
    }).optional()
});
const $508a5edf05a9a175$var$ErrorEvent = $508a5edf05a9a175$var$EventFrame.extend({
    evt: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$exports.Events.ERROR),
    data: $508a5edf05a9a175$var$objectType({
        code: $508a5edf05a9a175$var$numberType(),
        message: $508a5edf05a9a175$var$stringType().optional()
    }),
    cmd: $508a5edf05a9a175$var$stringType(),
    nonce: $508a5edf05a9a175$var$stringType().nullable()
});
const $508a5edf05a9a175$var$GuildStatus = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.GUILD_STATUS, {
    guild: $508a5edf05a9a175$var$Guild,
    online: $508a5edf05a9a175$var$numberType().optional()
});
const $508a5edf05a9a175$var$GuildCreate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.GUILD_CREATE, {
    id: $508a5edf05a9a175$var$stringType(),
    name: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$ChannelCreate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.CHANNEL_CREATE, {
    id: $508a5edf05a9a175$var$stringType(),
    name: $508a5edf05a9a175$var$stringType(),
    type: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$ChannelTypesObject)
});
const $508a5edf05a9a175$var$VoiceChannelSelect = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.VOICE_CHANNEL_SELECT, {
    channel_id: $508a5edf05a9a175$var$stringType().nullable(),
    guild_id: $508a5edf05a9a175$var$stringType().nullable().optional()
});
const $508a5edf05a9a175$var$VoiceSettingsUpdate = $508a5edf05a9a175$var$GetVoiceSettingsPayload.extend({
    cmd: $508a5edf05a9a175$var$literalType("DISPATCH"),
    evt: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$exports.Events.VOICE_SETTINGS_UPDATE),
    nonce: $508a5edf05a9a175$var$nullType()
});
const $508a5edf05a9a175$var$VoiceStateCreate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.VOICE_STATE_CREATE, {
    voice_state: $508a5edf05a9a175$var$VoiceState,
    user: $508a5edf05a9a175$var$User,
    nick: $508a5edf05a9a175$var$stringType(),
    volume: $508a5edf05a9a175$var$numberType(),
    mute: $508a5edf05a9a175$var$booleanType(),
    pan: $508a5edf05a9a175$var$objectType({
        left: $508a5edf05a9a175$var$numberType(),
        right: $508a5edf05a9a175$var$numberType()
    })
});
const $508a5edf05a9a175$var$VoiceStateUpdate = $508a5edf05a9a175$var$VoiceStateCreate.extend({
    evt: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$exports.Events.VOICE_STATE_UPDATE)
});
const $508a5edf05a9a175$var$VoiceStateDelete = $508a5edf05a9a175$var$VoiceStateCreate.extend({
    evt: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$exports.Events.VOICE_STATE_DELETE)
});
const $508a5edf05a9a175$var$VoiceConnectionStatusStateObject = {
    UNHANDLED: -1,
    DISCONNECTED: "DISCONNECTED",
    AWAITING_ENDPOINT: "AWAITING_ENDPOINT",
    AUTHENTICATING: "AUTHENTICATING",
    CONNECTING: "CONNECTING",
    CONNECTED: "CONNECTED",
    VOICE_DISCONNECTED: "VOICE_DISCONNECTED",
    VOICE_CONNECTING: "VOICE_CONNECTING",
    VOICE_CONNECTED: "VOICE_CONNECTED",
    NO_ROUTE: "NO_ROUTE",
    ICE_CHECKING: "ICE_CHECKING"
};
const $508a5edf05a9a175$var$VoiceConnectionStatus = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.VOICE_CONNECTION_STATUS, {
    state: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$VoiceConnectionStatusStateObject),
    hostname: $508a5edf05a9a175$var$stringType(),
    pings: $508a5edf05a9a175$var$arrayType($508a5edf05a9a175$var$numberType()),
    average_ping: $508a5edf05a9a175$var$numberType(),
    last_ping: $508a5edf05a9a175$var$numberType()
});
const $508a5edf05a9a175$var$MessageCreate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.MESSAGE_CREATE, {
    channel_id: $508a5edf05a9a175$var$stringType(),
    message: $508a5edf05a9a175$var$Message
});
const $508a5edf05a9a175$var$MessageUpdate = $508a5edf05a9a175$var$MessageCreate.extend({
    evt: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$exports.Events.MESSAGE_UPDATE)
});
const $508a5edf05a9a175$var$MessageDelete = $508a5edf05a9a175$var$MessageCreate.extend({
    evt: $508a5edf05a9a175$var$literalType($508a5edf05a9a175$exports.Events.MESSAGE_DELETE)
});
const $508a5edf05a9a175$var$StartSpeaking = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.SPEAKING_START, {
    user_id: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$StopSpeaking = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.SPEAKING_STOP, {
    user_id: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$NotificationCreate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.NOTIFICATION_CREATE, {
    channel_id: $508a5edf05a9a175$var$stringType(),
    message: $508a5edf05a9a175$var$Message,
    icon_url: $508a5edf05a9a175$var$stringType(),
    title: $508a5edf05a9a175$var$stringType(),
    body: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$CaptureShortcutChange = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.CAPTURE_SHORTCUT_CHANGE, {
    shortcut: $508a5edf05a9a175$var$ShortcutKey
});
const $508a5edf05a9a175$var$ActivityJoinIntentObject = {
    UNHANDLED: -1,
    PLAY: 0,
    SPECTATE: 1
};
const $508a5edf05a9a175$var$ActivityJoin = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.ACTIVITY_JOIN, {
    secret: $508a5edf05a9a175$var$stringType(),
    intent: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$ActivityJoinIntentObject).optional()
});
const $508a5edf05a9a175$var$ActivityJoinRequest = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.ACTIVITY_JOIN_REQUEST, {
    user: $508a5edf05a9a175$var$User
});
const $508a5edf05a9a175$var$ActivityPIPModeUpdate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.ACTIVITY_PIP_MODE_UPDATE, {
    is_pip_mode: $508a5edf05a9a175$var$booleanType()
});
const $508a5edf05a9a175$var$ActivityLayoutModeUpdate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.ACTIVITY_LAYOUT_MODE_UPDATE, {
    layout_mode: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$LayoutModeTypeObject)
});
const $508a5edf05a9a175$var$OrientationUpdate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.ORIENTATION_UPDATE, {
    screen_orientation: $508a5edf05a9a175$var$zodCoerceUnhandledValue($508a5edf05a9a175$var$OrientationTypeObject),
    /**
     * @deprecated use screen_orientation instead
     */ orientation: $508a5edf05a9a175$var$nativeEnumType($508a5edf05a9a175$exports.Orientation)
});
// For some god forsaken reason the user shape for this event doesnt match our existing event shapes, and is directly dumped into the
// event
const $508a5edf05a9a175$var$CurrentUserUpdate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.CURRENT_USER_UPDATE, {
    avatar: $508a5edf05a9a175$var$stringType().optional().nullable(),
    bot: $508a5edf05a9a175$var$booleanType(),
    discriminator: $508a5edf05a9a175$var$stringType(),
    flags: $508a5edf05a9a175$var$numberType().optional().nullable(),
    id: $508a5edf05a9a175$var$stringType(),
    premium_type: $508a5edf05a9a175$var$numberType().optional().nullable(),
    username: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$EntitlementCreate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.ENTITLEMENT_CREATE, {
    entitlement: $508a5edf05a9a175$var$Entitlement
});
const $508a5edf05a9a175$var$ThermalStateUpdate = $508a5edf05a9a175$var$makeEvent($508a5edf05a9a175$exports.Events.THERMAL_STATE_UPDATE, {
    thermal_state: $508a5edf05a9a175$var$ThermalState
});
function $508a5edf05a9a175$var$parseEventPayload(data) {
    switch(data.evt){
        case $508a5edf05a9a175$exports.Events.ACTIVITY_JOIN:
            return $508a5edf05a9a175$var$ActivityJoin.parse(data);
        case $508a5edf05a9a175$exports.Events.ACTIVITY_JOIN_REQUEST:
            return $508a5edf05a9a175$var$ActivityJoinRequest.parse(data);
        case $508a5edf05a9a175$exports.Events.ACTIVITY_PIP_MODE_UPDATE:
            return $508a5edf05a9a175$var$ActivityPIPModeUpdate.parse(data);
        case $508a5edf05a9a175$exports.Events.ACTIVITY_LAYOUT_MODE_UPDATE:
            return $508a5edf05a9a175$var$ActivityLayoutModeUpdate.parse(data);
        case $508a5edf05a9a175$exports.Events.CAPTURE_SHORTCUT_CHANGE:
            return $508a5edf05a9a175$var$CaptureShortcutChange.parse(data);
        case $508a5edf05a9a175$exports.Events.CHANNEL_CREATE:
            return $508a5edf05a9a175$var$ChannelCreate.parse(data);
        case $508a5edf05a9a175$exports.Events.ERROR:
            return $508a5edf05a9a175$var$ErrorEvent.parse(data);
        case $508a5edf05a9a175$exports.Events.GUILD_CREATE:
            return $508a5edf05a9a175$var$GuildCreate.parse(data);
        case $508a5edf05a9a175$exports.Events.GUILD_STATUS:
            return $508a5edf05a9a175$var$GuildStatus.parse(data);
        case $508a5edf05a9a175$exports.Events.MESSAGE_CREATE:
            return $508a5edf05a9a175$var$MessageCreate.parse(data);
        case $508a5edf05a9a175$exports.Events.MESSAGE_DELETE:
            return $508a5edf05a9a175$var$MessageDelete.parse(data);
        case $508a5edf05a9a175$exports.Events.MESSAGE_UPDATE:
            return $508a5edf05a9a175$var$MessageUpdate.parse(data);
        case $508a5edf05a9a175$exports.Events.NOTIFICATION_CREATE:
            return $508a5edf05a9a175$var$NotificationCreate.parse(data);
        case $508a5edf05a9a175$exports.Events.ORIENTATION_UPDATE:
            return $508a5edf05a9a175$var$OrientationUpdate.parse(data);
        case $508a5edf05a9a175$exports.Events.READY:
            return $508a5edf05a9a175$var$Ready.parse(data);
        case $508a5edf05a9a175$exports.Events.SPEAKING_START:
            return $508a5edf05a9a175$var$StartSpeaking.parse(data);
        case $508a5edf05a9a175$exports.Events.SPEAKING_STOP:
            return $508a5edf05a9a175$var$StopSpeaking.parse(data);
        case $508a5edf05a9a175$exports.Events.VOICE_CHANNEL_SELECT:
            return $508a5edf05a9a175$var$VoiceChannelSelect.parse(data);
        case $508a5edf05a9a175$exports.Events.VOICE_CONNECTION_STATUS:
            return $508a5edf05a9a175$var$VoiceConnectionStatus.parse(data);
        case $508a5edf05a9a175$exports.Events.VOICE_SETTINGS_UPDATE:
            return $508a5edf05a9a175$var$VoiceSettingsUpdate.parse(data);
        case $508a5edf05a9a175$exports.Events.VOICE_STATE_CREATE:
            return $508a5edf05a9a175$var$VoiceStateCreate.parse(data);
        case $508a5edf05a9a175$exports.Events.VOICE_STATE_DELETE:
            return $508a5edf05a9a175$var$VoiceStateDelete.parse(data);
        case $508a5edf05a9a175$exports.Events.VOICE_STATE_UPDATE:
            return $508a5edf05a9a175$var$VoiceStateUpdate.parse(data);
        case $508a5edf05a9a175$exports.Events.CURRENT_USER_UPDATE:
            return $508a5edf05a9a175$var$CurrentUserUpdate.parse(data);
        case $508a5edf05a9a175$exports.Events.ENTITLEMENT_CREATE:
            return $508a5edf05a9a175$var$EntitlementCreate.parse(data);
        case $508a5edf05a9a175$exports.Events.THERMAL_STATE_UPDATE:
            return $508a5edf05a9a175$var$ThermalStateUpdate.parse(data);
        default:
            throw new Error(`Unrecognized event type ${data.evt}`);
    }
}
$508a5edf05a9a175$var$objectType({
    frame_id: $508a5edf05a9a175$var$stringType(),
    platform: $508a5edf05a9a175$var$nativeEnumType($508a5edf05a9a175$exports.Platform).optional().nullable()
});
$508a5edf05a9a175$var$objectType({
    v: $508a5edf05a9a175$var$literalType(1),
    encoding: $508a5edf05a9a175$var$literalType("json").optional(),
    client_id: $508a5edf05a9a175$var$stringType(),
    frame_id: $508a5edf05a9a175$var$stringType()
});
const $508a5edf05a9a175$var$ClosePayload = $508a5edf05a9a175$var$objectType({
    code: $508a5edf05a9a175$var$numberType(),
    message: $508a5edf05a9a175$var$stringType().optional()
});
const $508a5edf05a9a175$var$IncomingPayload = $508a5edf05a9a175$var$objectType({
    evt: $508a5edf05a9a175$var$stringType().nullable(),
    nonce: $508a5edf05a9a175$var$stringType().nullable(),
    cmd: $508a5edf05a9a175$var$stringType()
}).passthrough();
function $508a5edf05a9a175$var$parseIncomingPayload(data) {
    const incoming = $508a5edf05a9a175$var$IncomingPayload.parse(data);
    if (incoming.evt != null) return $508a5edf05a9a175$var$parseEventPayload($508a5edf05a9a175$var$EventFrame.passthrough().parse(incoming));
    else return $508a5edf05a9a175$var$parseResponsePayload(incoming);
}
/**
 *
 */ const $508a5edf05a9a175$var$authenticate = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.AUTHENTICATE,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$AuthenticatePayload.parse(reply);
            return parsedReply.data;
        });
/**
 * Should be called directly after a `ready` payload is received from the
 * Discord client. It includes a list of all scopes that your activity would
 * like to be authorized to use. If the user does not yet have a valid token
 * for all scopes requested, this command will open an OAuth modal. Once an
 * authorized token is available, it will be returned in the command response.
 */ const $508a5edf05a9a175$var$authorize = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.AUTHORIZE,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$AuthorizePayload.parse(reply);
            return parsedReply.data;
        });
/**
 *
 */ const $508a5edf05a9a175$var$captureLog = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.CAPTURE_LOG,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$CaptureLogPayload.parse(reply);
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$encourageHardwareAcceleration = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.ENCOURAGE_HW_ACCELERATION,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$EncourageHardwareAccelerationPayload.parse(reply);
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$getEntitlements = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.GET_ENTITLEMENTS,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$GetEntitlementsPayload.parse(reply);
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$getSelectedVoiceChannel = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.GET_SELECTED_VOICE_CHANNEL,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$GetSelectedVoiceChannelPayload.parse(reply);
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$getSkus = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.GET_SKUS,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$GetSkusPayload.parse(reply);
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$getVoiceSettings = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.GET_VOICE_SETTINGS,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$GetVoiceSettingsPayload.parse(reply);
            return parsedReply;
        });
/**
 * Returns a bigint representing Permissions for the current user in the currently connected channel. Use PermissionsUtils to calculate if a user has a particular permission.
 * Always returns `0n` (no valid permissions) in a (G)DM context, so is unnecessary to call when discordSdk.guildId == null.
 */ const $508a5edf05a9a175$var$getChannelPermissions = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.GET_CHANNEL_PERMISSIONS,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$GetChannelPermissionsPayload.parse(reply);
            return parsedReply;
        });
/**
 * Returns an object with information about platform behaviors
 * This command can be utilized to inform and react to a breaking change in platform behavior
 *
 * @returns {GetPlatformBehaviorsPayload} payload - The command return value
 * @returns {boolean} payload.data.iosKeyboardResizesView - If on iOS the webview is resized when the keyboard is opened
 */ const $508a5edf05a9a175$var$getPlatformBehaviors = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.GET_PLATFORM_BEHAVIORS,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$GetPlatformBehaviorsPayload.parse(reply);
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$openExternalLink = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.OPEN_EXTERNAL_LINK,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$OpenExternalLinkPayload.parse(reply);
            return parsedReply;
        });
/**
 * Opens the invite dialog within the discord client, allowing users to share invite links to friends.
 * Does not work in (G)DM contexts (throws RPCError.INVALID_CHANNEL), so should not be called if discordSdk.guildId == null
 * Similarly, if the user does not have Permissions.CREATE_INSTANT_INVITE this command throws RPCErrors.INVALID_PERMISSIONS, so checking the user's permissions via getChannelPermissions is highly recommended.
 */ const $508a5edf05a9a175$var$openInviteDialog = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.OPEN_INVITE_DIALOG,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$OpenInviteDialogPayload.parse(reply);
            return parsedReply;
        });
$508a5edf05a9a175$var$Activity.pick({
    state: true,
    details: true,
    timestamps: true,
    assets: true,
    party: true,
    secrets: true,
    buttons: true,
    instance: true,
    supported_platforms: true,
    type: true
}).extend({
    type: $508a5edf05a9a175$var$Activity.shape.type.optional(),
    instance: $508a5edf05a9a175$var$Activity.shape.instance.optional()
}).nullable();
/**
 *
 * @description
 * RPC documentation here: https://discord.com/developers/docs/topics/rpc#setactivity
 * Calling setActivity allows modifying how your activity's rich presence is displayed in the Discord App
 *
 * Supported Platforms
 * | Web | iOS | Android |
 * |-----|-----|---------|
 * | ✅  | ✅  | ✅      |
 *
 * Required scopes: [rpc.activities.write]
 *
 * @example
 * await discordSdk.commands.setActivity({
 *   activity: {
 *     type: 0,
 *     details: 'Details',
 *     state: 'Playing',
 *   },
 * });
 */ const $508a5edf05a9a175$var$setActivity = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.SET_ACTIVITY,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$SetActivityPayload.parse(reply);
            return parsedReply.data;
        });
/**
 *
 */ const $508a5edf05a9a175$var$setConfig = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.SET_CONFIG,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$SetConfigPayload.parse(reply);
            return parsedReply;
        });
/**
 * @args - the primary args to send with the command.
 * @fallbackArgs - the args to try the command with in the case where an old Discord
 *  client doesn't support one of the new args.
 */ function $508a5edf05a9a175$var$sendCommandCompat({ sendCommand: sendCommand , command: command , args: args , fallbackArgs: fallbackArgs , responseParser: responseParser  }) {
    return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
        try {
            const reply = yield sendCommand({
                cmd: command,
                args: args
            });
            const parsedReply = responseParser.parse(reply);
            return parsedReply;
        } catch (error) {
            if (error.code === $508a5edf05a9a175$exports.RPCErrorCodes.INVALID_PAYLOAD) {
                const reply = yield sendCommand({
                    cmd: command,
                    args: fallbackArgs
                });
                const parsedReply = responseParser.parse(reply);
                return parsedReply;
            } else throw error;
        }
    });
}
const $508a5edf05a9a175$var$setOrientationLockState = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const parsedReply = yield $508a5edf05a9a175$var$sendCommandCompat({
                sendCommand: sendCommand,
                command: $508a5edf05a9a175$var$Commands$1.SET_ORIENTATION_LOCK_STATE,
                args: args,
                fallbackArgs: {
                    lock_state: args.lock_state,
                    picture_in_picture_lock_state: args.picture_in_picture_lock_state
                },
                responseParser: $508a5edf05a9a175$var$SetOrientationLockStatePayload
            });
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$setUserVoiceSettings = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.SET_USER_VOICE_SETTINGS,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$SetUserVoiceSettingsPayload.parse(reply);
            return parsedReply;
        });
/**
 *
 */ const $508a5edf05a9a175$var$startPremiumPurchase = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.START_PREMIUM_PURCHASE,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$StartPremiumPurchasePayload.parse(reply);
            return parsedReply.data;
        });
/**
 *
 */ const $508a5edf05a9a175$var$startPurchase = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.START_PURCHASE,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$StartPurchasePayload.parse(reply);
            return parsedReply.data;
        });
/**
 *
 */ const $508a5edf05a9a175$var$userSettingsGetLocale = (sendCommand)=>(args)=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const reply = yield sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.USER_SETTINGS_GET_LOCALE,
                args: args
            });
            const parsedReply = $508a5edf05a9a175$var$UserSettingsGetLocalePayload.parse(reply);
            return parsedReply;
        });
function $508a5edf05a9a175$var$commands(sendCommand) {
    return {
        authenticate: $508a5edf05a9a175$var$authenticate(sendCommand),
        authorize: $508a5edf05a9a175$var$authorize(sendCommand),
        captureLog: $508a5edf05a9a175$var$captureLog(sendCommand),
        encourageHardwareAcceleration: $508a5edf05a9a175$var$encourageHardwareAcceleration(sendCommand),
        getEntitlements: $508a5edf05a9a175$var$getEntitlements(sendCommand),
        getPlatformBehaviors: $508a5edf05a9a175$var$getPlatformBehaviors(sendCommand),
        getSelectedVoiceChannel: $508a5edf05a9a175$var$getSelectedVoiceChannel(sendCommand),
        getChannelPermissions: $508a5edf05a9a175$var$getChannelPermissions(sendCommand),
        getSkus: $508a5edf05a9a175$var$getSkus(sendCommand),
        getVoiceSettings: $508a5edf05a9a175$var$getVoiceSettings(sendCommand),
        openExternalLink: $508a5edf05a9a175$var$openExternalLink(sendCommand),
        openInviteDialog: $508a5edf05a9a175$var$openInviteDialog(sendCommand),
        setActivity: $508a5edf05a9a175$var$setActivity(sendCommand),
        setConfig: $508a5edf05a9a175$var$setConfig(sendCommand),
        setOrientationLockState: $508a5edf05a9a175$var$setOrientationLockState(sendCommand),
        setUserVoiceSettings: $508a5edf05a9a175$var$setUserVoiceSettings(sendCommand),
        startPremiumPurchase: $508a5edf05a9a175$var$startPremiumPurchase(sendCommand),
        startPurchase: $508a5edf05a9a175$var$startPurchase(sendCommand),
        userSettingsGetLocale: $508a5edf05a9a175$var$userSettingsGetLocale(sendCommand)
    };
}
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $508a5edf05a9a175$var$getRandomValues;
var $508a5edf05a9a175$var$rnds8 = new Uint8Array(16);
function $508a5edf05a9a175$var$rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$508a5edf05a9a175$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $508a5edf05a9a175$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$508a5edf05a9a175$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $508a5edf05a9a175$var$getRandomValues($508a5edf05a9a175$var$rnds8);
}
var $508a5edf05a9a175$var$REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function $508a5edf05a9a175$var$validate(uuid) {
    return typeof uuid === "string" && $508a5edf05a9a175$var$REGEX.test(uuid);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $508a5edf05a9a175$var$byteToHex = [];
for(var $508a5edf05a9a175$var$i = 0; $508a5edf05a9a175$var$i < 256; ++$508a5edf05a9a175$var$i)$508a5edf05a9a175$var$byteToHex.push(($508a5edf05a9a175$var$i + 0x100).toString(16).substr(1));
function $508a5edf05a9a175$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($508a5edf05a9a175$var$byteToHex[arr[offset + 0]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 1]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 2]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 3]] + "-" + $508a5edf05a9a175$var$byteToHex[arr[offset + 4]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 5]] + "-" + $508a5edf05a9a175$var$byteToHex[arr[offset + 6]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 7]] + "-" + $508a5edf05a9a175$var$byteToHex[arr[offset + 8]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 9]] + "-" + $508a5edf05a9a175$var$byteToHex[arr[offset + 10]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 11]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 12]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 13]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 14]] + $508a5edf05a9a175$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!$508a5edf05a9a175$var$validate(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
function $508a5edf05a9a175$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || $508a5edf05a9a175$var$rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return $508a5edf05a9a175$var$stringify(rnds);
}
class $508a5edf05a9a175$var$SDKError extends Error {
    constructor(code, message = ""){
        super(message);
        this.code = code;
        this.message = message;
        this.name = "Discord SDK Error";
    }
}
/**
 * Creates a regular expression from a target string. The target string
 * may contain `{name}` tokens which will end up being translated to
 * a named group match for a series of word characters with the group named `name`
 * The substitution pattern is {a-z} because the named groups must be valid JS identifiers,
 * making items like {0} invalid.
 *
 * @returns a RegExp object
 **/ const $508a5edf05a9a175$var$SUBSTITUTION_REGEX = /\{([a-z]+)\}/g;
function $508a5edf05a9a175$var$regexFromTarget(target) {
    const regexString = target.replace($508a5edf05a9a175$var$SUBSTITUTION_REGEX, (match, name)=>`(?<${name}>[\\w-]+)`);
    return new RegExp(`${regexString}(/|$)`);
}
/**
 *
 * Attempts to map the actual url (i.e. google.com) to a url path, per the url
 * mappings set up in the embedded application. If the target contains `{foo}`
 * tokens, they will be replace with the values contained in the original URL,
 * via the pattern described in the prefix
 *
 * @returns  null if URL doesn't match prefix, otherwise return rewritten URL
 */ function $508a5edf05a9a175$var$matchAndRewriteURL({ originalURL: originalURL , prefix: prefix , prefixHost: prefixHost , target: target  }) {
    // coerce url with filler https protocol so we can retrieve host and pathname from target
    const targetURL = new URL(`https://${target}`);
    const targetRegEx = $508a5edf05a9a175$var$regexFromTarget(targetURL.host);
    const match = originalURL.toString().match(targetRegEx);
    // Null match indicates that this target is not relevant
    if (match == null) return originalURL;
    const newURL = new URL(originalURL.toString());
    newURL.host = prefixHost;
    newURL.pathname = prefix.replace($508a5edf05a9a175$var$SUBSTITUTION_REGEX, (_, matchName)=>{
        var _a;
        const replaceValue = (_a = match.groups) === null || _a === void 0 ? void 0 : _a[matchName];
        if (replaceValue == null) throw new Error("Misconfigured route.");
        return replaceValue;
    });
    // Append the original path
    newURL.pathname += newURL.pathname === "/" ? originalURL.pathname.slice(1) : originalURL.pathname;
    // Remove the target's path from the new url path
    newURL.pathname = newURL.pathname.replace(targetURL.pathname, "");
    // Keep the trailing slash
    newURL.pathname += newURL.pathname.endsWith("/") ? "" : "/";
    return newURL;
}
function $508a5edf05a9a175$var$absoluteURL(url, protocol = window.location.protocol, host = window.location.host) {
    if (url.startsWith("/")) return new URL(`${protocol}//${host}${url}`);
    else return new URL(url);
}
function $508a5edf05a9a175$var$attemptRemap({ url: url , mappings: mappings  }) {
    for (const mapping of mappings){
        const mapped = $508a5edf05a9a175$var$matchAndRewriteURL({
            originalURL: url,
            prefix: mapping.prefix,
            target: mapping.target,
            prefixHost: window.location.host
        });
        if (mapped) return mapped;
    }
    return url;
}
// @deprecated applicationID is no longer used
function $508a5edf05a9a175$var$initializeNetworkShims(_applicationId, mappings) {
    // fetch intercept
    const fetchImpl = window.fetch;
    window.fetch = function(input, init) {
        const remapped = $508a5edf05a9a175$var$attemptRemap({
            url: $508a5edf05a9a175$var$absoluteURL(input.toString()),
            mappings: mappings
        });
        return fetchImpl(remapped.toString(), init);
    };
    // xhr intercept
    const openImpl = XMLHttpRequest.prototype.open;
    // @ts-expect-error - the ts interface exports two 'open' methods
    XMLHttpRequest.prototype.open = function(method, url, async, username, password) {
        const remapped = $508a5edf05a9a175$var$attemptRemap({
            url: $508a5edf05a9a175$var$absoluteURL(url),
            mappings: mappings
        });
        openImpl.apply(this, [
            method,
            remapped.toString(),
            async,
            username,
            password
        ]);
    };
    // web socket intercept
    class WebSocketProxy extends WebSocket {
        constructor(urlIn, protocols){
            const url = urlIn instanceof URL ? urlIn.toString() : urlIn;
            const remapped = $508a5edf05a9a175$var$attemptRemap({
                url: $508a5edf05a9a175$var$absoluteURL(url, "wss:"),
                mappings: mappings
            });
            super(remapped.toString(), protocols);
        }
    }
    window.WebSocket = WebSocketProxy;
}
function $508a5edf05a9a175$var$getDefaultSdkConfiguration() {
    return {
        disableConsoleLogOverride: false
    };
}
const $508a5edf05a9a175$var$consoleLevels = [
    "log",
    "warn",
    "debug",
    "info",
    "error"
];
function $508a5edf05a9a175$var$wrapConsoleMethod(console1, level, callback) {
    const _consoleMethod = console1[level];
    const _console = console1;
    if (!_consoleMethod) return;
    console1[level] = function() {
        const args = [].slice.call(arguments);
        const message = "" + args.join(" ");
        callback(level, message);
        _consoleMethod.apply(_console, args);
    };
}
var $508a5edf05a9a175$var$Opcodes;
(function(Opcodes) {
    Opcodes[Opcodes["HANDSHAKE"] = 0] = "HANDSHAKE";
    Opcodes[Opcodes["FRAME"] = 1] = "FRAME";
    Opcodes[Opcodes["CLOSE"] = 2] = "CLOSE";
    Opcodes[Opcodes["HELLO"] = 3] = "HELLO";
})($508a5edf05a9a175$var$Opcodes || ($508a5edf05a9a175$var$Opcodes = {}));
const $508a5edf05a9a175$var$ALLOWED_ORIGINS = new Set([
    window.location.origin,
    "https://discord.com",
    "https://discordapp.com",
    "https://ptb.discord.com",
    "https://ptb.discordapp.com",
    "https://canary.discord.com",
    "https://canary.discordapp.com",
    "https://staging.discord.co",
    "http://localhost:3333",
    "https://pax.discord.com",
    "null"
]);
/**
 * The embedded application is running in an IFrame either within the main Discord client window or in a popout. The RPC server is always running in the main Discord client window. In either case, the referrer is the correct origin.
 */ function $508a5edf05a9a175$var$getRPCServerSource() {
    var _a;
    return [
        (_a = window.parent.opener) !== null && _a !== void 0 ? _a : window.parent,
        !!document.referrer ? document.referrer : "*"
    ];
}
class $508a5edf05a9a175$var$DiscordSDK {
    constructor(clientId, configuration){
        this.eventBus = new $508a5edf05a9a175$var$EventEmitter();
        this.source = null;
        this.sourceOrigin = "";
        this.pendingCommands = new Map();
        /**
         * The key is the layout mode listener passed in by the public API for
         * subscribeToLayoutModeUpdatesCompat, and the value is the corresponding
         * listeners, created by the SDK, for layout mode updates and PIP mode updates.
         */ this.layoutModeUpdateListenerMap = new Map();
        this.sendCommand = (payload)=>{
            var _a;
            if (this.source == null) throw new Error("Attempting to send message before initialization");
            const nonce = $508a5edf05a9a175$var$v4();
            (_a = this.source) === null || _a === void 0 || _a.postMessage([
                $508a5edf05a9a175$var$Opcodes.FRAME,
                Object.assign(Object.assign({}, payload), {
                    nonce: nonce
                })
            ], this.sourceOrigin);
            const promise = new Promise((resolve, reject)=>{
                this.pendingCommands.set(nonce, {
                    resolve: resolve,
                    reject: reject
                });
            });
            return promise;
        };
        this.commands = $508a5edf05a9a175$var$commands(this.sendCommand);
        this.initializeNetworkShims = $508a5edf05a9a175$var$initializeNetworkShims;
        this.handleMessage = (event)=>{
            if (!$508a5edf05a9a175$var$ALLOWED_ORIGINS.has(event.origin)) return;
            const tuple = event.data;
            if (!Array.isArray(tuple)) return;
            const [opcode, data] = tuple;
            switch(opcode){
                case $508a5edf05a9a175$var$Opcodes.HELLO:
                    // backwards compat; the Discord client will still send HELLOs for old applications.
                    //
                    // TODO: figure out compatibility approach; it would be easier to maintain compatibility at the SDK level, not the underlying RPC protocol level...
                    return;
                case $508a5edf05a9a175$var$Opcodes.CLOSE:
                    return this.handleClose(data);
                case $508a5edf05a9a175$var$Opcodes.HANDSHAKE:
                    return this.handleHandshake();
                case $508a5edf05a9a175$var$Opcodes.FRAME:
                    return this.handleFrame(data);
                default:
                    throw new Error("Invalid message format");
            }
        };
        this.isReady = false;
        this.clientId = clientId;
        this.configuration = configuration !== null && configuration !== void 0 ? configuration : $508a5edf05a9a175$var$getDefaultSdkConfiguration();
        window.addEventListener("message", this.handleMessage);
        // START Capture URL Query Params
        const urlParams = new URLSearchParams(window.location.search);
        const frameId = urlParams.get("frame_id");
        if (!frameId) throw new Error("frame_id query param is not defined");
        this.frameId = frameId;
        const instanceId = urlParams.get("instance_id");
        if (!instanceId) throw new Error("instance_id query param is not defined");
        this.instanceId = instanceId;
        const platform = urlParams.get("platform");
        if (!platform) throw new Error("platform query param is not defined");
        else if (platform !== $508a5edf05a9a175$exports.Platform.DESKTOP && platform !== $508a5edf05a9a175$exports.Platform.MOBILE) throw new Error(`Invalid query param "platform" of "${platform}". Valid values are "${$508a5edf05a9a175$exports.Platform.DESKTOP}" or "${$508a5edf05a9a175$exports.Platform.MOBILE}"`);
        this.platform = platform;
        this.guildId = urlParams.get("guild_id");
        this.channelId = urlParams.get("channel_id");
        // END Capture URL Query Params
        [this.source, this.sourceOrigin] = $508a5edf05a9a175$var$getRPCServerSource();
        this.addOnReadyListener();
        this.handshake();
    }
    close(code, message) {
        var _a;
        window.removeEventListener("message", this.handleMessage);
        const nonce = $508a5edf05a9a175$var$v4();
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $508a5edf05a9a175$var$Opcodes.CLOSE,
            {
                code: code,
                message: message,
                nonce: nonce
            }
        ], this.sourceOrigin);
    }
    subscribe(event, listener, subscribeArgs) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            const listenerCount = this.eventBus.listenerCount(event);
            const emitter = this.eventBus.on(event, listener);
            // If first subscription, subscribe via RPC
            if (Object.values($508a5edf05a9a175$exports.Events).includes(event) && event !== $508a5edf05a9a175$exports.Events.READY && listenerCount === 0) yield this.sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.SUBSCRIBE,
                args: subscribeArgs,
                evt: event
            });
            return emitter;
        });
    }
    unsubscribe(event, listener) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            if (Object.values($508a5edf05a9a175$exports.Events).includes(event) && event !== $508a5edf05a9a175$exports.Events.READY && this.eventBus.listenerCount(event) === 1) yield this.sendCommand({
                cmd: $508a5edf05a9a175$var$Commands$1.UNSUBSCRIBE,
                evt: event
            });
            return this.eventBus.off(event, listener);
        });
    }
    ready() {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            if (this.isReady) return;
            else yield new Promise((resolve)=>{
                this.eventBus.once($508a5edf05a9a175$exports.Events.READY, resolve);
            });
        });
    }
    subscribeToLayoutModeUpdatesCompat(listener) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            const pipModeListener = (update)=>{
                const layoutMode = update.is_pip_mode ? $508a5edf05a9a175$var$LayoutModeTypeObject.PIP : $508a5edf05a9a175$var$LayoutModeTypeObject.FOCUSED;
                listener({
                    layout_mode: layoutMode
                });
            };
            const pipModeSubscription = yield this.subscribe($508a5edf05a9a175$exports.Events.ACTIVITY_PIP_MODE_UPDATE, pipModeListener);
            const layoutModeListener = (update)=>{
                this.unsubscribe($508a5edf05a9a175$exports.Events.ACTIVITY_PIP_MODE_UPDATE, pipModeListener);
                listener(update);
            };
            this.layoutModeUpdateListenerMap.set(listener, {
                layoutModeListener: layoutModeListener,
                pipModeListener: pipModeListener
            });
            try {
                const layoutModeSubscription = yield this.subscribe($508a5edf05a9a175$exports.Events.ACTIVITY_LAYOUT_MODE_UPDATE, layoutModeListener);
                return layoutModeSubscription;
            } catch (error) {
                if (error.code === $508a5edf05a9a175$exports.RPCErrorCodes.INVALID_EVENT) return pipModeSubscription;
                else throw error;
            }
        });
    }
    unsubscribeFromLayoutModeUpdatesCompat(listener) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            const listeners = this.layoutModeUpdateListenerMap.get(listener);
            this.layoutModeUpdateListenerMap.delete(listener);
            if (listeners != null) {
                const { layoutModeListener: layoutModeListener , pipModeListener: pipModeListener  } = listeners;
                let layoutModeUnsubscribeResult = null;
                let pipModeUnsubscribeResult = null;
                if (layoutModeListener != null) try {
                    layoutModeUnsubscribeResult = yield this.unsubscribe($508a5edf05a9a175$exports.Events.ACTIVITY_LAYOUT_MODE_UPDATE, layoutModeListener);
                } catch (error) {
                    if (error.code === $508a5edf05a9a175$exports.RPCErrorCodes.INVALID_EVENT) ;
                    else throw error;
                }
                if (pipModeListener != null) pipModeUnsubscribeResult = yield this.unsubscribe($508a5edf05a9a175$exports.Events.ACTIVITY_PIP_MODE_UPDATE, pipModeListener);
                return layoutModeUnsubscribeResult !== null && layoutModeUnsubscribeResult !== void 0 ? layoutModeUnsubscribeResult : pipModeUnsubscribeResult;
            }
        });
    }
    handshake() {
        var _a;
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $508a5edf05a9a175$var$Opcodes.HANDSHAKE,
            {
                v: 1,
                encoding: "json",
                client_id: this.clientId,
                frame_id: this.frameId
            }
        ], this.sourceOrigin);
    }
    addOnReadyListener() {
        this.eventBus.once($508a5edf05a9a175$exports.Events.READY, ()=>{
            this.overrideConsoleLogging();
            this.isReady = true;
        });
    }
    overrideConsoleLogging() {
        if (this.configuration.disableConsoleLogOverride) return;
        const sendCaptureLogCommand = (level, message)=>{
            this.commands.captureLog({
                level: level,
                message: message
            });
        };
        $508a5edf05a9a175$var$consoleLevels.forEach((level)=>{
            $508a5edf05a9a175$var$wrapConsoleMethod(console, level, sendCaptureLogCommand);
        });
    }
    handleClose(data) {
        $508a5edf05a9a175$var$ClosePayload.parse(data);
    }
    handleHandshake() {}
    handleFrame(data) {
        var _a, _b;
        let parsed;
        try {
            parsed = $508a5edf05a9a175$var$parseIncomingPayload(data);
        } catch (e) {
            console.error("Failed to parse", data);
            console.error(e);
            return;
        }
        if (parsed.cmd === "DISPATCH") this.eventBus.emit(parsed.evt, parsed.data);
        else {
            if (parsed.evt === "ERROR") {
                // In response to a command
                if (parsed.nonce != null) {
                    (_a = this.pendingCommands.get(parsed.nonce)) === null || _a === void 0 || _a.reject(parsed.data);
                    this.pendingCommands.delete(parsed.nonce);
                    return;
                }
                // General error
                this.eventBus.emit("error", new $508a5edf05a9a175$var$SDKError(parsed.data.code, parsed.data.message));
            }
            if (parsed.nonce == null) {
                console.error("Missing nonce", data);
                return;
            }
            (_b = this.pendingCommands.get(parsed.nonce)) === null || _b === void 0 || _b.resolve(parsed);
            this.pendingCommands.delete(parsed.nonce);
        }
    }
}
class $508a5edf05a9a175$var$DiscordSDKMock {
    constructor(clientId, guildId, channelId){
        this.platform = $508a5edf05a9a175$exports.Platform.DESKTOP;
        this.instanceId = "123456789012345678";
        this.configuration = $508a5edf05a9a175$var$getDefaultSdkConfiguration();
        this.frameId = "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa";
        this.eventBus = new $508a5edf05a9a175$var$EventEmitter();
        this.clientId = clientId;
        this.commands = this._updateCommandMocks({});
        this.guildId = guildId;
        this.channelId = channelId;
    }
    _updateCommandMocks(newCommands) {
        // Wrap all the command functions with logging
        this.commands = $508a5edf05a9a175$var$transform(Object.assign({}, $508a5edf05a9a175$var$commandsMockDefault, newCommands), (mock, func, name)=>{
            mock[name] = (...args)=>$508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
                    console.info(`DiscordSDKMock: ${String(name)}(${JSON.stringify(args)})`);
                    return yield func(...args);
                });
        });
        // redundant return here to satisfy the constructor defining commands
        return this.commands;
    }
    /**
     * Helper function to be used if you have subscribed to the "ready" event
     */ emitReady() {
        this.emitEvent("READY", undefined);
    }
    close(...args) {
        console.info(`DiscordSDKMock: close(${JSON.stringify(args)})`);
    }
    ready() {
        return Promise.resolve();
    }
    subscribe(event, listener) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            return yield this.eventBus.on(event, listener);
        });
    }
    unsubscribe(event, listener) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            return yield this.eventBus.off(event, listener);
        });
    }
    subscribeToLayoutModeUpdatesCompat(listener) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            return yield this.eventBus.on($508a5edf05a9a175$exports.Events.ACTIVITY_LAYOUT_MODE_UPDATE, listener);
        });
    }
    unsubscribeFromLayoutModeUpdatesCompat(listener) {
        return $508a5edf05a9a175$var$__awaiter$1(this, void 0, void 0, function*() {
            return yield this.eventBus.off($508a5edf05a9a175$exports.Events.ACTIVITY_LAYOUT_MODE_UPDATE, listener);
        });
    }
    initializeNetworkShims(applicationId, mappings) {
        console.info("Mock initializing network shims", applicationId, mappings);
    }
    emitEvent(event, data) {
        this.eventBus.emit(event, data);
    }
}
/** Default return values for all discord SDK commands */ const $508a5edf05a9a175$var$commandsMockDefault = {
    authorize: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                code: "mock_code"
            };
        }),
    authenticate: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                access_token: "mock_token",
                user: {
                    username: "mock_user_username",
                    discriminator: "mock_user_discriminator",
                    id: "mock_user_id",
                    avatar: null,
                    public_flags: 1
                },
                scopes: [],
                expires: new Date(2121, 1, 1).toString(),
                application: {
                    description: "mock_app_description",
                    icon: "mock_app_icon",
                    id: "mock_app_id",
                    name: "mock_app_name"
                }
            };
        }),
    setActivity: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                name: "mock_activity_name",
                type: 0
            };
        }),
    getSkus: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.GET_SKUS,
                data: [],
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    getEntitlements: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.GET_ENTITLEMENTS,
                data: [],
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    startPurchase: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield [];
        }),
    startPremiumPurchase: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield null;
        }),
    setConfig: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.SET_CONFIG,
                data: {
                    use_interactive_pip: false
                },
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    getSelectedVoiceChannel: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.GET_SELECTED_VOICE_CHANNEL,
                data: null,
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    userSettingsGetLocale: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.USER_SETTINGS_GET_LOCALE,
                data: {
                    locale: ""
                },
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    getVoiceSettings: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.GET_VOICE_SETTINGS,
                data: {
                    input: {
                        device_id: "default",
                        volume: 0,
                        available_devices: [
                            {
                                id: "default",
                                name: "default"
                            }
                        ]
                    },
                    output: {
                        device_id: "default",
                        volume: 0,
                        available_devices: [
                            {
                                id: "default",
                                name: "default"
                            }
                        ]
                    },
                    mode: {
                        type: "VOICE_ACTIVITY",
                        auto_threshold: false,
                        threshold: 0,
                        shortcut: [],
                        delay: 0
                    },
                    automatic_gain_control: false,
                    echo_cancellation: false,
                    noise_suppression: false,
                    qos: false,
                    silence_warning: false,
                    deaf: false,
                    mute: false
                },
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    setUserVoiceSettings: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.SET_USER_VOICE_SETTINGS,
                data: {
                    user_id: "user_id",
                    mute: false,
                    pan: {
                        left: 1,
                        right: 1
                    },
                    volume: 100
                },
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    openExternalLink: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.OPEN_EXTERNAL_LINK,
                data: null,
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    encourageHardwareAcceleration: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.ENCOURAGE_HW_ACCELERATION,
                data: {
                    enabled: true
                },
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    captureLog: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.CAPTURE_LOG,
                data: null,
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    setOrientationLockState: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.SET_ORIENTATION_LOCK_STATE,
                data: null,
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    openInviteDialog: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.OPEN_INVITE_DIALOG,
                data: null,
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    getPlatformBehaviors: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.GET_PLATFORM_BEHAVIORS,
                data: {
                    iosKeyboardResizesView: true
                },
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        }),
    getChannelPermissions: ()=>$508a5edf05a9a175$var$__awaiter$1(void 0, void 0, void 0, function*() {
            return yield {
                cmd: $508a5edf05a9a175$var$Commands$1.GET_CHANNEL_PERMISSIONS,
                data: {
                    permissions: $508a5edf05a9a175$var$bigInt(1234567890)
                },
                evt: null,
                nonce: $508a5edf05a9a175$var$v4()
            };
        })
};
var $508a5edf05a9a175$var$types = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
function $508a5edf05a9a175$var$can(permission, permissions) {
    return $508a5edf05a9a175$var$BigFlagUtils.has($508a5edf05a9a175$var$BigFlagUtils.deserialize(permissions), permission);
}
var $508a5edf05a9a175$var$PermissionUtils = {
    can: $508a5edf05a9a175$var$can
};
const { Commands: $508a5edf05a9a175$var$Commands  } = $508a5edf05a9a175$var$Common;
$508a5edf05a9a175$exports.Commands = $508a5edf05a9a175$var$Commands;
$508a5edf05a9a175$exports.Common = $508a5edf05a9a175$var$Common;
$508a5edf05a9a175$exports.DiscordSDK = $508a5edf05a9a175$var$DiscordSDK;
$508a5edf05a9a175$exports.DiscordSDKMock = $508a5edf05a9a175$var$DiscordSDKMock;
$508a5edf05a9a175$exports.PermissionUtils = $508a5edf05a9a175$var$PermissionUtils;
$508a5edf05a9a175$exports.Permissions = $508a5edf05a9a175$var$Permissions;
$508a5edf05a9a175$exports.Responses = $508a5edf05a9a175$var$responses;
$508a5edf05a9a175$exports.Types = $508a5edf05a9a175$var$types;


const $b5aff70181e0917f$var$queryParams = new URLSearchParams(window.location.search);
const $b5aff70181e0917f$var$isEmbedded = $b5aff70181e0917f$var$queryParams.get("frame_id") != null;
let $b5aff70181e0917f$export$127230c0dc597d18;
if ($b5aff70181e0917f$var$isEmbedded) $b5aff70181e0917f$export$127230c0dc597d18 = new (0, $508a5edf05a9a175$exports.DiscordSDK)("1112018719841996951");
else {
    // We're using session storage for user_id, guild_id, and channel_id
    // This way the user/guild/channel will be maintained until the tab is closed, even if you refresh
    // Session storage will generate new unique mocks for each tab you open
    // Any of these values can be overridden via query parameters
    // i.e. if you set https://my-tunnel-url.com/?user_id=test_user_id
    // this will override this will override the session user_id value
    const mockUserId = $b5aff70181e0917f$var$getOverrideOrRandomSessionValue("user_id");
    const mockGuildId = $b5aff70181e0917f$var$getOverrideOrRandomSessionValue("guild_id");
    const mockChannelId = $b5aff70181e0917f$var$getOverrideOrRandomSessionValue("channel_id");
    $b5aff70181e0917f$export$127230c0dc597d18 = new (0, $508a5edf05a9a175$exports.DiscordSDKMock)("1112018719841996951", mockGuildId, mockChannelId);
    const discriminator = String(mockUserId.charCodeAt(0) % 5);
    $b5aff70181e0917f$export$127230c0dc597d18._updateCommandMocks({
        authenticate: async ()=>{
            return await {
                access_token: "mock_token",
                user: {
                    username: mockUserId,
                    discriminator: discriminator,
                    id: mockUserId,
                    avatar: null,
                    public_flags: 1
                },
                scopes: [],
                expires: new Date(2112, 1, 1).toString(),
                application: {
                    description: "mock_app_description",
                    icon: "mock_app_icon",
                    id: "mock_app_id",
                    name: "mock_app_name"
                }
            };
        }
    });
}
var $b5aff70181e0917f$var$SessionStorageQueryParam;
(function(SessionStorageQueryParam) {
    SessionStorageQueryParam["user_id"] = "user_id";
    SessionStorageQueryParam["guild_id"] = "guild_id";
    SessionStorageQueryParam["channel_id"] = "channel_id";
})($b5aff70181e0917f$var$SessionStorageQueryParam || ($b5aff70181e0917f$var$SessionStorageQueryParam = {}));
function $b5aff70181e0917f$var$getOverrideOrRandomSessionValue(queryParam) {
    const overrideValue = $b5aff70181e0917f$var$queryParams.get(queryParam);
    if (overrideValue != null) return overrideValue;
    const currentStoredValue = sessionStorage.getItem(queryParam);
    if (currentStoredValue != null) return currentStoredValue;
    // Set queryParam to a random 8-character string
    const randomString = Math.random().toString(36).slice(2, 10);
    sessionStorage.setItem(queryParam, randomString);
    return randomString;
}


const $d40087df9a05b3da$var$DiscordAuthContext = /*#__PURE__*/ (0, $exYeM.createContext)({
    access_token: "",
    scopes: [],
    expires: "",
    user: {
        id: "",
        username: "",
        discriminator: "",
        avatar: undefined,
        public_flags: 0
    },
    application: {
        rpc_origins: undefined,
        id: "",
        name: "",
        icon: undefined,
        description: ""
    }
});
const $d40087df9a05b3da$export$1aec681d4d8de28d = ({ children: children  })=>{
    const authContext = $d40087df9a05b3da$var$useAuthContextSetup();
    if (authContext == null) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: "loading..."
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d40087df9a05b3da$var$DiscordAuthContext.Provider, {
        value: authContext,
        children: children
    });
};
const $d40087df9a05b3da$export$9dfbf593388d3738 = ()=>{
    return (0, $exYeM.useContext)($d40087df9a05b3da$var$DiscordAuthContext);
};
const $d40087df9a05b3da$var$useAuthContextSetup = ()=>{
    const [auth, setAuth] = (0, $exYeM.useState)(null);
    const settingUp = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        const setUpDiscordSdk = async ()=>{
            await (0, $b5aff70181e0917f$export$127230c0dc597d18).ready();
            // authorize with client
            const { code: code  } = await (0, $b5aff70181e0917f$export$127230c0dc597d18).commands.authorize({
                client_id: "1112018719841996951",
                response_type: "code",
                state: "",
                prompt: "none",
                scope: [
                    "identify",
                    "guilds",
                    "guilds.members.read",
                    "rpc.voice.read"
                ]
            });
            const response = await fetch("/api/token", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code: code
                })
            });
            const { access_token: access_token  } = await response.json();
            // authenticate with client
            const newAuth = await (0, $b5aff70181e0917f$export$127230c0dc597d18).commands.authenticate({
                access_token: access_token
            });
            setAuth({
                ...newAuth
            });
        };
        if (!settingUp.current) {
            settingUp.current = true;
            setUpDiscordSdk();
        }
    }, [
        (0, $b5aff70181e0917f$export$127230c0dc597d18)
    ]);
    return auth;
};





var $exYeM = parcelRequire("exYeM");

var $b3551b1678837ab6$exports = {};
"use strict";
Object.defineProperty($b3551b1678837ab6$exports, "__esModule", {
    value: true
});
$b3551b1678837ab6$exports.resetGlobalState = $b3551b1678837ab6$exports.useEventSource = $b3551b1678837ab6$exports.ReadyState = $b3551b1678837ab6$exports.useSocketIO = $b3551b1678837ab6$exports.default = void 0;
var $5e2aa2d56abb87fa$exports = {};
"use strict";
var $5e2aa2d56abb87fa$var$__assign = $5e2aa2d56abb87fa$exports && $5e2aa2d56abb87fa$exports.__assign || function() {
    $5e2aa2d56abb87fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5e2aa2d56abb87fa$var$__assign.apply(this, arguments);
};
var $5e2aa2d56abb87fa$var$__awaiter = $5e2aa2d56abb87fa$exports && $5e2aa2d56abb87fa$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5e2aa2d56abb87fa$var$__generator = $5e2aa2d56abb87fa$exports && $5e2aa2d56abb87fa$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5e2aa2d56abb87fa$var$__importDefault = $5e2aa2d56abb87fa$exports && $5e2aa2d56abb87fa$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5e2aa2d56abb87fa$exports, "__esModule", {
    value: true
});
$5e2aa2d56abb87fa$exports.useWebSocket = void 0;

var $exYeM = parcelRequire("exYeM");

var $a5f48a6a0c42f032$exports = {};
"use strict";
Object.defineProperty($a5f48a6a0c42f032$exports, "__esModule", {
    value: true
});
$a5f48a6a0c42f032$exports.isEventSourceSupported = $a5f48a6a0c42f032$exports.isReactNative = $a5f48a6a0c42f032$exports.ReadyState = $a5f48a6a0c42f032$exports.UNPARSABLE_JSON_OBJECT = $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_INTERVAL_MS = $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_LIMIT = $a5f48a6a0c42f032$exports.SOCKET_IO_PING_CODE = $a5f48a6a0c42f032$exports.SOCKET_IO_PATH = $a5f48a6a0c42f032$exports.SOCKET_IO_PING_INTERVAL = $a5f48a6a0c42f032$exports.DEFAULT_EVENT_SOURCE_OPTIONS = $a5f48a6a0c42f032$exports.EMPTY_EVENT_HANDLERS = $a5f48a6a0c42f032$exports.DEFAULT_OPTIONS = void 0;
var $a5f48a6a0c42f032$var$MILLISECONDS = 1;
var $a5f48a6a0c42f032$var$SECONDS = 1000 * $a5f48a6a0c42f032$var$MILLISECONDS;
$a5f48a6a0c42f032$exports.DEFAULT_OPTIONS = {};
$a5f48a6a0c42f032$exports.EMPTY_EVENT_HANDLERS = {};
$a5f48a6a0c42f032$exports.DEFAULT_EVENT_SOURCE_OPTIONS = {
    withCredentials: false,
    events: $a5f48a6a0c42f032$exports.EMPTY_EVENT_HANDLERS
};
$a5f48a6a0c42f032$exports.SOCKET_IO_PING_INTERVAL = 25 * $a5f48a6a0c42f032$var$SECONDS;
$a5f48a6a0c42f032$exports.SOCKET_IO_PATH = "/socket.io/?EIO=3&transport=websocket";
$a5f48a6a0c42f032$exports.SOCKET_IO_PING_CODE = "2";
$a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_LIMIT = 20;
$a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_INTERVAL_MS = 5000;
$a5f48a6a0c42f032$exports.UNPARSABLE_JSON_OBJECT = {};
var $a5f48a6a0c42f032$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})($a5f48a6a0c42f032$var$ReadyState = $a5f48a6a0c42f032$exports.ReadyState || ($a5f48a6a0c42f032$exports.ReadyState = {}));
var $a5f48a6a0c42f032$var$eventSourceSupported = function() {
    try {
        return "EventSource" in globalThis;
    } catch (e) {
        return false;
    }
};
$a5f48a6a0c42f032$exports.isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
$a5f48a6a0c42f032$exports.isEventSourceSupported = !$a5f48a6a0c42f032$exports.isReactNative && $a5f48a6a0c42f032$var$eventSourceSupported();


var $5f4d99dc40d76d48$exports = {};
"use strict";
Object.defineProperty($5f4d99dc40d76d48$exports, "__esModule", {
    value: true
});
$5f4d99dc40d76d48$exports.createOrJoinSocket = void 0;
var $01b9f7375233e525$exports = {};
"use strict";
Object.defineProperty($01b9f7375233e525$exports, "__esModule", {
    value: true
});
$01b9f7375233e525$exports.resetWebSockets = $01b9f7375233e525$exports.sharedWebSockets = void 0;
$01b9f7375233e525$exports.sharedWebSockets = {};
var $01b9f7375233e525$var$resetWebSockets = function(url) {
    if (url && $01b9f7375233e525$exports.sharedWebSockets.hasOwnProperty(url)) delete $01b9f7375233e525$exports.sharedWebSockets[url];
    else {
        for(var url_1 in $01b9f7375233e525$exports.sharedWebSockets)if ($01b9f7375233e525$exports.sharedWebSockets.hasOwnProperty(url_1)) delete $01b9f7375233e525$exports.sharedWebSockets[url_1];
    }
};
$01b9f7375233e525$exports.resetWebSockets = $01b9f7375233e525$var$resetWebSockets;



var $bc3c1c3d68dce265$exports = {};
"use strict";
var $bc3c1c3d68dce265$var$__assign = $bc3c1c3d68dce265$exports && $bc3c1c3d68dce265$exports.__assign || function() {
    $bc3c1c3d68dce265$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc3c1c3d68dce265$var$__assign.apply(this, arguments);
};
Object.defineProperty($bc3c1c3d68dce265$exports, "__esModule", {
    value: true
});
$bc3c1c3d68dce265$exports.attachListeners = void 0;
var $929aa7201d3888a5$exports = {};
"use strict";
Object.defineProperty($929aa7201d3888a5$exports, "__esModule", {
    value: true
});
$929aa7201d3888a5$exports.setUpSocketIOPing = $929aa7201d3888a5$exports.appendQueryParams = $929aa7201d3888a5$exports.parseSocketIOUrl = void 0;

var $929aa7201d3888a5$var$parseSocketIOUrl = function(url) {
    if (url) {
        var isSecure = /^https|wss/.test(url);
        var strippedProtocol = url.replace(/^(https?|wss?)(:\/\/)?/, "");
        var removedFinalBackSlack = strippedProtocol.replace(/\/$/, "");
        var protocol = isSecure ? "wss" : "ws";
        return "".concat(protocol, "://").concat(removedFinalBackSlack).concat($a5f48a6a0c42f032$exports.SOCKET_IO_PATH);
    } else if (url === "") {
        var isSecure = /^https/.test(window.location.protocol);
        var protocol = isSecure ? "wss" : "ws";
        var port = window.location.port ? ":".concat(window.location.port) : "";
        return "".concat(protocol, "://").concat(window.location.hostname).concat(port).concat($a5f48a6a0c42f032$exports.SOCKET_IO_PATH);
    }
    return url;
};
$929aa7201d3888a5$exports.parseSocketIOUrl = $929aa7201d3888a5$var$parseSocketIOUrl;
var $929aa7201d3888a5$var$appendQueryParams = function(url, params) {
    if (params === void 0) params = {};
    var hasParamsRegex = /\?([\w]+=[\w]+)/;
    var alreadyHasParams = hasParamsRegex.test(url);
    var stringified = "".concat(Object.entries(params).reduce(function(next, _a) {
        var key = _a[0], value = _a[1];
        return next + "".concat(key, "=").concat(value, "&");
    }, "").slice(0, -1));
    return "".concat(url).concat(alreadyHasParams ? "&" : "?").concat(stringified);
};
$929aa7201d3888a5$exports.appendQueryParams = $929aa7201d3888a5$var$appendQueryParams;
var $929aa7201d3888a5$var$setUpSocketIOPing = function(sendMessage, interval) {
    if (interval === void 0) interval = $a5f48a6a0c42f032$exports.SOCKET_IO_PING_INTERVAL;
    var ping = function() {
        return sendMessage($a5f48a6a0c42f032$exports.SOCKET_IO_PING_CODE);
    };
    return window.setInterval(ping, interval);
};
$929aa7201d3888a5$exports.setUpSocketIOPing = $929aa7201d3888a5$var$setUpSocketIOPing;



var $a4c5937388a88d9b$exports = {};
"use strict";
Object.defineProperty($a4c5937388a88d9b$exports, "__esModule", {
    value: true
});
$a4c5937388a88d9b$exports.resetGlobalState = $a4c5937388a88d9b$exports.assertIsWebSocket = void 0;

var $083c0cd98a7da0b9$exports = {};
"use strict";
Object.defineProperty($083c0cd98a7da0b9$exports, "__esModule", {
    value: true
});
$083c0cd98a7da0b9$exports.resetSubscribers = $083c0cd98a7da0b9$exports.removeSubscriber = $083c0cd98a7da0b9$exports.addSubscriber = $083c0cd98a7da0b9$exports.hasSubscribers = $083c0cd98a7da0b9$exports.getSubscribers = void 0;
var $083c0cd98a7da0b9$var$subscribers = {};
var $083c0cd98a7da0b9$var$EMPTY_LIST = [];
var $083c0cd98a7da0b9$var$getSubscribers = function(url) {
    if ((0, $083c0cd98a7da0b9$exports.hasSubscribers)(url)) return Array.from($083c0cd98a7da0b9$var$subscribers[url]);
    return $083c0cd98a7da0b9$var$EMPTY_LIST;
};
$083c0cd98a7da0b9$exports.getSubscribers = $083c0cd98a7da0b9$var$getSubscribers;
var $083c0cd98a7da0b9$var$hasSubscribers = function(url) {
    var _a;
    return ((_a = $083c0cd98a7da0b9$var$subscribers[url]) === null || _a === void 0 ? void 0 : _a.size) > 0;
};
$083c0cd98a7da0b9$exports.hasSubscribers = $083c0cd98a7da0b9$var$hasSubscribers;
var $083c0cd98a7da0b9$var$addSubscriber = function(url, subscriber) {
    $083c0cd98a7da0b9$var$subscribers[url] = $083c0cd98a7da0b9$var$subscribers[url] || new Set();
    $083c0cd98a7da0b9$var$subscribers[url].add(subscriber);
};
$083c0cd98a7da0b9$exports.addSubscriber = $083c0cd98a7da0b9$var$addSubscriber;
var $083c0cd98a7da0b9$var$removeSubscriber = function(url, subscriber) {
    $083c0cd98a7da0b9$var$subscribers[url].delete(subscriber);
};
$083c0cd98a7da0b9$exports.removeSubscriber = $083c0cd98a7da0b9$var$removeSubscriber;
var $083c0cd98a7da0b9$var$resetSubscribers = function(url) {
    if (url && $083c0cd98a7da0b9$var$subscribers.hasOwnProperty(url)) delete $083c0cd98a7da0b9$var$subscribers[url];
    else {
        for(var url_1 in $083c0cd98a7da0b9$var$subscribers)if ($083c0cd98a7da0b9$var$subscribers.hasOwnProperty(url_1)) delete $083c0cd98a7da0b9$var$subscribers[url_1];
    }
};
$083c0cd98a7da0b9$exports.resetSubscribers = $083c0cd98a7da0b9$var$resetSubscribers;


function $a4c5937388a88d9b$var$assertIsWebSocket(webSocketInstance, skip) {
    if (!skip && webSocketInstance instanceof WebSocket === false) throw new Error("");
}
$a4c5937388a88d9b$exports.assertIsWebSocket = $a4c5937388a88d9b$var$assertIsWebSocket;
function $a4c5937388a88d9b$var$resetGlobalState(url) {
    (0, $083c0cd98a7da0b9$exports.resetSubscribers)(url);
    (0, $01b9f7375233e525$exports.resetWebSockets)(url);
}
$a4c5937388a88d9b$exports.resetGlobalState = $a4c5937388a88d9b$var$resetGlobalState;


var $bc3c1c3d68dce265$var$bindMessageHandler = function(webSocketInstance, optionsRef, setLastMessage) {
    webSocketInstance.onmessage = function(message) {
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof optionsRef.current.filter === "function" && optionsRef.current.filter(message) !== true) return;
        setLastMessage(message);
    };
};
var $bc3c1c3d68dce265$var$bindOpenHandler = function(webSocketInstance, optionsRef, setReadyState, reconnectCount) {
    webSocketInstance.onopen = function(event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        setReadyState($a5f48a6a0c42f032$exports.ReadyState.OPEN);
    };
};
var $bc3c1c3d68dce265$var$bindCloseHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    if ($a5f48a6a0c42f032$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) return function() {};
    (0, $a4c5937388a88d9b$exports.assertIsWebSocket)(webSocketInstance, optionsRef.current.skipAssert);
    var reconnectTimeout;
    webSocketInstance.onclose = function(event) {
        var _a;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        setReadyState($a5f48a6a0c42f032$exports.ReadyState.CLOSED);
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_LIMIT;
            if (reconnectCount.current < reconnectAttempts) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === "function" ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $bc3c1c3d68dce265$var$bindErrorHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    var reconnectTimeout;
    webSocketInstance.onerror = function(error) {
        var _a;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if ($a5f48a6a0c42f032$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
            optionsRef.current.onClose && optionsRef.current.onClose($bc3c1c3d68dce265$var$__assign($bc3c1c3d68dce265$var$__assign({}, error), {
                code: 1006,
                reason: "An error occurred with the EventSource: ".concat(error),
                wasClean: false
            }));
            setReadyState($a5f48a6a0c42f032$exports.ReadyState.CLOSED);
            webSocketInstance.close();
        }
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < ((_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_LIMIT)) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === "function" ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(optionsRef.current.reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(optionsRef.current.reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $bc3c1c3d68dce265$var$attachListeners = function(webSocketInstance, setters, optionsRef, reconnect, reconnectCount, sendMessage) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var cancelReconnectOnClose;
    var cancelReconnectOnError;
    if (optionsRef.current.fromSocketIO) interval = (0, $929aa7201d3888a5$exports.setUpSocketIOPing)(sendMessage);
    $bc3c1c3d68dce265$var$bindMessageHandler(webSocketInstance, optionsRef, setLastMessage);
    $bc3c1c3d68dce265$var$bindOpenHandler(webSocketInstance, optionsRef, setReadyState, reconnectCount);
    cancelReconnectOnClose = $bc3c1c3d68dce265$var$bindCloseHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    cancelReconnectOnError = $bc3c1c3d68dce265$var$bindErrorHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    return function() {
        setReadyState($a5f48a6a0c42f032$exports.ReadyState.CLOSING);
        cancelReconnectOnClose();
        cancelReconnectOnError();
        webSocketInstance.close();
        if (interval) clearInterval(interval);
    };
};
$bc3c1c3d68dce265$exports.attachListeners = $bc3c1c3d68dce265$var$attachListeners;


var $f265ce76e22ed38c$exports = {};
"use strict";
var $f265ce76e22ed38c$var$__assign = $f265ce76e22ed38c$exports && $f265ce76e22ed38c$exports.__assign || function() {
    $f265ce76e22ed38c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f265ce76e22ed38c$var$__assign.apply(this, arguments);
};
Object.defineProperty($f265ce76e22ed38c$exports, "__esModule", {
    value: true
});
$f265ce76e22ed38c$exports.attachSharedListeners = void 0;




var $f265ce76e22ed38c$var$bindMessageHandler = function(webSocketInstance, url) {
    webSocketInstance.onmessage = function(message) {
        (0, $083c0cd98a7da0b9$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onMessage) subscriber.optionsRef.current.onMessage(message);
            if (typeof subscriber.optionsRef.current.filter === "function" && subscriber.optionsRef.current.filter(message) !== true) return;
            subscriber.setLastMessage(message);
        });
    };
};
var $f265ce76e22ed38c$var$bindOpenHandler = function(webSocketInstance, url) {
    webSocketInstance.onopen = function(event) {
        (0, $083c0cd98a7da0b9$exports.getSubscribers)(url).forEach(function(subscriber) {
            subscriber.reconnectCount.current = 0;
            if (subscriber.optionsRef.current.onOpen) subscriber.optionsRef.current.onOpen(event);
            subscriber.setReadyState($a5f48a6a0c42f032$exports.ReadyState.OPEN);
        });
    };
};
var $f265ce76e22ed38c$var$bindCloseHandler = function(webSocketInstance, url) {
    if (webSocketInstance instanceof WebSocket) webSocketInstance.onclose = function(event) {
        (0, $083c0cd98a7da0b9$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onClose) subscriber.optionsRef.current.onClose(event);
            subscriber.setReadyState($a5f48a6a0c42f032$exports.ReadyState.CLOSED);
        });
        delete $01b9f7375233e525$exports.sharedWebSockets[url];
        (0, $083c0cd98a7da0b9$exports.getSubscribers)(url).forEach(function(subscriber) {
            var _a;
            if (subscriber.optionsRef.current.shouldReconnect && subscriber.optionsRef.current.shouldReconnect(event)) {
                var reconnectAttempts = (_a = subscriber.optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_LIMIT;
                if (subscriber.reconnectCount.current < reconnectAttempts) {
                    var nextReconnectInterval = typeof subscriber.optionsRef.current.reconnectInterval === "function" ? subscriber.optionsRef.current.reconnectInterval(subscriber.reconnectCount.current) : subscriber.optionsRef.current.reconnectInterval;
                    setTimeout(function() {
                        subscriber.reconnectCount.current++;
                        subscriber.reconnect.current();
                    }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $a5f48a6a0c42f032$exports.DEFAULT_RECONNECT_INTERVAL_MS);
                } else {
                    subscriber.optionsRef.current.onReconnectStop && subscriber.optionsRef.current.onReconnectStop(subscriber.optionsRef.current.reconnectAttempts);
                    console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
                }
            }
        });
    };
};
var $f265ce76e22ed38c$var$bindErrorHandler = function(webSocketInstance, url) {
    webSocketInstance.onerror = function(error) {
        (0, $083c0cd98a7da0b9$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onError) subscriber.optionsRef.current.onError(error);
            if ($a5f48a6a0c42f032$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
                subscriber.optionsRef.current.onClose && subscriber.optionsRef.current.onClose($f265ce76e22ed38c$var$__assign($f265ce76e22ed38c$var$__assign({}, error), {
                    code: 1006,
                    reason: "An error occurred with the EventSource: ".concat(error),
                    wasClean: false
                }));
                subscriber.setReadyState($a5f48a6a0c42f032$exports.ReadyState.CLOSED);
            }
        });
        if ($a5f48a6a0c42f032$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) webSocketInstance.close();
    };
};
var $f265ce76e22ed38c$var$attachSharedListeners = function(webSocketInstance, url, optionsRef, sendMessage) {
    var interval;
    if (optionsRef.current.fromSocketIO) interval = (0, $929aa7201d3888a5$exports.setUpSocketIOPing)(sendMessage);
    $f265ce76e22ed38c$var$bindMessageHandler(webSocketInstance, url);
    $f265ce76e22ed38c$var$bindCloseHandler(webSocketInstance, url);
    $f265ce76e22ed38c$var$bindOpenHandler(webSocketInstance, url);
    $f265ce76e22ed38c$var$bindErrorHandler(webSocketInstance, url);
    return function() {
        if (interval) clearInterval(interval);
    };
};
$f265ce76e22ed38c$exports.attachSharedListeners = $f265ce76e22ed38c$var$attachSharedListeners;



//TODO ensure that all onClose callbacks are called
var $5f4d99dc40d76d48$var$cleanSubscribers = function(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval) {
    return function() {
        (0, $083c0cd98a7da0b9$exports.removeSubscriber)(url, subscriber);
        if (!(0, $083c0cd98a7da0b9$exports.hasSubscribers)(url)) {
            try {
                var socketLike = $01b9f7375233e525$exports.sharedWebSockets[url];
                if (socketLike instanceof WebSocket) socketLike.onclose = function(event) {
                    if (optionsRef.current.onClose) optionsRef.current.onClose(event);
                    setReadyState($a5f48a6a0c42f032$exports.ReadyState.CLOSED);
                };
                socketLike.close();
            } catch (e) {}
            if (clearSocketIoPingInterval) clearSocketIoPingInterval();
            delete $01b9f7375233e525$exports.sharedWebSockets[url];
        }
    };
};
var $5f4d99dc40d76d48$var$createOrJoinSocket = function(webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount, sendMessage) {
    if (!$a5f48a6a0c42f032$exports.isEventSourceSupported && optionsRef.current.eventSourceOptions) {
        if ($a5f48a6a0c42f032$exports.isReactNative) throw new Error("EventSource is not supported in ReactNative");
        else throw new Error("EventSource is not supported");
    }
    if (optionsRef.current.share) {
        var clearSocketIoPingInterval = null;
        if ($01b9f7375233e525$exports.sharedWebSockets[url] === undefined) {
            $01b9f7375233e525$exports.sharedWebSockets[url] = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
            webSocketRef.current = $01b9f7375233e525$exports.sharedWebSockets[url];
            setReadyState($a5f48a6a0c42f032$exports.ReadyState.CONNECTING);
            clearSocketIoPingInterval = (0, $f265ce76e22ed38c$exports.attachSharedListeners)($01b9f7375233e525$exports.sharedWebSockets[url], url, optionsRef, sendMessage);
        } else {
            webSocketRef.current = $01b9f7375233e525$exports.sharedWebSockets[url];
            setReadyState($01b9f7375233e525$exports.sharedWebSockets[url].readyState);
        }
        var subscriber = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            reconnect: startRef
        };
        (0, $083c0cd98a7da0b9$exports.addSubscriber)(url, subscriber);
        return $5f4d99dc40d76d48$var$cleanSubscribers(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval);
    } else {
        webSocketRef.current = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
        setReadyState($a5f48a6a0c42f032$exports.ReadyState.CONNECTING);
        if (!webSocketRef.current) throw new Error("WebSocket failed to be created");
        return (0, $bc3c1c3d68dce265$exports.attachListeners)(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount, sendMessage);
    }
};
$5f4d99dc40d76d48$exports.createOrJoinSocket = $5f4d99dc40d76d48$var$createOrJoinSocket;


var $89ba8610be0957f5$exports = {};
"use strict";
var $89ba8610be0957f5$var$__awaiter = $89ba8610be0957f5$exports && $89ba8610be0957f5$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $89ba8610be0957f5$var$__generator = $89ba8610be0957f5$exports && $89ba8610be0957f5$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($89ba8610be0957f5$exports, "__esModule", {
    value: true
});
$89ba8610be0957f5$exports.getUrl = void 0;

var $89ba8610be0957f5$var$getUrl = function(url, optionsRef) {
    return $89ba8610be0957f5$var$__awaiter(void 0, void 0, void 0, function() {
        var convertedUrl, parsedUrl, parsedWithQueryParams;
        return $89ba8610be0957f5$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(typeof url === "function")) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        url()
                    ];
                case 1:
                    convertedUrl = _a.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    convertedUrl = url;
                    _a.label = 3;
                case 3:
                    parsedUrl = optionsRef.current.fromSocketIO ? (0, $929aa7201d3888a5$exports.parseSocketIOUrl)(convertedUrl) : convertedUrl;
                    parsedWithQueryParams = optionsRef.current.queryParams ? (0, $929aa7201d3888a5$exports.appendQueryParams)(parsedUrl, optionsRef.current.queryParams) : parsedUrl;
                    return [
                        2 /*return*/ ,
                        parsedWithQueryParams
                    ];
            }
        });
    });
};
$89ba8610be0957f5$exports.getUrl = $89ba8610be0957f5$var$getUrl;



var $5e2aa2d56abb87fa$var$proxy_1 = $5e2aa2d56abb87fa$var$__importDefault((parcelRequire("1z6jU")));

var $5e2aa2d56abb87fa$var$useWebSocket = function(url, options, connect) {
    if (options === void 0) options = $a5f48a6a0c42f032$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var _a = (0, $exYeM.useState)(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = (0, $exYeM.useState)({}), readyState = _b[0], setReadyState = _b[1];
    var lastJsonMessage = (0, $exYeM.useMemo)(function() {
        if (lastMessage) try {
            return JSON.parse(lastMessage.data);
        } catch (e) {
            return $a5f48a6a0c42f032$exports.UNPARSABLE_JSON_OBJECT;
        }
        return null;
    }, [
        lastMessage
    ]);
    var convertedUrl = (0, $exYeM.useRef)(null);
    var webSocketRef = (0, $exYeM.useRef)(null);
    var startRef = (0, $exYeM.useRef)(function() {
        return void 0;
    });
    var reconnectCount = (0, $exYeM.useRef)(0);
    var messageQueue = (0, $exYeM.useRef)([]);
    var webSocketProxy = (0, $exYeM.useRef)(null);
    var optionsCache = (0, $exYeM.useRef)(options);
    optionsCache.current = options;
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ? readyState[convertedUrl.current] : url !== null && connect === true ? $a5f48a6a0c42f032$exports.ReadyState.CONNECTING : $a5f48a6a0c42f032$exports.ReadyState.UNINSTANTIATED;
    var stringifiedQueryParams = options.queryParams ? JSON.stringify(options.queryParams) : null;
    var sendMessage = (0, $exYeM.useCallback)(function(message, keep) {
        var _a;
        if (keep === void 0) keep = true;
        if ($a5f48a6a0c42f032$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) {
            console.warn("Unable to send a message from an eventSource");
            return;
        }
        if (((_a = webSocketRef.current) === null || _a === void 0 ? void 0 : _a.readyState) === $a5f48a6a0c42f032$exports.ReadyState.OPEN) {
            (0, $a4c5937388a88d9b$exports.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketRef.current.send(message);
        } else if (keep) messageQueue.current.push(message);
    }, []);
    var sendJsonMessage = (0, $exYeM.useCallback)(function(message, keep) {
        if (keep === void 0) keep = true;
        sendMessage(JSON.stringify(message), keep);
    }, [
        sendMessage
    ]);
    var getWebSocket = (0, $exYeM.useCallback)(function() {
        if (optionsCache.current.share !== true || $a5f48a6a0c42f032$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) return webSocketRef.current;
        if (webSocketProxy.current === null && webSocketRef.current) {
            (0, $a4c5937388a88d9b$exports.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketProxy.current = (0, $5e2aa2d56abb87fa$var$proxy_1.default)(webSocketRef.current, startRef);
        }
        return webSocketProxy.current;
    }, []);
    (0, $exYeM.useEffect)(function() {
        if (url !== null && connect === true) {
            var removeListeners_1;
            var expectClose_1 = false;
            var createOrJoin_1 = true;
            var start_1 = function() {
                return $5e2aa2d56abb87fa$var$__awaiter(void 0, void 0, void 0, function() {
                    var _a, protectedSetLastMessage, protectedSetReadyState;
                    return $5e2aa2d56abb87fa$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _a = convertedUrl;
                                return [
                                    4 /*yield*/ ,
                                    (0, $89ba8610be0957f5$exports.getUrl)(url, optionsCache)
                                ];
                            case 1:
                                _a.current = _b.sent();
                                protectedSetLastMessage = function(message) {
                                    if (!expectClose_1) (0, $97dc602bd7e23afa$exports.flushSync)(function() {
                                        return setLastMessage(message);
                                    });
                                };
                                protectedSetReadyState = function(state) {
                                    if (!expectClose_1) (0, $97dc602bd7e23afa$exports.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            var _a;
                                            return $5e2aa2d56abb87fa$var$__assign($5e2aa2d56abb87fa$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = state, _a));
                                        });
                                    });
                                };
                                if (createOrJoin_1) removeListeners_1 = (0, $5f4d99dc40d76d48$exports.createOrJoinSocket)(webSocketRef, convertedUrl.current, protectedSetReadyState, optionsCache, protectedSetLastMessage, startRef, reconnectCount, sendMessage);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            startRef.current = function() {
                if (!expectClose_1) {
                    if (webSocketProxy.current) webSocketProxy.current = null;
                    removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                    start_1();
                }
            };
            start_1();
            return function() {
                expectClose_1 = true;
                createOrJoin_1 = false;
                if (webSocketProxy.current) webSocketProxy.current = null;
                removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                setLastMessage(null);
            };
        } else if (url === null || connect === false) {
            reconnectCount.current = 0; // reset reconnection attempts
            setReadyState(function(prev) {
                var _a;
                return $5e2aa2d56abb87fa$var$__assign($5e2aa2d56abb87fa$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = $a5f48a6a0c42f032$exports.ReadyState.CLOSED, _a));
            });
        }
    }, [
        url,
        connect,
        stringifiedQueryParams,
        sendMessage
    ]);
    (0, $exYeM.useEffect)(function() {
        if (readyStateFromUrl === $a5f48a6a0c42f032$exports.ReadyState.OPEN) messageQueue.current.splice(0).forEach(function(message) {
            sendMessage(message);
        });
    }, [
        readyStateFromUrl
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: lastMessage,
        lastJsonMessage: lastJsonMessage,
        readyState: readyStateFromUrl,
        getWebSocket: getWebSocket
    };
};
$5e2aa2d56abb87fa$exports.useWebSocket = $5e2aa2d56abb87fa$var$useWebSocket;


Object.defineProperty($b3551b1678837ab6$exports, "default", {
    enumerable: true,
    get: function() {
        return $5e2aa2d56abb87fa$exports.useWebSocket;
    }
});
var $92210c41ebd163c5$exports = {};
"use strict";
var $92210c41ebd163c5$var$__assign = $92210c41ebd163c5$exports && $92210c41ebd163c5$exports.__assign || function() {
    $92210c41ebd163c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $92210c41ebd163c5$var$__assign.apply(this, arguments);
};
Object.defineProperty($92210c41ebd163c5$exports, "__esModule", {
    value: true
});
$92210c41ebd163c5$exports.useSocketIO = void 0;

var $exYeM = parcelRequire("exYeM");


var $92210c41ebd163c5$var$emptyEvent = {
    type: "empty",
    payload: null
};
var $92210c41ebd163c5$var$getSocketData = function(event) {
    if (!event || !event.data) return $92210c41ebd163c5$var$emptyEvent;
    var match = event.data.match(/\[.*]/);
    if (!match) return $92210c41ebd163c5$var$emptyEvent;
    var data = JSON.parse(match);
    if (!Array.isArray(data) || !data[1]) return $92210c41ebd163c5$var$emptyEvent;
    return {
        type: data[0],
        payload: data[1]
    };
};
var $92210c41ebd163c5$var$useSocketIO = function(url, options, connect) {
    if (options === void 0) options = $a5f48a6a0c42f032$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var optionsWithSocketIO = (0, $exYeM.useMemo)(function() {
        return $92210c41ebd163c5$var$__assign($92210c41ebd163c5$var$__assign({}, options), {
            fromSocketIO: true
        });
    }, []);
    var _a = (0, $5e2aa2d56abb87fa$exports.useWebSocket)(url, optionsWithSocketIO, connect), sendMessage = _a.sendMessage, sendJsonMessage = _a.sendJsonMessage, lastMessage = _a.lastMessage, readyState = _a.readyState, getWebSocket = _a.getWebSocket;
    var socketIOLastMessage = (0, $exYeM.useMemo)(function() {
        return $92210c41ebd163c5$var$getSocketData(lastMessage);
    }, [
        lastMessage
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: socketIOLastMessage,
        lastJsonMessage: socketIOLastMessage,
        readyState: readyState,
        getWebSocket: getWebSocket
    };
};
$92210c41ebd163c5$exports.useSocketIO = $92210c41ebd163c5$var$useSocketIO;


Object.defineProperty($b3551b1678837ab6$exports, "useSocketIO", {
    enumerable: true,
    get: function() {
        return $92210c41ebd163c5$exports.useSocketIO;
    }
});

Object.defineProperty($b3551b1678837ab6$exports, "ReadyState", {
    enumerable: true,
    get: function() {
        return $a5f48a6a0c42f032$exports.ReadyState;
    }
});
var $d3564bc2c8c6e390$exports = {};
"use strict";
var $d3564bc2c8c6e390$var$__assign = $d3564bc2c8c6e390$exports && $d3564bc2c8c6e390$exports.__assign || function() {
    $d3564bc2c8c6e390$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d3564bc2c8c6e390$var$__assign.apply(this, arguments);
};
var $d3564bc2c8c6e390$var$__rest = $d3564bc2c8c6e390$exports && $d3564bc2c8c6e390$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($d3564bc2c8c6e390$exports, "__esModule", {
    value: true
});
$d3564bc2c8c6e390$exports.useEventSource = void 0;

var $exYeM = parcelRequire("exYeM");


var $d3564bc2c8c6e390$var$useEventSource = function(url, _a, connect) {
    if (_a === void 0) _a = $a5f48a6a0c42f032$exports.DEFAULT_EVENT_SOURCE_OPTIONS;
    var withCredentials = _a.withCredentials, events = _a.events, options = $d3564bc2c8c6e390$var$__rest(_a, [
        "withCredentials",
        "events"
    ]);
    if (connect === void 0) connect = true;
    var optionsWithEventSource = $d3564bc2c8c6e390$var$__assign($d3564bc2c8c6e390$var$__assign({}, options), {
        eventSourceOptions: {
            withCredentials: withCredentials
        }
    });
    var eventsRef = (0, $exYeM.useRef)($a5f48a6a0c42f032$exports.EMPTY_EVENT_HANDLERS);
    if (events) eventsRef.current = events;
    var _b = (0, $5e2aa2d56abb87fa$exports.useWebSocket)(url, optionsWithEventSource, connect), lastMessage = _b.lastMessage, readyState = _b.readyState, getWebSocket = _b.getWebSocket;
    (0, $exYeM.useEffect)(function() {
        if (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) Object.entries(eventsRef.current).forEach(function(_a) {
            var type = _a[0], handler = _a[1];
            if (type === lastMessage.type) handler(lastMessage);
        });
    }, [
        lastMessage
    ]);
    return {
        lastEvent: lastMessage,
        readyState: readyState,
        getEventSource: getWebSocket
    };
};
$d3564bc2c8c6e390$exports.useEventSource = $d3564bc2c8c6e390$var$useEventSource;


Object.defineProperty($b3551b1678837ab6$exports, "useEventSource", {
    enumerable: true,
    get: function() {
        return $d3564bc2c8c6e390$exports.useEventSource;
    }
});

Object.defineProperty($b3551b1678837ab6$exports, "resetGlobalState", {
    enumerable: true,
    get: function() {
        return $a4c5937388a88d9b$exports.resetGlobalState;
    }
});




var $b4421d6b03122e6b$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["AnswerQuestion"] = "answer-question";
    MessageType["Authenticate"] = "authenticate";
    MessageType["Authenticated"] = "authenticated";
    MessageType["GameStateUpdate"] = "game-state-update";
    MessageType["Pong"] = "pong";
    MessageType["Ready"] = "ready";
    MessageType["Spectate"] = "spectate";
    MessageType["UserDisconnected"] = "user-disconnected";
})($b4421d6b03122e6b$export$80edbf15fa61a4db || ($b4421d6b03122e6b$export$80edbf15fa61a4db = {}));
function $b4421d6b03122e6b$export$62651879628e0c4c(type, data) {
    return {
        type: type,
        time: Date.now(),
        data: data
    };
}


var $135b2b0db2d21fa4$export$df7cd2a2d7088cfa;
(function(GameStates) {
    GameStates["Lobby"] = "lobby";
    GameStates["PreGame"] = "preGame";
    GameStates["InRound"] = "inRound";
    GameStates["PostRound"] = "postRound";
    GameStates["PostGame"] = "postGame";
})($135b2b0db2d21fa4$export$df7cd2a2d7088cfa || ($135b2b0db2d21fa4$export$df7cd2a2d7088cfa = {}));




function $0c1c12d856ffd7b8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $0c1c12d856ffd7b8$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $0c1c12d856ffd7b8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $0c1c12d856ffd7b8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $0c1c12d856ffd7b8$export$2e2bcd8739ae039 = $0c1c12d856ffd7b8$export$4f5d2d50c9deca37;


const $d62f00ef7ccd989c$export$9594e561b978802d = ({ answer: answer , correctAnswer: correctAnswer , isSelected: isSelected , onAnswerClick: onAnswerClick  })=>{
    const isCorrect = correctAnswer === answer;
    const isDefaultState = !isSelected && !isCorrect;
    let textSize = "text-4xl 2xl:text-5xl";
    if (answer.length > 15) textSize = "text-3xl 2xl:text-4xl";
    if (answer.length > 30) textSize = "text-2xl 2xl:text-3xl";
    if (answer.length > 60) textSize = "text-md 2xl:text-3xl";
    if (answer.length > 120) textSize = "text-sm 2xl:text-2xl";
    if (answer.length > 150) textSize = "text-xs 2xl:text-xl";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("flex items-center justify-center relative rounded-lg w-[35vw] h-[8vw] px-16 cursor-pointer shadow-xl", isDefaultState && "bg-white text-black", isCorrect && "bg-green-600 text-white", isSelected && {
            ["ring-8 ring-indigo-900 bg-indigo-600 text-white"]: correctAnswer == null,
            ["ring-8 ring-green-900"]: isCorrect,
            ["ring-8 ring-red-900 bg-red-600 text-white"]: !isCorrect && correctAnswer != null
        }),
        onClick: ()=>onAnswerClick(answer),
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            className: `font-bold ${textSize} text-center leading-snug`,
            children: answer
        })
    });
};




var $bd8fdadd7ac50559$export$8678b1e0957c59be;
(function(QuestionCategory) {
    QuestionCategory["music"] = "Music";
    QuestionCategory["sport_and_leisure"] = "Sport & Leisure";
    QuestionCategory["film_and_tv"] = "Film & TV";
    QuestionCategory["arts_and_literature"] = "Arts & Literature";
    QuestionCategory["history"] = "History";
    QuestionCategory["society_and_culture"] = "Society & Culture";
    QuestionCategory["science"] = "Science";
    QuestionCategory["geography"] = "Geography";
    QuestionCategory["food_and_drink"] = "Food & Drink";
    QuestionCategory["general_knowledge"] = "General Knowledge";
})($bd8fdadd7ac50559$export$8678b1e0957c59be || ($bd8fdadd7ac50559$export$8678b1e0957c59be = {}));


const $ebe428b00cfdc478$export$854f2d8ee9e27c5b = ({ question: question  })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("flex items-center justify-center bg-white relative rounded-lg ring-4 ring-black text-black mx-8 shadow-xl", "h-[40vh]", "lg:w-[50vw] lg:px-8 lg:aspect-video lg:h-[unset]" // lg overrides
        ),
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                className: "font-medium absolute top-4 right-8 text-base xl:text-xl 2xl:text-4xl",
                children: (0, $bd8fdadd7ac50559$export$8678b1e0957c59be)[question.category] ?? "Unknown Category"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("font-bold text-black text-center leading-normal text-xl", "lg:text-3xl xl:!leading-tight 2xl:text-5xl"),
                children: question.question.text
            })
        ]
    });
};


const $1ee8f04627fdbc93$export$3661cca1198d968f = ({ user: user , question: question , onAnswerClick: onAnswerClick  })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            className: "flex flex-col items-center justify-between h-screen flex-grow pt-32 lg:py-8",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $ebe428b00cfdc478$export$854f2d8ee9e27c5b), {
                    question: question
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "grid grid-cols-2 grid-rows-2 gap-x-28 gap-y-4",
                        children: question.answers.map((answer)=>{
                            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d62f00ef7ccd989c$export$9594e561b978802d), {
                                answer: answer,
                                onAnswerClick: onAnswerClick,
                                isSelected: user.selectedAnswer === answer,
                                correctAnswer: question.correctAnswer
                            }, answer);
                        })
                    })
                })
            ]
        })
    });
};






const $fdc89476723a3133$export$b389245be866a105 = (ping)=>{
    if (ping < 100) return "bg-green-500";
    else if (ping < 200) return "bg-yellow-500";
    else return "bg-red-500";
};


const $a25e96737178e854$export$3d3ebd75456d5e4c = ({ user: user , subtitle: subtitle  })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                className: "relative inline-block",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        className: "inline-block h-10 w-10 rounded-full",
                        src: user.avatarSrc,
                        alt: user.display_name
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("absolute bottom-0 right-0 block h-3 w-3 rounded-full ring-2 ring-white", (0, $fdc89476723a3133$export$b389245be866a105)(user.ping))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "ml-3 flex flex-col justify-start",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: "text-sm font-medium text-black text-ellipsis leading-tight",
                        children: user.display_name
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: "text-sm font-medium text-black leading-tight",
                        children: subtitle
                    })
                ]
            })
        ]
    });
};



const $0406a0c3316dc668$export$c57e9b2d8b9e4de = ({ timeLeft: timeLeft  })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "flex items-center justify-center ring-8 ring-black w-40 h-40 rounded-full",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            className: "font-bold font-brand text-8xl text-center",
            children: timeLeft
        })
    });
};


var $c0914c99866da038$exports = {};


$c0914c99866da038$exports = (parcelRequire("aNJCr")).getBundleURL("cD01m") + (parcelRequire("iE7OH")).resolve("5qat4");


const $9b8d645c3c6b66c0$export$b7c0cf9ca43db97b = ({ user: user , gameState: gameState  })=>{
    const userSubtitle = gameState.state !== (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).Lobby ? `${user.score} points` : undefined;
    const logoUrl = new URL($c0914c99866da038$exports).href;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            user && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "absolute top-4 left-6",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a25e96737178e854$export$3d3ebd75456d5e4c), {
                    user: user,
                    subtitle: user.isSpectator ? "spectating" : userSubtitle
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "absolute top-0 right-6",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                    src: logoUrl,
                    alt: "logo",
                    className: "h-24"
                })
            }),
            gameState.approxTimeLeft && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "absolute top-24 right-16",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $0406a0c3316dc668$export$c57e9b2d8b9e4de), {
                    timeLeft: gameState.approxTimeLeft
                })
            })
        ]
    });
};





const $d9c5bacd3905d622$export$4b7aa3c9ee65a20b = ({ isSelected: isSelected , children: children , onClick: onClick  })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
        onClick: onClick,
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("text-5xl font-black font-brand py-8 px-16 rounded-lg shadow-xl transition-all duration-200 cursor-pointer xl:w-[35vw] 2xl:w-[20vw]", isSelected && "bg-green-600 ring-green-900 ring-4 text-white hover:bg-green-700", !isSelected && "hover:bg-gray-200 bg-white"),
        children: children
    });
};





const $a62e9d0026cb655d$export$7f95c5f0cae0dc0a = ({ className: className = "" , user: user , showPoints: showPoints = false  })=>{
    const subtitleText = user.isSpectator ? "Spectating" : user.isReady ? "Ready!" : "Not Ready";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("flex flex-col items-center text-center w-36", className),
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        className: "inline-block h-24 w-24 rounded-full",
                        src: user.avatarSrc,
                        alt: user.display_name
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("absolute bottom-0 right-0 block h-6 w-6 rounded-full ring-4 ring-white", (0, $fdc89476723a3133$export$b389245be866a105)(user.ping))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                className: "text-lg font-bold text-black text-ellipsis leading-tight mt-2",
                children: user.display_name
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                className: "text-2xl font-black font-brand text-black leading-tight mt-0",
                children: showPoints ? `${user.score} points` : subtitleText
            })
        ]
    });
};


const $a5f04e5b58f1456b$export$93c82f7914a36eae = ({ users: users , user: user , onReadyClick: onReadyClick , onSpectateClick: onSpectateClick , isPostGame: isPostGame = false  })=>{
    const displayUsers = users.sort((a, b)=>b.score - a.score);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "flex w-full h-screen items-center justify-center",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            className: "flex flex-col self-center items-center justify-between 2xl:w-[50vw] w-[75vw]",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "flex flex-row justify-center w-full bg-white rounded-xl shadow-xl py-4",
                    children: displayUsers.map((user)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a62e9d0026cb655d$export$7f95c5f0cae0dc0a), {
                            user: user,
                            showPoints: isPostGame,
                            className: "mx-2"
                        }, user.id))
                }),
                !isPostGame && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "flex flex-row justify-between w-full mt-8",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d9c5bacd3905d622$export$4b7aa3c9ee65a20b), {
                            isSelected: user.isReady,
                            onClick: onReadyClick,
                            children: user.isReady ? "Ready!" : "Ready Up!"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d9c5bacd3905d622$export$4b7aa3c9ee65a20b), {
                            isSelected: user.isSpectator,
                            onClick: onSpectateClick,
                            children: "Spectate!"
                        })
                    ]
                })
            ]
        })
    });
};


const $fed53e16d1d53efb$var$getWebsocketUrl = ()=>{
    const url = new URL(location.href);
    if (url.hostname === "localhost") return `ws://localhost:8788/api/game`;
    return `wss://${url.hostname}/api/game`;
};
const $fed53e16d1d53efb$var$getInstanceId = ()=>{
    const url = new URL(location.href);
    const override = url.searchParams.get("instanceId");
    return override ?? (0, $b5aff70181e0917f$export$127230c0dc597d18).instanceId;
};
const $fed53e16d1d53efb$var$Game = ()=>{
    const [userId, setUserId] = (0, $exYeM.useState)(null);
    const [gameState, setGameState] = (0, $exYeM.useState)(null);
    const { channelId: channelId , guildId: guildId  } = (0, $b5aff70181e0917f$export$127230c0dc597d18);
    const { access_token: access_token  } = (0, $d40087df9a05b3da$export$9dfbf593388d3738)();
    const wsUrl = `${$fed53e16d1d53efb$var$getWebsocketUrl()}/${$fed53e16d1d53efb$var$getInstanceId()}`;
    const { sendJsonMessage: sendMessage , lastJsonMessage: wsMessage , readyState: readyState  } = (0, (/*@__PURE__*/$parcel$interopDefault($b3551b1678837ab6$exports)))(wsUrl, {
        onClose () {
            setUserId(null);
        },
        onError (event) {
            console.error(event);
        },
        shouldReconnect: ()=>true,
        reconnectAttempts: 10,
        reconnectInterval: (attemptNumber)=>// exponential reconnect backoff: 1, 2, 4, 8, 10. Max of 10 seconds between retries.
            Math.min(Math.pow(2, attemptNumber) * 1000, 10000)
    });
    const handleSpeakingStart = (0, $exYeM.useCallback)(({ user_id: user_id  })=>{
        console.log(`${user_id} is speaking!`);
    }, []);
    const handleSpeakingStop = (0, $exYeM.useCallback)(({ user_id: user_id  })=>{
        console.log(`${user_id} stopped speaking!`);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        (0, $b5aff70181e0917f$export$127230c0dc597d18).subscribe((0, $508a5edf05a9a175$exports.Events).SPEAKING_STOP, handleSpeakingStop, {
            channel_id: channelId
        });
        (0, $b5aff70181e0917f$export$127230c0dc597d18).subscribe((0, $508a5edf05a9a175$exports.Events).SPEAKING_START, handleSpeakingStart, {
            channel_id: channelId
        });
        return ()=>{
            (0, $b5aff70181e0917f$export$127230c0dc597d18).unsubscribe((0, $508a5edf05a9a175$exports.Events).SPEAKING_STOP, handleSpeakingStop);
            (0, $b5aff70181e0917f$export$127230c0dc597d18).unsubscribe((0, $508a5edf05a9a175$exports.Events).SPEAKING_START, handleSpeakingStart);
        };
    }, [
        (0, $b5aff70181e0917f$export$127230c0dc597d18).subscribe,
        (0, $b5aff70181e0917f$export$127230c0dc597d18).unsubscribe,
        handleSpeakingStart,
        handleSpeakingStop
    ]);
    const handleGameStateUpdate = (message)=>{
        const msg = (0, $b4421d6b03122e6b$export$62651879628e0c4c)((0, $b4421d6b03122e6b$export$80edbf15fa61a4db).Pong);
        sendMessage(msg);
        setGameState(message.data);
    };
    const handleMessage = (0, $exYeM.useCallback)((message)=>{
        switch(message.type){
            case (0, $b4421d6b03122e6b$export$80edbf15fa61a4db).Authenticated:
                console.log(`authenticated as ${message.data.user.id}`);
                setUserId(message.data.user.id);
                break;
            case (0, $b4421d6b03122e6b$export$80edbf15fa61a4db).GameStateUpdate:
                handleGameStateUpdate(message);
                break;
            default:
                console.log("unhandled message", message);
        }
    }, []);
    (0, $exYeM.useEffect)(()=>{
        if (wsMessage == null) return;
        let messages = wsMessage;
        if (!Array.isArray(wsMessage)) messages = [
            wsMessage
        ];
        messages.forEach(handleMessage);
    }, [
        wsMessage,
        handleMessage
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (readyState !== (0, $b3551b1678837ab6$exports.ReadyState).OPEN || userId != null) return;
        const msg = (0, $b4421d6b03122e6b$export$62651879628e0c4c)((0, $b4421d6b03122e6b$export$80edbf15fa61a4db).Authenticate, {
            access_token: access_token,
            channelId: channelId,
            guildId: guildId
        });
        sendMessage(msg);
    }, [
        readyState,
        userId
    ]);
    if (gameState == null) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: "Loading..."
    });
    const user = gameState.users.find((u)=>u.id === userId);
    if (user == null) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: "Loading..."
    });
    if (gameState.state === (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).Lobby || gameState.state === (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).PreGame || gameState.state === (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).PostGame) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b8d645c3c6b66c0$export$b7c0cf9ca43db97b), {
                gameState: gameState,
                user: user
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a5f04e5b58f1456b$export$93c82f7914a36eae), {
                users: gameState.users,
                user: user,
                onReadyClick: ()=>{
                    sendMessage((0, $b4421d6b03122e6b$export$62651879628e0c4c)((0, $b4421d6b03122e6b$export$80edbf15fa61a4db).Ready));
                },
                onSpectateClick: ()=>{
                    sendMessage((0, $b4421d6b03122e6b$export$62651879628e0c4c)((0, $b4421d6b03122e6b$export$80edbf15fa61a4db).Spectate));
                },
                isPostGame: gameState.state === (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).PostGame
            })
        ]
    });
    if (gameState.state === (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).InRound || gameState.state === (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).PostRound) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b8d645c3c6b66c0$export$b7c0cf9ca43db97b), {
                gameState: gameState,
                user: user
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $1ee8f04627fdbc93$export$3661cca1198d968f), {
                user: user,
                question: gameState.questionData,
                onAnswerClick: (answer)=>{
                    if (gameState.state !== (0, $135b2b0db2d21fa4$export$df7cd2a2d7088cfa).InRound || user.isSpectator || answer === user.selectedAnswer) return;
                    sendMessage((0, $b4421d6b03122e6b$export$62651879628e0c4c)((0, $b4421d6b03122e6b$export$80edbf15fa61a4db).AnswerQuestion, {
                        answer: answer
                    }));
                }
            })
        ]
    });
};
var $fed53e16d1d53efb$export$2e2bcd8739ae039 = $fed53e16d1d53efb$var$Game;


function $26c28601dd21ca71$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("main", {
        className: "min-h-screen min-w-screen bg-gradient-to-br from-[#9796F0] to-[#FBC7D4]",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fed53e16d1d53efb$export$2e2bcd8739ae039), {})
    });
}


const $7d0d880cf2ba634e$var$container = document.getElementById("app");
const $7d0d880cf2ba634e$var$root = $7d0d880cf2ba634e$var$container && (0, $7bd215913159ea08$export$882461b6382ed46c)($7d0d880cf2ba634e$var$container);
$7d0d880cf2ba634e$var$root?.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $exYeM.StrictMode), {
    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d40087df9a05b3da$export$1aec681d4d8de28d), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $26c28601dd21ca71$export$86fbec116b87613f), {})
    })
}));

})();
//# sourceMappingURL=index.492c14e5.js.map
